// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ids Data Grid Component - Filter */
.ids-data-grid {
  --ids-button-formatter-color-text-default: var(--ids-data-grid-filter-icon-color);
  --ids-button-formatter-color-background-hover: var(--ids-data-grid-filter-icon-color-background-hover);
  --ids-button-formatter-color-text-hover: var(--ids-data-grid-filter-icon-color-hover);
  --ids-menu-item-width-min: 190px;
  --ids-trigger-field-button-inset-inline-start: 0;
}
.ids-data-grid .ids-data-grid-header-cell-filter-wrapper ids-dropdown {
  --ids-trigger-field-button-inset-inline-start: -1px;
  padding-top: 3px;
}
.ids-data-grid[data-row-height=md] ids-dropdown, .ids-data-grid[data-row-height=sm] ids-dropdown, .ids-data-grid[data-row-height=xs] ids-dropdown, .ids-data-grid[data-row-height=xxs] ids-dropdown {
  padding-top: 0;
}
.ids-data-grid ::slotted([slot^=filter-]) {
  align-items: center;
  display: flex;
  position: relative;
}
.ids-data-grid .ids-data-grid-header-cell-content.vertical-align-center {
  position: relative;
  top: calc(50% - var(--ids-space-sm));
}
.ids-data-grid .ids-data-grid-header-cell-filter-wrapper {
  align-items: center;
  display: flex;
  position: relative;
  padding-inline-start: var(--ids-space-xs);
  padding-inline-end: var(--ids-space-xs);
  padding-block-end: var(--ids-space-xs);
}
.ids-data-grid .ids-data-grid-header-cell-filter-wrapper.hidden {
  display: none;
}
.ids-data-grid .ids-data-grid-header-cell-filter-wrapper ids-dropdown[compact] ids-list-box-option {
  font-size: unset;
  min-height: var(--ids-size-20);
}
.ids-data-grid .ids-data-grid-header-cell.is-uppercase .ids-data-grid-header-cell-filter-wrapper ids-list-box-option,
.ids-data-grid .ids-data-grid-header-cell.is-uppercase .ids-data-grid-header-cell-filter-wrapper ids-dropdown::part(triggerfield-input),
.ids-data-grid .ids-data-grid-header-cell.is-uppercase .ids-data-grid-header-cell-filter-wrapper ids-input::part(input) {
  text-transform: uppercase;
}
.ids-data-grid [data-filter-conditions-button] {
  --ids-button-icon-compact-height: 20px;
  --ids-button-icon-compact-width: 36px;
  margin-inline-end: 2px;
  margin-inline-start: 0;
}
.ids-data-grid [data-filter-conditions-button] ids-icon {
  margin-inline-start: 3px;
  margin-inline-end: -3px;
}
.ids-data-grid [data-filter-conditions-button] ids-icon-button {
  padding-inline-start: 0;
}

/* Ids Data Grid Component - Header */
.ids-data-grid-header {
  position: sticky;
  top: var(--ids-space-none);
  z-index: 1;
  --ids-button-formatter-size: 28px;
}
.ids-data-grid-header.is-frozen {
  z-index: 2;
}

.ids-data-grid-header-text .ids-data-grid-checkbox-container {
  width: 20px;
}
.ids-data-grid-header-text .ids-data-grid-checkbox-container[disabled=true] {
  cursor: default;
}
.ids-data-grid-header-text .ids-data-grid-checkbox-container .ids-data-grid-checkbox[disabled=true] {
  pointer-events: none;
  opacity: var(--ids-data-grid-header-checkbox-opacity-disabled);
}
.ids-data-grid-header-text .ids-data-grid-checkbox-container .ids-data-grid-checkbox:not(.checked):not(.indeterminate) {
  background-color: var(--ids-data-grid-header-checkbox-color-background);
  border-color: var(--ids-data-grid-header-checkbox-color-border);
}

.ids-data-grid-header-cell {
  border-inline-start: 1px solid var(--ids-data-grid-header-color-border);
  border-block-end: 1px solid var(--ids-data-grid-header-color-border);
  background-color: var(--ids-data-grid-header-color-background-default);
  min-height: 28px;
  position: relative;
}
.ids-data-grid-header-cell:first-child {
  border-inline-start-width: var(--ids-border-width-none);
}
.ids-data-grid-header-cell:hover.is-actionable {
  background-color: var(--ids-data-grid-header-color-background-hover);
}
.ids-data-grid-header-cell.align-center .ids-data-grid-header-cell-content, .ids-data-grid-header-cell.align-center .ids-data-grid-header-cell-filter-wrapper {
  justify-content: center;
}
.ids-data-grid-header-cell.align-right .ids-data-grid-header-cell-content, .ids-data-grid-header-cell.align-right .ids-data-grid-header-cell-filter-wrapper {
  justify-content: flex-end;
}
.ids-data-grid-header-cell.align-right .is-sortable .ids-data-grid-header-text {
  padding-inline-end: var(--ids-data-grid-padding-lg);
  padding-inline-start: 5px;
}
.ids-data-grid-header-cell.align-right .ids-data-grid-header-cell-filter-wrapper ids-menu-button {
  margin-inline-start: var(--ids-space-3xs);
}
.ids-data-grid-header-cell .resizer {
  cursor: var(--ids-cursor-resize);
  display: inline;
  height: 100%;
  position: absolute;
  margin-inline-start: calc(100% - 4px);
  top: var(--ids-space-none);
  width: 6px;
  z-index: 2;
}
.ids-data-grid-header-cell .reorderer {
  cursor: var(--ids-cursor-move);
  display: inline;
  height: 34px;
  opacity: 0;
  position: absolute;
  inset-inline-start: var(--ids-space-xs);
  top: var(--ids-space-none);
  width: var(--ids-space-2xs);
}
.ids-data-grid-header-cell .reorderer ids-icon {
  position: absolute;
  color: var(--ids-data-grid-header-color-icon);
  inset-inline-start: calc(-1 * var(--ids-space-xs));
  text-align: center;
  top: calc(50% - 9px);
}
.ids-data-grid-header-cell.align-right .reorderer {
  inset-inline-end: 5px;
  inset-inline-start: initial;
}
.ids-data-grid-header-cell:last-child .resizer {
  margin-inline-start: calc(100% - 6px);
}
.ids-data-grid-header-cell.dragging {
  background-color: var(--ids-data-grid-header-drag-background-color) !important;
  border-inline-start: var(--ids-space-none);
  display: block;
  left: -1000px;
  position: absolute;
  top: var(--ids-space-none);
  width: 110px;
}
.ids-data-grid-header-cell.active-drag-column {
  background-color: var(--ids-data-grid-header-color-background-default-placeholder-dragging);
}
.ids-data-grid-header-cell.active-drag-column .sort-indicator {
  opacity: 0;
}
.ids-data-grid-header-cell:hover .reorderer {
  opacity: 1;
}
.ids-data-grid-header-cell.frozen {
  background-color: var(--ids-data-grid-header-color-background-default);
  position: sticky;
  z-index: 3;
}
.ids-data-grid-header-cell.frozen-last {
  border-inline-end: 1px solid var(--ids-data-grid-header-color-border);
}
.ids-data-grid-header-cell.frozen-last + .ids-data-grid-header-cell {
  border-inline-start-width: var(--ids-border-width-none);
}
.ids-data-grid-header-cell.frozen-left {
  position: sticky;
  left: var(--ids-space-none);
  z-index: 2;
}
.ids-data-grid-header-cell.frozen-left:nth-of-type(2) {
  left: var(--ids-data-grid-frozen-column-left-width-2);
}
.ids-data-grid-header-cell.frozen-left:nth-of-type(3) {
  left: var(--ids-data-grid-frozen-column-left-width-3);
}
.ids-data-grid-header-cell.frozen-left:nth-of-type(4) {
  left: var(--ids-data-grid-frozen-column-left-width-4);
}
.ids-data-grid-header-cell.frozen-left:nth-of-type(5) {
  left: var(--ids-data-grid-frozen-column-left-width-5);
}
.ids-data-grid-header-cell.frozen-left:nth-of-type(6) {
  left: var(--ids-data-grid-frozen-column-left-width-6);
}
.ids-data-grid-header-cell.frozen-left:nth-of-type(7) {
  left: var(--ids-data-grid-frozen-column-left-width-7);
}
.ids-data-grid-header-cell.frozen-left:nth-of-type(8) {
  left: var(--ids-data-grid-frozen-column-left-width-8);
}
.ids-data-grid-header-cell.frozen-left:nth-of-type(9) {
  left: var(--ids-data-grid-frozen-column-left-width-9);
}
.ids-data-grid-header-cell.frozen-left:nth-of-type(10) {
  left: var(--ids-data-grid-frozen-column-left-width-10);
}
.ids-data-grid-header-cell.frozen-right {
  position: sticky;
  right: var(--ids-space-none);
}
.ids-data-grid-header-cell.frozen-right .ids-data-grid-header-cell-content {
  display: inline-flex;
}

.ids-data-grid-header-cell-content {
  display: flex;
}

.ids-data-grid-header-text {
  display: block;
  padding: var(--ids-data-grid-header-lg-padding);
  font-weight: var(--ids-font-weight-semibold);
  font-size: var(--ids-data-grid-font-size-sm);
  color: var(--ids-data-grid-header-color-text);
  overflow: hidden;
  text-align: left;
  text-overflow: ellipsis;
  user-select: none;
  white-space: nowrap;
}
.ids-data-grid-header-text small {
  font-weight: var(--ids-font-weight-normal);
  font-size: var(--ids-data-grid-font-size-sm);
}

.ids-data-grid-header-icon {
  align-self: center;
  color: var(--ids-data-grid-header-color-text);
  margin-inline-start: var(--ids-space-2xs);
  margin-block-start: var(--ids-space-2xs);
}

.sort-indicator {
  display: flex;
  flex-direction: column;
  gap: 4px;
  position: relative;
  overflow: hidden;
  height: var(--ids-space-lg);
  margin-inline-start: auto;
  margin-inline-end: 5px;
  width: 18px;
}

.is-sortable .sort-indicator ids-icon {
  color: var(--ids-data-grid-header-color-icon-unsorted);
  opacity: 0;
  transition: opacity 0.3s var(--ids-motion-ease) 0s;
}
.is-sortable .sort-indicator ids-icon:first-child {
  position: relative;
  top: var(--ids-space-2xs);
  transform: rotate(180deg);
}
.is-sortable .sort-indicator ids-icon:last-child {
  position: relative;
  top: -10px;
}
.is-sortable:hover {
  cursor: pointer;
}
.is-sortable:hover .sort-indicator ids-icon {
  opacity: 1;
}

.header-expander {
  display: none;
  max-height: 18px;
  cursor: var(--ids-cursor-pointer);
  color: var(--ids-data-grid-header-expander-color);
  margin-inline-start: var(--ids-space-12);
}
.header-expander:hover {
  color: var(--ids-data-grid-header-expander-color-active);
}

[data-row-height=xxs] .header-expander {
  top: var(--ids-space-3xs);
}

:host([show-header-expander]) .header-expander,
.column-header-expander .header-expander {
  display: unset;
}

.has-selectioncheckbox .ids-data-grid-header-text {
  padding-inline-start: var(--ids-space-none);
  padding-inline-end: var(--ids-space-none);
}

.is-sortable .ids-data-grid-header-text,
.has-headericon .ids-data-grid-header-text {
  padding-inline-end: var(--ids-space-none);
}

[aria-sort=ascending] .is-sortable .sort-indicator ids-icon:first-child {
  color: var(--ids-data-grid-header-color-icon-sorted);
  opacity: 1;
}
[aria-sort=ascending] .is-sortable .sort-indicator ids-icon:last-child {
  opacity: 1;
}

[aria-sort=descending] .is-sortable .sort-indicator ids-icon:first-child {
  opacity: 1;
}
[aria-sort=descending] .is-sortable .sort-indicator ids-icon:last-child {
  color: var(--ids-data-grid-header-color-icon-sorted);
  opacity: 1;
}

.ids-data-grid-sort-arrows {
  display: none;
  height: 34px;
  position: absolute;
  z-index: 1;
}
.ids-data-grid-sort-arrows::before, .ids-data-grid-sort-arrows::after {
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  content: "";
  display: inline-block;
  height: 0;
  left: -5px;
  position: absolute;
  width: 0;
}
.ids-data-grid-sort-arrows::before {
  border-top: 5px solid var(--ids-data-grid-header-drag-arrow-color-background);
  top: -6px;
}
.ids-data-grid-sort-arrows::after {
  border-bottom: 5px solid var(--ids-data-grid-header-drag-arrow-color-background);
  bottom: -9px;
}

tr.ids-data-grid-header {
  position: initial;
}

th.ids-data-grid-header-cell {
  display: table-cell;
}

.ids-data-grid.is-list-style .ids-data-grid-header-cell {
  background-color: var(--ids-data-grid-list-header-color-background);
  border-color: var(--ids-data-grid-list-header-color-border);
}
.ids-data-grid.is-list-style .ids-data-grid-header-text {
  color: var(--ids-data-grid-list-header-color-text);
}
.ids-data-grid.is-list-style .is-sortable ids-icon {
  color: var(--ids-data-grid-header-color-icon-unsorted);
}
.ids-data-grid.is-list-style [aria-sort=descending] .is-sortable ids-icon:last-child,
.ids-data-grid.is-list-style [aria-sort=ascending] .is-sortable ids-icon:first-child {
  color: var(--ids-data-grid-list-header-color-icon-unsorted);
}
.ids-data-grid.is-list-style .ids-data-grid-header-text .ids-data-grid-checkbox-container .ids-data-grid-checkbox:not(.checked):not(.indeterminate) {
  border-color: var(--ids-data-grid-list-header-checkbox-color-background);
}

.ids-data-grid-body {
  min-width: fit-content;
}

.ids-data-grid[data-row-height=md] .ids-data-grid-header-text {
  padding: var(--ids-data-grid-header-md-padding);
}
.ids-data-grid[data-row-height=md] .reorderer ids-icon {
  inset-inline-start: -11px;
}
.ids-data-grid[data-row-height=md] .sort-indicator {
  margin-inline-start: -8px;
}
.ids-data-grid[data-row-height=md] .ids-data-grid-header-cell.align-right .reorderer {
  inset-inline-end: 3px;
}
.ids-data-grid[data-row-height=sm] .ids-data-grid-header-text {
  padding: var(--ids-data-grid-header-sm-padding);
}
.ids-data-grid[data-row-height=sm] .reorderer {
  display: none;
}
.ids-data-grid[data-row-height=sm] .sort-indicator {
  margin-inline-start: -4px;
}
.ids-data-grid[data-row-height=xs] .ids-data-grid-header-text {
  padding: var(--ids-data-grid-header-xs-padding);
}
.ids-data-grid[data-row-height=xs] .reorderer {
  display: none;
}
.ids-data-grid[data-row-height=xs] .sort-indicator {
  margin-inline-start: -2px;
  margin-inline-end: -2px;
  margin-block-start: -3px;
}
.ids-data-grid[data-row-height=xs] .ids-data-grid-checkbox-container {
  padding-top: var(--ids-space-3xs);
}
.ids-data-grid[data-row-height=xs] .ids-data-grid-header-cell.align-right .is-sortable .ids-data-grid-header-text {
  padding-inline-end: var(--ids-data-grid-padding-xs);
  padding-inline-start: 5px;
}
.ids-data-grid[data-row-height=xxs] .ids-data-grid-header-text {
  padding: var(--ids-data-grid-header-xxs-padding);
}
.ids-data-grid[data-row-height=xxs] .reorderer {
  display: none;
}
.ids-data-grid[data-row-height=xxs] .sort-indicator {
  margin-inline-start: var(--ids-space-none);
  margin-block-start: -1px;
  height: 22px;
}
.ids-data-grid[data-row-height=xxs] .sort-indicator > ids-icon:first-child {
  top: 3px;
}
.ids-data-grid[data-row-height=xxs] .sort-indicator ids-icon:last-child {
  top: -11px;
}
.ids-data-grid[data-row-height=xxs] .align-right .sort-indicator {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=xxs] .ids-data-grid-header-text .ids-data-grid-checkbox-container {
  padding-top: 3px;
}
.ids-data-grid[data-row-height=xxs] .ids-data-grid-header-cell.align-right .is-sortable .ids-data-grid-header-text {
  padding-inline-end: 3px;
  padding-inline-start: 3px;
}
.ids-data-grid[data-row-height=xxs] ids-input,
.ids-data-grid[data-row-height=xxs] ids-menu-button,
.ids-data-grid[data-row-height=xxs] ids-trigger-field,
.ids-data-grid[data-row-height=xxs] ids-dropdown {
  --ids-input-height-10: 24px;
}
.ids-data-grid[data-row-height=xxs] ids-dropdown {
  --ids-input-font-size-sm: var(--ids-input-font-size-xs);
}
.ids-data-grid[data-row-height=xxs] .ids-data-grid-header-cell-filter-wrapper {
  padding-inline-start: calc(var(--ids-data-grid-padding-xxs) + 2px);
  padding-inline-end: calc(var(--ids-data-grid-padding-xxs) + 2px);
  padding-block-end: var(--ids-data-grid-padding-xxs-1px);
}

.ids-data-grid .has-col-selection .ids-data-grid-header-cell:not([column-id=selectionCheckbox]) .ids-data-grid-header-cell-content {
  justify-content: flex-start;
}
.ids-data-grid .has-col-selection .ids-data-grid-header-cell:not([column-id=selectionCheckbox]) .ids-data-grid-header-cell-content .ids-data-grid-header-text .ids-checkbox .label-text {
  position: absolute;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 80%;
}
.ids-data-grid .has-col-selection .ids-data-grid-header-cell:not([column-id=selectionCheckbox]) .ids-data-grid-header-cell-content.is-sortable .ids-data-grid-header-text .ids-checkbox .label-text, .ids-data-grid .has-col-selection .ids-data-grid-header-cell:not([column-id=selectionCheckbox]) .ids-data-grid-header-cell-content.is-reorderable .ids-data-grid-header-text .ids-checkbox .label-text {
  width: 70%;
}
.ids-data-grid .has-col-selection .ids-data-grid-header-cell:not([column-id=selectionCheckbox]) .ids-data-grid-header-cell-content.is-sortable.is-reorderable .ids-data-grid-header-text .ids-checkbox .label-text {
  width: 60%;
}
.ids-data-grid .has-col-selection .sort-indicator {
  margin-inline-start: auto;
}

:host([dir=rtl]) .ids-data-grid-header-cell.align-right .ids-data-grid-header-cell-content {
  direction: ltr;
}
:host([dir=rtl]) .ids-data-grid-header-cell:last-child {
  border-inline-end-width: var(--ids-border-width-none);
}
:host([dir=rtl]) .ids-data-grid-header-cell.frozen-left {
  position: sticky;
  right: var(--ids-space-none);
}
:host([dir=rtl]) .ids-data-grid-header-cell.frozen-left:nth-of-type(2) {
  right: var(--ids-data-grid-frozen-column-left-width-2);
}
:host([dir=rtl]) .ids-data-grid-header-cell.frozen-left:nth-of-type(3) {
  right: var(--ids-data-grid-frozen-column-left-width-3);
}
:host([dir=rtl]) .ids-data-grid-header-cell.frozen-left:nth-of-type(4) {
  right: var(--ids-data-grid-frozen-column-left-width-4);
}
:host([dir=rtl]) .ids-data-grid-header-cell.frozen-left:nth-of-type(5) {
  right: var(--ids-data-grid-frozen-column-left-width-5);
}
:host([dir=rtl]) .ids-data-grid-header-cell.frozen-left:nth-of-type(6) {
  right: var(--ids-data-grid-frozen-column-left-width-6);
}
:host([dir=rtl]) .ids-data-grid-header-cell.frozen-left:nth-of-type(7) {
  right: var(--ids-data-grid-frozen-column-left-width-7);
}
:host([dir=rtl]) .ids-data-grid-header-cell.frozen-left:nth-of-type(8) {
  right: var(--ids-data-grid-frozen-column-left-width-8);
}
:host([dir=rtl]) .ids-data-grid-header-cell.frozen-left:nth-of-type(9) {
  right: var(--ids-data-grid-frozen-column-left-width-9);
}
:host([dir=rtl]) .ids-data-grid-header-cell.frozen-left:nth-of-type(10) {
  right: var(--ids-data-grid-frozen-column-left-width-10);
}

/* Ids Data Grid Component - Rows */
.ids-data-grid-row {
  display: grid;
  grid-template-columns: var(--ids-data-grid-column-widths);
  width: 100%;
}
.ids-data-grid-row.selected:not(.mixed) .ids-data-grid-cell, .ids-data-grid-row.activated .ids-data-grid-cell {
  background-color: var(--ids-data-grid-row-color-background-selected);
}
.ids-data-grid-row[hidden] {
  display: none;
}
.ids-data-grid-row[part*=row-]:not(.selected) .ids-data-grid-cell:first-child::before {
  border-style: solid;
  border-width: 5px;
  content: "";
  position: absolute;
  z-index: 1;
  margin: 2px;
  top: 0;
}
.ids-data-grid-row[part=row-new] {
  background-color: var(--ids-data-grid-row-color-background-new);
}
.ids-data-grid-row[part=row-new]:not(.selected) .ids-data-grid-cell {
  background-color: var(--ids-data-grid-row-color-background-new);
  color: var(--ids-data-grid-cell-color-text-states-default);
}
.ids-data-grid-row[part=row-new]:not(.selected) .ids-data-grid-cell:first-child::before {
  border-color: var(--ids-data-grid-row-color-border-new) transparent transparent var(--ids-data-grid-row-color-border-new);
}
.ids-data-grid-row[part=row-removed] {
  background-color: var(--ids-data-grid-row-color-background-removed);
}
.ids-data-grid-row[part=row-removed]:not(.selected) .ids-data-grid-cell {
  background-color: var(--ids-data-grid-row-color-background-removed);
  color: var(--ids-data-grid-cell-color-text-states-default);
}
.ids-data-grid-row[part=row-removed]:not(.selected) .ids-data-grid-cell:first-child::before {
  border-color: var(--ids-data-grid-row-color-border-removed) transparent transparent var(--ids-data-grid-row-color-border-removed);
}
.ids-data-grid-row[part=row-error] {
  background-color: var(--ids-data-grid-row-color-background-error);
}
.ids-data-grid-row[part=row-error]:not(.selected) .ids-data-grid-cell {
  background-color: var(--ids-data-grid-row-color-background-error);
  color: var(--ids-data-grid-cell-color-text-states-default);
}
.ids-data-grid-row[part=row-error]:not(.selected) .ids-data-grid-cell:first-child::before {
  border-color: var(--ids-data-grid-row-color-border-error) transparent transparent var(--ids-data-grid-row-color-border-error);
}

.ids-data-grid-row.is-group-row {
  background-color: var(--ids-data-grid-row-grouped-color-background);
  grid-template-columns: 100%;
}
.ids-data-grid-row.is-group-row .ids-data-grid-cell {
  color: var(--ids-data-grid-row-grouped-color-text, red);
  font-weight: var(--ids-data-grid-row-grouped-font-weight, 600);
  border-inline-start: 0;
}
.ids-data-grid-row.is-group-row ids-button {
  --ids-button-tertiary-color-background-hover: transparent;
  --ids-button-tertiary-color-border-hover: transparent;
  padding: 0 2px;
}

.ids-data-grid[data-row-height=md] .ids-data-grid-cell {
  height: var(--ids-data-grid-row-height-md);
}
.ids-data-grid[data-row-height=md] .ids-data-grid-cell .text-ellipsis,
.ids-data-grid[data-row-height=md] .ids-data-grid-cell ids-badge {
  padding-inline-start: var(--ids-data-grid-padding-md);
  padding-inline-end: var(--ids-data-grid-padding-md);
}
.ids-data-grid[data-row-height=md] .ids-data-grid-cell ids-hyperlink {
  margin: var(--ids-data-grid-padding-md);
}
.ids-data-grid[data-row-height=md] .ids-data-grid-cell:not(.align-center) .ids-data-grid-header-cell-content:not(.vertical-align-center) .ids-data-grid-header-text {
  padding-inline-start: var(--ids-data-grid-padding-md);
  transition: padding var(--ids-motion-duration) var(--ids-motion-ease);
}
.ids-data-grid[data-row-height=md] .ids-data-grid-cell:not(.align-center) .ids-data-grid-header-cell:hover .ids-data-grid-header-cell-content:not(.vertical-align-center).is-reorderable .ids-data-grid-header-text {
  padding-inline-start: var(--ids-data-grid-padding-md);
}
.ids-data-grid[data-row-height=sm] .ids-data-grid-cell {
  height: var(--ids-data-grid-row-height-sm);
}
.ids-data-grid[data-row-height=sm] .ids-data-grid-cell .text-ellipsis,
.ids-data-grid[data-row-height=sm] .ids-data-grid-cell ids-badge {
  padding-inline-start: var(--ids-data-grid-padding-sm);
  padding-inline-end: var(--ids-data-grid-padding-sm);
}
.ids-data-grid[data-row-height=sm] .ids-data-grid-cell ids-hyperlink {
  margin: var(--ids-data-grid-padding-sm);
}
.ids-data-grid[data-row-height=sm] .ids-data-grid-cell:not(.align-center) .ids-data-grid-header-cell-content:not(.vertical-align-center) .ids-data-grid-header-text {
  padding-inline-start: var(--ids-data-grid-padding-sm);
  transition: padding var(--ids-motion-duration) var(--ids-motion-ease);
}
.ids-data-grid[data-row-height=sm] .ids-data-grid-cell:not(.align-center) .ids-data-grid-header-cell:hover .ids-data-grid-header-cell-content:not(.vertical-align-center).is-reorderable .ids-data-grid-header-text {
  padding-inline-start: var(--ids-data-grid-padding-sm);
}
.ids-data-grid[data-row-height=xs] .ids-data-grid-cell {
  height: var(--ids-data-grid-row-height-xs);
  font-size: var(--ids-data-grid-font-size-sm);
}
.ids-data-grid[data-row-height=xs] .ids-data-grid-cell .text-ellipsis,
.ids-data-grid[data-row-height=xs] .ids-data-grid-cell ids-badge {
  padding-inline-start: var(--ids-data-grid-padding-xs);
  padding-inline-end: var(--ids-data-grid-padding-xs);
}
.ids-data-grid[data-row-height=xs] .ids-data-grid-cell ids-hyperlink {
  margin: var(--ids-data-grid-padding-xs);
}
.ids-data-grid[data-row-height=xs] .ids-data-grid-cell:not(.align-center) .ids-data-grid-header-cell-content:not(.vertical-align-center) .ids-data-grid-header-text {
  padding-inline-start: var(--ids-data-grid-padding-xs);
  transition: padding var(--ids-motion-duration) var(--ids-motion-ease);
}
.ids-data-grid[data-row-height=xs] .ids-data-grid-cell:not(.align-center) .ids-data-grid-header-cell:hover .ids-data-grid-header-cell-content:not(.vertical-align-center).is-reorderable .ids-data-grid-header-text {
  padding-inline-start: var(--ids-data-grid-padding-xs);
}
.ids-data-grid[data-row-height=xxs] .ids-data-grid-cell {
  height: var(--ids-data-grid-row-height-xxs);
  font-size: var(--ids-data-grid-font-size-sm);
}
.ids-data-grid[data-row-height=xxs] .ids-data-grid-cell .text-ellipsis,
.ids-data-grid[data-row-height=xxs] .ids-data-grid-cell ids-badge {
  padding-inline-start: var(--ids-data-grid-padding-xxs);
  padding-inline-end: var(--ids-data-grid-padding-xxs);
}
.ids-data-grid[data-row-height=xxs] .ids-data-grid-cell ids-hyperlink {
  margin: var(--ids-data-grid-padding-xxs);
}
.ids-data-grid[data-row-height=xxs] .ids-data-grid-cell.is-inline .text-ellipsis {
  padding-inline-start: var(--ids-data-grid-padding-xs);
  padding-inline-end: var(--ids-data-grid-padding-xs);
}
.ids-data-grid[data-row-height=xxs] .ids-data-grid-cell:not(.align-center) .ids-data-grid-header-cell-content:not(.vertical-align-center) .ids-data-grid-header-text {
  padding-inline-start: var(--ids-data-grid-padding-xxs);
  transition: padding var(--ids-motion-duration) var(--ids-motion-ease);
}
.ids-data-grid[data-row-height=xxs] .ids-data-grid-cell:not(.align-center) .ids-data-grid-header-cell:hover .ids-data-grid-header-cell-content:not(.vertical-align-center).is-reorderable .ids-data-grid-header-text {
  padding-inline-start: var(--ids-data-grid-padding-xxs);
}

.ids-data-grid.alt-row-shading ids-data-grid-row:nth-child(even) {
  background-color: var(--ids-data-grid-row-alternating-color-background);
}

.ids-data-grid-expandable-row {
  border-bottom: 1px solid var(--ids-data-grid-cell-color-border);
  grid-column: 1/-1;
  padding: var(--ids-space-xs);
}

tr.ids-data-grid-row {
  display: table-row;
  height: var(--ids-data-grid-row-height-lg);
}

.ids-data-grid.row-navigation .ids-data-grid-body .ids-data-grid-row:focus-within {
  transform-style: preserve-3d;
}
.ids-data-grid.row-navigation .ids-data-grid-body .ids-data-grid-row:focus-within::after {
  box-shadow: var(--ids-data-grid-row-shadow-focus);
  content: " ";
  display: block;
  height: 100%;
  position: absolute;
  width: 100%;
}
.ids-data-grid.row-navigation .ids-data-grid-body .ids-data-grid-row .ids-data-grid-cell:focus {
  box-shadow: none;
  outline: none;
}
.ids-data-grid.row-navigation .ids-data-grid-body .ids-data-grid-row ids-hyperlink,
.ids-data-grid.row-navigation .ids-data-grid-body .ids-data-grid-row .ids-hyperlink {
  transform: translateZ(1px);
}

:host([dir=rtl]) .ids-data-grid-row[part=row-new]:not(.selected) .ids-data-grid-cell:first-child::before {
  border-color: var(--ids-data-grid-row-color-border-new) var(--ids-data-grid-row-color-border-new) transparent transparent;
}
:host([dir=rtl]) .ids-data-grid-row[part=row-removed]:not(.selected) .ids-data-grid-cell:first-child::before {
  border-color: var(--ids-data-grid-row-color-border-removed) var(--ids-data-grid-row-color-border-removed) transparent transparent;
}
:host([dir=rtl]) .ids-data-grid-row[part=row-error]:not(.selected) .ids-data-grid-cell:first-child::before {
  border-color: var(--ids-data-grid-row-color-border-error) var(--ids-data-grid-row-color-border-error) transparent transparent;
}

/* Ids Data Grid Component - Cells */
/* Generates a pseudo-element representing the dirty tracker */
ids-data-grid-cell[column-onscreen] {
  visibility: visible;
}

ids-data-grid-cell[column-offscreen] {
  visibility: visible;
}

ids-data-grid-cell[column-offscreen-left] {
  visibility: visible;
}

ids-data-grid-cell[column-offscreen-right] {
  display: none !important;
}

.ids-data-grid-row:not(.selected):not([part*=row-]) .ids-data-grid-cell:not(.is-readonly).frozen-left {
  background-color: var(--ids-data-grid-color-background);
}
.ids-data-grid-row:not(.selected):not([part*=row-]) .ids-data-grid-cell:not(.is-readonly).frozen-right {
  background-color: var(--ids-data-grid-color-background);
}
.ids-data-grid-row:not(.selected):not([part*=row-]):hover .ids-data-grid-cell.frozen {
  background-color: var(--ids-data-grid-row-color-background-hover);
}

.ids-data-grid-cell {
  align-items: center;
  border-inline-start: 1px solid;
  border-block-end: 1px solid;
  border-color: var(--ids-data-grid-cell-color-border);
  display: inline-flex;
  color: var(--ids-data-grid-cell-color-text-default);
  height: 50px;
  overflow: hidden;
  position: relative;
  white-space: nowrap;
}
.ids-data-grid-cell:first-child {
  border-inline-start-width: var(--ids-border-width-none);
}
.ids-data-grid-cell ids-badge::part(badge) {
  margin-block-end: var(--ids-space-none);
  margin-inline-end: var(--ids-space-none);
}
.ids-data-grid-cell ids-badge {
  padding-inline-start: var(--ids-space-sm);
  padding-inline-end: var(--ids-space-sm);
}
.ids-data-grid-cell ids-icon[icon=dropdown] {
  color: var(--ids-trigger-field-icon-color);
}
.ids-data-grid-cell ids-hyperlink {
  margin: var(--ids-space-sm);
  width: -moz-available;
  width: -webkit-fill-available;
  width: fill-available;
}
.ids-data-grid-cell .text-ellipsis {
  display: inline-block;
  vertical-align: middle;
  padding-inline-start: var(--ids-space-sm);
  padding-inline-end: var(--ids-space-sm);
  height: auto;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ids-data-grid-cell ids-icon {
  vertical-align: middle;
}
.ids-data-grid-cell ids-icon + span {
  vertical-align: middle;
  line-height: 25px;
  padding-inline: var(--ids-space-2xs);
}
.ids-data-grid-cell.align-center > *:first-child {
  display: inline-flex;
  margin: var(--ids-space-none) auto;
}
.ids-data-grid-cell.align-right > *:first-child {
  margin-inline-start: auto;
  margin-inline-end: var(--ids-space-none);
}
.ids-data-grid-cell.align-right ids-input {
  text-align: right;
}
.ids-data-grid-cell.is-readonly:not(.exclude-readonly-style):not(.selected) {
  background-color: var(--ids-data-grid-cell-color-background-frozen-readonly);
}
.ids-data-grid-cell.is-readonly:not(.exclude-readonly-style):not(.selected) .editor-cell-icon {
  display: none;
}
.ids-data-grid-cell.is-disabled {
  color: var(--ids-data-grid-cell-color-text-disabled);
}
.ids-data-grid-cell.is-disabled .editor-cell-icon {
  display: none;
}
.ids-data-grid-cell.is-uppercase {
  text-transform: uppercase;
}
.ids-data-grid-cell:focus:not(.selected):not([tabindex="-1"]), .ids-data-grid-cell.is-editing:not(.is-inline):focus-within:not(.selected):not([tabindex="-1"]), .ids-data-grid-cell.is-focused:not(.selected):not([tabindex="-1"]) {
  box-shadow: var(--ids-shadow-20);
  outline: 1px solid var(--ids-color-border-focus);
  outline-offset: -1px;
}
.ids-data-grid-cell.is-editable.is-readonly:not(.exclude-readonly-style) .text-ellipsis::after {
  background-color: var(--ids-data-grid-cell-color-background-readonly);
}
.ids-data-grid-cell.is-editable.is-inline.formatter-tree .ids-data-grid-tree-container {
  height: 100%;
  width: 100%;
}
.ids-data-grid-cell.is-editable.is-inline.formatter-tree .ids-data-grid-tree-field-container {
  height: 100%;
  width: 100%;
}
.ids-data-grid-cell.is-editable.is-inline.formatter-tree .text-ellipsis {
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: end;
  width: 100%;
}
.ids-data-grid-cell.is-editable.is-inline.formatter-tree .text-ellipsis::after {
  margin-inline-end: -8px;
}
.ids-data-grid-cell.is-editable.is-inline ids-icon.editor-cell-icon {
  display: inline-flex;
  visibility: visible;
  margin-inline-end: 15px;
}
.ids-data-grid-cell.is-editable.is-inline ids-icon.editor-cell-icon[icon=dropdown] {
  margin-inline-end: 12px;
}
.ids-data-grid-cell.is-editable.is-lookup, .ids-data-grid-cell.is-editable.is-datepicker, .ids-data-grid-cell.is-editable.is-timepicker {
  justify-content: space-between;
}
.ids-data-grid-cell.is-editable.is-lookup .text-ellipsis, .ids-data-grid-cell.is-editable.is-datepicker .text-ellipsis, .ids-data-grid-cell.is-editable.is-timepicker .text-ellipsis {
  padding-inline-end: var(--ids-space-none);
}
.ids-data-grid-cell.is-editable.is-datepicker ids-trigger-field, .ids-data-grid-cell.is-editable.is-timepicker ids-trigger-field {
  margin-inline-start: -1px;
  margin-block-start: 1px;
}
.ids-data-grid-cell.is-editable.is-lookup ids-lookup {
  border: 0;
  outline: none;
  width: 100%;
}
.ids-data-grid-cell.is-editable.is-lookup ids-lookup::part(container),
.ids-data-grid-cell.is-editable.is-lookup ids-lookup::part(field-container) {
  background-color: var(--ids-color-transparent);
  border: 0;
  border-radius: 0;
  box-shadow: none;
  outline: none;
  height: 100%;
  width: 100%;
  display: flex;
  margin: 0;
}
.ids-data-grid-cell.is-editable .editor-cell-icon {
  margin-inline-end: 10px;
  margin-block-start: var(--ids-space-3xs);
  display: none;
}
.ids-data-grid-cell.is-editable .editor-cell-icon.show-cell-icon-always {
  display: inline-flex;
}
.ids-data-grid-cell.is-editable .editor-cell-icon.show-cell-icon-always:hover {
  cursor: pointer;
}
.ids-data-grid-cell.is-editable ids-trigger-button::part(button) {
  color: inherit;
}
.ids-data-grid-cell.is-editable:not(.is-inline):not(.is-invalid):focus .editor-cell-icon, .ids-data-grid-cell.is-editable:not(.is-inline):not(.is-invalid):hover .editor-cell-icon {
  display: flex;
}
.ids-data-grid-cell.is-editable:not(.is-inline):not(.is-invalid):focus ids-alert, .ids-data-grid-cell.is-editable:not(.is-inline):not(.is-invalid):hover ids-alert {
  margin-inline: calc(100% - 48px);
}
.ids-data-grid-cell.is-editable.is-editable.is-invalid {
  justify-content: space-between;
}
.ids-data-grid-cell.is-editable.is-editable.is-invalid ids-alert {
  margin-inline-end: var(--ids-space-xs);
}
.ids-data-grid-cell.is-editing ids-checkbox {
  --ids-checkbox-margin-inline-end: 0;
  --ids-checkbox-shadow-focus: 0 0 0 2px transparent, 0 0 0 3px transparent;
  --ids-checkbox-color-border-focus: var(--ids-checkbox-border);
  display: flex;
  justify-content: center;
  width: 100%;
  position: relative;
  left: 6px;
  top: 3px;
}
.ids-data-grid-cell.is-editing ids-checkbox[checked] {
  --ids-checkbox-color-border-focus: var(--ids-checkbox-color-background-selected);
}
.ids-data-grid-cell.is-editing.is-lookup, .ids-data-grid-cell.is-editing.is-datepicker, .ids-data-grid-cell.is-editing.is-timepicker {
  overflow: visible;
}
.ids-data-grid-cell.is-editing.is-inline ids-input {
  z-index: 99;
}
.ids-data-grid-cell.is-editable.is-dropdown .dropdown-cell-value {
  width: 100%;
}
.ids-data-grid-cell.is-editable.is-dropdown.is-editing:not(.is-inline) {
  border-inline-start-width: 0;
}
.ids-data-grid-cell.is-editing.is-dropdown.is-inline {
  box-shadow: none;
}
.ids-data-grid-cell.is-editing.is-dropdown.is-inline ids-dropdown {
  padding: 0 var(--ids-space-2xs);
}
.ids-data-grid-cell.formatter-text {
  white-space: pre;
}
.ids-data-grid-cell.is-editing.is-uppercase {
  text-transform: uppercase;
}
.ids-data-grid-cell.is-editing.is-uppercase ids-list-box-option,
.ids-data-grid-cell.is-editing.is-uppercase ids-dropdown::part(triggerfield-input),
.ids-data-grid-cell.is-editing.is-uppercase ids-input::part(input) {
  text-transform: uppercase;
}
.ids-data-grid-cell.frozen {
  position: sticky;
  z-index: 1;
}
.ids-data-grid-cell.frozen-last {
  border-inline-end: 1px solid var(--ids-data-grid-cell-color-border);
}
.ids-data-grid-cell.frozen-last + .ids-data-grid-cell {
  border-inline-start-width: var(--ids-border-width-none);
}
.ids-data-grid-cell.frozen-left {
  position: sticky;
  left: var(--ids-space-none);
}
.ids-data-grid-cell.frozen-left:nth-of-type(2) {
  left: var(--ids-data-grid-frozen-column-left-width-2);
}
.ids-data-grid-cell.frozen-left:nth-of-type(3) {
  left: var(--ids-data-grid-frozen-column-left-width-3);
}
.ids-data-grid-cell.frozen-left:nth-of-type(4) {
  left: var(--ids-data-grid-frozen-column-left-width-4);
}
.ids-data-grid-cell.frozen-left:nth-of-type(5) {
  left: var(--ids-data-grid-frozen-column-left-width-5);
}
.ids-data-grid-cell.frozen-left:nth-of-type(6) {
  left: var(--ids-data-grid-frozen-column-left-width-6);
}
.ids-data-grid-cell.frozen-left:nth-of-type(7) {
  left: var(--ids-data-grid-frozen-column-left-width-7);
}
.ids-data-grid-cell.frozen-left:nth-of-type(8) {
  left: var(--ids-data-grid-frozen-column-left-width-8);
}
.ids-data-grid-cell.frozen-left:nth-of-type(9) {
  left: var(--ids-data-grid-frozen-column-left-width-9);
}
.ids-data-grid-cell.frozen-left:nth-of-type(10) {
  left: var(--ids-data-grid-frozen-column-left-width-10);
}
.ids-data-grid-cell.frozen-right {
  position: sticky;
  right: var(--ids-space-none);
}
.ids-data-grid-cell.is-dirty::before {
  border-color: var(--ids-input-dirty-indicator-color-background-dirty) transparent transparent var(--ids-input-dirty-indicator-color-background-dirty);
  border-style: solid;
  border-width: 5px;
  content: "";
  display: inline-block;
  margin-inline: var(--ids-space-3xs);
  position: absolute;
  inset-block-start: var(--ids-space-3xs);
  z-index: 1;
}
.ids-data-grid-cell.is-dirty.is-inline.formatter-tree::before {
  display: none;
  content: none;
}
.ids-data-grid-cell.is-dirty.is-inline.formatter-tree .ids-data-grid-tree-field-container {
  position: relative;
}
.ids-data-grid-cell.is-dirty.is-inline.formatter-tree .ids-data-grid-tree-field-container::before {
  border-color: var(--ids-input-dirty-indicator-color-background-dirty) transparent transparent var(--ids-input-dirty-indicator-color-background-dirty);
  border-style: solid;
  border-width: 5px;
  content: "";
  display: inline-block;
  margin-inline: var(--ids-space-3xs);
  position: absolute;
  inset-block-start: var(--ids-space-3xs);
  z-index: 1;
}
.ids-data-grid-cell.is-dirty.is-inline.is-dropdown::before {
  margin-inline: 6px;
  inset-block-start: 6px;
}
.ids-data-grid-cell.is-dirty.is-inline ids-input::part(dirty-tracker-icon) {
  --ids-icon-height-default: 12px !important;
  --ids-icon-width-default: 12px !important;
}
.ids-data-grid-cell.is-dirty.is-dropdown.is-editing:not(.is-inline)::before {
  inset-block-start: 3px;
  margin-inline: 3px;
}
.ids-data-grid-cell.is-invalid {
  background-color: var(--ids-data-grid-cell-color-background-error);
}
.ids-data-grid-cell.selected {
  background-color: var(--ids-data-grid-row-color-background-selected);
}
.ids-data-grid-cell ids-alert {
  margin-top: 3px;
}
.ids-data-grid-cell ids-tag {
  --ids-tag-margin-inline-end: 0;
}
.ids-data-grid-cell ids-progress-bar {
  margin: var(--ids-progress-bar-grid-cell-margin);
}
.ids-data-grid-cell.is-editing.is-timepicker .ids-trigger-field-slot-trigger-end[icon=clock][field-height=xs] {
  margin-inline-end: -5px;
  margin-block-start: 1px;
}
.ids-data-grid-cell.is-editing.is-timepicker .ids-trigger-field-slot-trigger-end[icon=clock][field-height=sm] {
  margin-inline-end: var(--ids-space-3xs);
  margin-block-start: 1px;
}
.ids-data-grid-cell.is-editing.is-datepicker .ids-trigger-field-slot-trigger-end[icon=calendar][field-height=xs] {
  margin-inline-end: -5px;
  margin-block-start: 1px;
}
.ids-data-grid-cell.is-editing.is-datepicker .ids-trigger-field-slot-trigger-end[icon=calendar][field-height=sm] {
  margin-inline-end: var(--ids-space-3xs);
  margin-block-start: 1px;
}

[data-row-height=xxs] .formatter-progress ids-progress-bar {
  margin: var(--ids-data-grid-padding-xxs);
}
[data-row-height=xxs] .ids-data-grid-cell.is-dirty::before {
  border-width: 4px;
  inset-block-start: 1px;
  inset-inline-start: -1px;
}
[data-row-height=xxs] .ids-data-grid-cell.is-dirty.is-inline::before {
  margin-inline: 3px;
  top: 3px;
}
[data-row-height=xxs] ids-button {
  --ids-button-icon-padding: var(--ids-space-3xs);
}
[data-row-height=xxs] ids-badge {
  --ids-badge-font-line-height: calc(var(--ids-data-grid-row-height-xxs) - 8px);
}
[data-row-height=xxs] ids-tag {
  --ids-tag-height: calc(var(--ids-data-grid-row-height-xxs) - 6px);
}
[data-row-height=xxs] ids-input,
[data-row-height=xxs] ids-trigger-field {
  --ids-space-3xs: 0;
  --ids-input-font-size-sm: var(--ids-data-grid-font-size-sm);
}
[data-row-height=xxs] ids-input::part(dirty-tracker-icon) {
  --ids-icon-height-default: 10px !important;
  --ids-icon-width-default: 10px !important;
}
[data-row-height=xxs] ids-input::part(input) {
  height: calc(var(--ids-input-height-10) - 4px);
}
[data-row-height=xxs] .ids-data-grid-cell.is-editable .editor-cell-icon {
  margin-inline-end: var(--ids-space-3xs);
}
[data-row-height=xxs] .ids-data-grid-cell.is-editable.is-inline ids-icon.editor-cell-icon {
  margin-inline-end: var(--ids-space-2xs);
}
[data-row-height=xxs] .ids-data-grid-cell.is-editable.is-inline {
  --ids-button-tertiary-color-background-hover: var(--ids-color-transparent);
}
[data-row-height=xxs] .ids-data-grid-cell.is-editing.is-dropdown.is-inline ids-dropdown {
  padding: var(--ids-space-none) var(--ids-space-4xs);
  --ids-input-font-size-sm: var(--ids-data-grid-font-size-sm);
}
[data-row-height=xxs] .ids-data-grid-cell .ids-data-grid-checkbox-container:not(.is-selection-checkbox) {
  padding-inline: var(--ids-data-grid-padding-xxs);
}
[data-row-height=xxs] .ids-data-grid-cell.is-editable.is-editable.is-invalid ids-alert {
  margin-inline-end: var(--ids-space-4xs);
}

[data-row-height=xs] .formatter-progress ids-progress-bar {
  margin: var(--ids-data-grid-padding-xs);
}
[data-row-height=xs] .ids-data-grid-cell.is-dirty::before {
  border-width: 4px;
}
[data-row-height=xs] .ids-data-grid-cell.is-dirty.is-inline::before {
  margin-inline: 3px;
  top: 3px;
}
[data-row-height=xs] ids-button {
  --ids-button-icon-padding: 3px;
}
[data-row-height=xs] ids-badge {
  --ids-badge-font-line-height: calc(var(--ids-data-grid-row-height-xs) - 12px);
}
[data-row-height=xs] ids-tag {
  --ids-tag-height: calc(var(--ids-data-grid-row-height-xxs) - 4px);
}
[data-row-height=xs] ids-input {
  --ids-input-font-size-sm: var(--ids-data-grid-font-size-sm);
}
[data-row-height=xs] ids-input::part(dirty-tracker-icon) {
  --ids-icon-height-default: 12px !important;
  --ids-icon-width-default: 12px !important;
}
[data-row-height=xs] .ids-data-grid-cell.is-editable .editor-cell-icon {
  margin-inline-end: var(--ids-space-3xs);
}
[data-row-height=xs] .ids-data-grid-cell.is-editable.is-inline ids-icon.editor-cell-icon {
  margin-inline-end: var(--ids-space-2xs);
}
[data-row-height=xs] .ids-data-grid-cell.is-editable.is-inline {
  --ids-button-tertiary-color-background-hover: var(--ids-color-transparent);
  --ids-input-font-size-sm: var(--ids-data-grid-font-size-sm);
}
[data-row-height=xs] .ids-data-grid-cell.is-editing.is-dropdown.is-inline ids-dropdown {
  padding: var(--ids-space-none) var(--ids-space-3xs);
}
[data-row-height=xs] .ids-data-grid-cell .ids-data-grid-checkbox-container:not(.is-selection-checkbox) {
  padding-inline: var(--ids-data-grid-padding-xs);
}

[data-row-height=sm] .formatter-progress ids-progress-bar {
  margin: var(--ids-data-grid-padding-sm);
}
[data-row-height=sm] ids-button {
  --ids-button-icon-padding: var(--ids-space-2xs);
}
[data-row-height=sm] .ids-data-grid-cell.is-editable .editor-cell-icon {
  margin-inline-end: 6px;
}
[data-row-height=sm] .ids-data-grid-cell.is-editable.is-inline ids-icon.editor-cell-icon {
  margin-inline-end: 5px;
  margin-block-start: 0;
}
[data-row-height=sm] .ids-data-grid-cell.is-editable.is-inline {
  --ids-button-tertiary-color-background-hover: var(--ids-color-transparent);
}
[data-row-height=sm] .ids-data-grid-cell .ids-data-grid-checkbox-container:not(.is-selection-checkbox) {
  padding-inline: var(--ids-data-grid-padding-sm);
}

[data-row-height=md] .formatter-progress ids-progress-bar {
  margin: var(--ids-data-grid-padding-md);
}
[data-row-height=md] .ids-data-grid-cell.is-editable .editor-cell-icon {
  margin-inline-end: 7px;
}
[data-row-height=md] .ids-data-grid-cell.is-editable.is-inline ids-icon.editor-cell-icon {
  margin-inline-end: var(--ids-data-grid-padding-sm);
}
[data-row-height=md] .ids-data-grid-cell.is-editable.is-inline {
  --ids-button-tertiary-color-background-hover: var(--ids-color-transparent);
}
[data-row-height=md] .ids-data-grid-cell.is-editable.is-inline ::slotted(ids-trigger-button) {
  position: relative;
  top: 100px;
}
[data-row-height=md] .ids-data-grid-cell .ids-data-grid-checkbox-container:not(.is-selection-checkbox) {
  padding-inline: var(--ids-data-grid-padding-md);
}

[data-row-height=lg] .ids-data-grid-cell .ids-data-grid-checkbox-container:not(.is-selection-checkbox) {
  padding-inline: var(--ids-data-grid-padding-lg);
}

.ids-data-grid.is-list-style .ids-data-grid-cell {
  border-inline-start-width: var(--ids-border-width-none);
  border-bottom: 1px solid var(--ids-data-grid-list-cell-color-border);
}
.ids-data-grid.is-list-style .ids-data-grid-cell.is-readonly:not(.exclude-readonly-style) {
  background-color: var(--ids-data-grid-cell-color-background-readonly);
}
.ids-data-grid.is-list-style .ids-data-grid-cell.is-disabled {
  color: var(--ids-data-grid-cell-color-text-disabled);
}
.ids-data-grid.is-list-style .ids-data-grid-body .ids-data-grid-row:first-child .ids-data-grid-cell {
  border-top: 0;
}

td.ids-data-grid-cell {
  display: table-cell;
  padding-inline-start: var(--ids-space-sm);
  padding-inline-end: var(--ids-space-sm);
}

:host([dir=rtl]) .ids-data-grid.is-list-style .ids-data-grid-cell {
  border-inline-end-width: var(--ids-border-width-none);
}
:host([dir=rtl]) .ids-data-grid-cell.frozen-left {
  position: sticky;
  right: var(--ids-space-none);
}
:host([dir=rtl]) .ids-data-grid-cell.frozen-left:nth-of-type(2) {
  right: var(--ids-data-grid-frozen-column-left-width-2);
}
:host([dir=rtl]) .ids-data-grid-cell.frozen-left:nth-of-type(3) {
  right: var(--ids-data-grid-frozen-column-left-width-3);
}
:host([dir=rtl]) .ids-data-grid-cell.frozen-left:nth-of-type(4) {
  right: var(--ids-data-grid-frozen-column-left-width-4);
}
:host([dir=rtl]) .ids-data-grid-cell.frozen-left:nth-of-type(5) {
  right: var(--ids-data-grid-frozen-column-left-width-5);
}
:host([dir=rtl]) .ids-data-grid-cell.frozen-left:nth-of-type(6) {
  right: var(--ids-data-grid-frozen-column-left-width-6);
}
:host([dir=rtl]) .ids-data-grid-cell.frozen-left:nth-of-type(7) {
  right: var(--ids-data-grid-frozen-column-left-width-7);
}
:host([dir=rtl]) .ids-data-grid-cell.frozen-left:nth-of-type(8) {
  right: var(--ids-data-grid-frozen-column-left-width-8);
}
:host([dir=rtl]) .ids-data-grid-cell.frozen-left:nth-of-type(9) {
  right: var(--ids-data-grid-frozen-column-left-width-9);
}
:host([dir=rtl]) .ids-data-grid-cell.frozen-left:nth-of-type(10) {
  right: var(--ids-data-grid-frozen-column-left-width-10);
}
:host([dir=rtl]) .ids-data-grid-cell:last-child {
  border-inline-end-width: var(--ids-border-width-none);
}
:host([dir=rtl]) .ids-data-grid-cell.is-dirty .ids-data-grid-tree-field-container::before, :host([dir=rtl]) .ids-data-grid-cell.is-dirty::before {
  border-color: var(--ids-input-dirty-indicator-color-background-dirty) var(--ids-input-dirty-indicator-color-background-dirty) transparent transparent;
}

.ids-trigger-field-slot-trigger-end {
  margin-inline-end: var(--ids-space-none);
}

.hide {
  display: none;
}

@media all and (max-width: 1440px) {
  .hide-xxl-down {
    display: none;
  }
}

@media all and (min-width: 1440px) {
  .hide-xxl-up {
    display: none;
  }
}

@media all and (max-width: 1280px) {
  .hide-xl-down {
    display: none;
  }
}

@media all and (min-width: 1280px) {
  .hide-xl-up {
    display: none;
  }
}

@media all and (max-width: 1024px) {
  .hide-lg-down {
    display: none;
  }
}

@media all and (min-width: 1024px) {
  .hide-lg-up {
    display: none;
  }
}

@media all and (max-width: 840px) {
  .hide-md-down {
    display: none;
  }
}

@media all and (min-width: 840px) {
  .hide-md-up {
    display: none;
  }
}

@media all and (max-width: 600px) {
  .hide-sm-down {
    display: none;
  }
}

@media all and (min-width: 600px) {
  .hide-sm-up {
    display: none;
  }
}

@media all and (max-width: 320px) {
  .hide-xs-down {
    display: none;
  }
}

@media all and (min-width: 320px) {
  .hide-xs-up {
    display: none;
  }
}

@media all and (max-width: 600px) {
  :host(.hide-sm-down) {
    display: none;
  }
}

.ids-popup-menu:not([hidden]) {
  display: block;
  z-index: var(--ids-z-index-60);
}

/**
 * Checkbox Mixins.
 */
@keyframes check {
  0% {
    height: 0;
    left: 0;
    top: 8px;
    width: 0;
  }
  50% {
    height: 0;
    left: 0;
    top: 8px;
    width: 4px;
  }
  100% {
    height: 10px;
    left: 4px;
    top: 0;
    width: 4px;
  }
}
@keyframes checkindeterminate {
  0% {
    width: 0;
  }
  100% {
    width: 10px;
  }
}
/**
 * Radio Mixins.
 */
:host {
  --ids-data-grid-column-widths: repeat(1, minmax(110px, 1fr));
  position: relative;
}

.ids-data-grid {
  background-color: var(--ids-data-grid-color-background);
  border: 1px solid var(--ids-data-grid-cell-color-border);
  border-radius: var(--ids-border-radius-2xs);
  border-collapse: collapse;
  box-sizing: border-box;
  overflow: auto;
  width: 100%;
  display: inline-grid;
  align-content: flex-start;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);
  font-size: var(--ids-font-size-sm);
}
.ids-data-grid .ids-data-grid-checkbox-container {
  cursor: var(--ids-cursor-pointer);
  display: flex;
  width: 100%;
}
.ids-data-grid .ids-data-grid-cell.align-left .ids-data-grid-tree-container,
.ids-data-grid .ids-data-grid-cell.align-left .ids-data-grid-checkbox-container {
  justify-content: start;
}
.ids-data-grid .ids-data-grid-cell.align-center .ids-data-grid-checkbox-container {
  justify-content: center;
}
.ids-data-grid .ids-data-grid-cell.align-right .ids-data-grid-checkbox-container {
  justify-content: end;
}
.ids-data-grid .ids-data-grid-checkbox {
  position: absolute;
  border: var(--ids-checkbox-border);
  border-radius: var(--ids-checkbox-border-radius);
  height: 14px;
  width: 14px;
  left: 0;
  top: 3px;
  border-color: var(--ids-data-grid-cell-checkbox-color-border);
  position: relative;
  left: var(--ids-space-none);
  top: var(--ids-space-none);
}
.ids-data-grid .ids-data-grid-checkbox.editable {
  cursor: var(--ids-cursor-pointer);
}
.ids-data-grid .ids-data-grid-checkbox.disabled {
  background-color: var(--ids-checkbox-color-background-disabled);
  border-color: var(--ids-checkbox-color-border-disabled);
  cursor: var(--ids-cursor-default);
  opacity: 0.4;
}
.ids-data-grid .ids-data-grid-checkbox.checked {
  background-color: var(--ids-checkbox-color-background-selected);
  border-color: var(--ids-checkbox-color-border-selected);
}
.ids-data-grid .ids-data-grid-checkbox.checked::after {
  position: absolute;
  display: block;
  border: var(--ids-font-size-2xs) solid var(--ids-checkbox-color-border-selected-after);
  border-width: var(--ids-checkbox-border-width-selected-after);
  animation: check 0.15s;
  transform: rotate(45deg);
  content: "";
  height: 10px;
  left: 4px;
  top: 0;
  width: 4px;
  animation: none;
}
.ids-data-grid .ids-data-grid-checkbox.checked.disabled {
  background-color: var(--ids-checkbox-color-background-selected-disabled);
  border-color: var(--ids-checkbox-color-border-selected-disabled);
}
.ids-data-grid .ids-data-grid-checkbox.indeterminate {
  background-color: var(--ids-checkbox-color-background-indeterminate);
  border-color: var(--ids-checkbox-color-border-indeterminate);
}
.ids-data-grid .ids-data-grid-checkbox.indeterminate::after {
  position: absolute;
  animation: checkindeterminate 0.15s;
  display: block;
  border: 1px solid var(--ids-checkbox-color-border-indeterminate-after);
  border-width: var(--ids-checkbox-border-width-indeterminate);
  content: "";
  height: 6px;
  left: 2px;
  top: 0;
  transform: none;
  width: 10px;
  animation: none;
}
.ids-data-grid .ids-data-grid-radio-container {
  display: flex;
  justify-content: center;
  width: 100%;
}
.ids-data-grid .ids-data-grid-radio {
  position: absolute;
  border: 1px solid var(--ids-radio-color-border-default);
  border-radius: var(--ids-radio-border-radius);
  height: 14px;
  left: 0;
  top: 3px;
  transition: border-color var(--ids-motion-duration) var(--ids-motion-ease);
  width: 14px;
  cursor: var(--ids-cursor-pointer);
  position: relative;
  left: var(--ids-space-none);
  top: var(--ids-space-none);
}
.ids-data-grid .ids-data-grid-radio::after {
  position: absolute;
  background-color: var(--ids-radio-color-background);
  border: 1px solid var(--ids-radio-color-background);
  border-radius: var(--ids-radio-border-radius);
  content: "";
  height: 0;
  left: 6px;
  top: 6px;
  transition: all var(--ids-motion-duration) var(--ids-motion-ease);
  width: 0;
}
.ids-data-grid .ids-data-grid-radio.disabled {
  border-color: var(--ids-radio-color-border-disabled);
  cursor: var(--ids-cursor-default);
  box-shadow: none;
  opacity: var(--ids-radio-disabled-opacity);
}
.ids-data-grid .ids-data-grid-radio.checked {
  background-color: var(--ids-radio-color-background-selected);
  border-color: var(--ids-radio-color-border-selected);
}
.ids-data-grid .ids-data-grid-radio.checked::after {
  background-color: var(--ids-radio-inner-color-background-selected);
  border-color: var(--ids-radio-inner-color-background-selected);
  border-width: 2px;
  height: 4px;
  left: 3px;
  top: 3px;
  width: 4px;
}
.ids-data-grid .ids-data-grid-radio.checked.disabled {
  background-color: var(--ids-radio-color-background-selected-disabled);
  border-color: var(--ids-radio-color-border-selected-disabled);
  opacity: var(--ids-radio-disabled-opacity);
}
.ids-data-grid .ids-data-grid-cell .ids-data-grid-tree-container {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.ids-data-grid .ids-data-grid-cell .ids-data-grid-tree-container ids-button + .ids-data-grid-tree-field-container .text-ellipsis {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid .ids-data-grid-cell .ids-data-grid-tree-container ids-button {
  padding-inline-start: var(--ids-space-2xs);
  padding-inline-end: var(--ids-space-none);
}
.ids-data-grid .ids-data-grid-cell .ids-data-grid-tree-container ids-button.expand-button {
  --ids-button-tertiary-color-background-hover: var(--ids-color-transparent);
  --ids-button-tertiary-color-border-hover: var(--ids-color-transparent);
  --ids-button-tertiary-color-background-pressed: var(--ids-color-transparent);
  --ids-button-tertiary-color-border-pressed: var(--ids-color-transparent);
}
.ids-data-grid .ids-data-grid-cell .ids-data-grid-tree-container .text-ellipsis ids-hyperlink {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid .ids-data-grid-cell .ids-data-grid-tree-field-container {
  display: inline-grid;
  align-items: center;
}
.ids-data-grid[data-row-height=xxs] .ids-data-grid-cell.is-dirty:not(.is-inline).formatter-text::before {
  inset-block-start: 1px;
  margin-inline-start: 1px;
}
.ids-data-grid[data-row-height=xxs] .ids-data-grid-cell.is-dirty.is-inline.formatter-text::before {
  inset-block-start: 3px;
  margin-inline-start: 3px;
}
.ids-data-grid[data-row-height=xxs] .ids-data-grid-cell.is-editable.is-inline:not(.formatter-tree) {
  position: relative;
}
.ids-data-grid[data-row-height=xxs] .ids-data-grid-cell.is-editable.is-inline:not(.formatter-tree)::after {
  border: 1px solid var(--ids-input-color-border-default);
  border-radius: var(--ids-border-radius-2xs);
  box-sizing: border-box;
  display: block;
  content: "";
  margin: 1px;
  height: calc(100% - 2px);
  position: absolute;
  width: calc(100% - 2px);
}
.ids-data-grid[data-row-height=xxs] .ids-data-grid-cell.is-editable.is-inline.formatter-tree .text-ellipsis {
  position: relative;
  width: calc(100% - 5px);
}
.ids-data-grid[data-row-height=xxs] .ids-data-grid-cell.is-editable.is-inline.formatter-tree .text-ellipsis::after {
  border: 1px solid var(--ids-input-color-border-default);
  border-radius: var(--ids-border-radius-2xs);
  box-sizing: border-box;
  display: block;
  content: "";
  margin: 1px;
  height: calc(100% - 2px);
  position: absolute;
  width: calc(100% - 2px);
}
.ids-data-grid[data-row-height=xxs] .ids-data-grid-cell.is-editable.is-inline.formatter-tree .text-ellipsis::after {
  margin-inline-end: -1px;
}
.ids-data-grid[data-row-height=xxs] .ids-data-grid-tree-field-container .text-ellipsis {
  padding-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=xxs] [aria-level="1"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 30px;
}
.ids-data-grid[data-row-height=xxs] [aria-level="1"] .ids-data-grid-cell ids-button {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=xxs] [aria-level="1"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=xxs] [aria-level="1"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 3px;
  margin-inline-start: 3px;
}
.ids-data-grid[data-row-height=xxs] [aria-level="2"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 54px;
}
.ids-data-grid[data-row-height=xxs] [aria-level="2"] .ids-data-grid-cell ids-button {
  margin-inline-start: 24px;
}
.ids-data-grid[data-row-height=xxs] [aria-level="2"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=xxs] [aria-level="2"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 3px;
  margin-inline-start: 3px;
}
.ids-data-grid[data-row-height=xxs] [aria-level="3"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 66px;
}
.ids-data-grid[data-row-height=xxs] [aria-level="3"] .ids-data-grid-cell ids-button {
  margin-inline-start: 36px;
}
.ids-data-grid[data-row-height=xxs] [aria-level="3"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=xxs] [aria-level="3"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 3px;
  margin-inline-start: 3px;
}
.ids-data-grid[data-row-height=xxs] [aria-level="4"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 78px;
}
.ids-data-grid[data-row-height=xxs] [aria-level="4"] .ids-data-grid-cell ids-button {
  margin-inline-start: 48px;
}
.ids-data-grid[data-row-height=xxs] [aria-level="4"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=xxs] [aria-level="4"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 3px;
  margin-inline-start: 3px;
}
.ids-data-grid[data-row-height=xxs] [aria-level="5"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 90px;
}
.ids-data-grid[data-row-height=xxs] [aria-level="5"] .ids-data-grid-cell ids-button {
  margin-inline-start: 60px;
}
.ids-data-grid[data-row-height=xxs] [aria-level="5"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=xxs] [aria-level="5"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 3px;
  margin-inline-start: 3px;
}
.ids-data-grid[data-row-height=xxs] [aria-level="6"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 102px;
}
.ids-data-grid[data-row-height=xxs] [aria-level="6"] .ids-data-grid-cell ids-button {
  margin-inline-start: 72px;
}
.ids-data-grid[data-row-height=xxs] [aria-level="6"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=xxs] [aria-level="6"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 3px;
  margin-inline-start: 3px;
}
.ids-data-grid[data-row-height=xxs] [aria-level="7"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 114px;
}
.ids-data-grid[data-row-height=xxs] [aria-level="7"] .ids-data-grid-cell ids-button {
  margin-inline-start: 84px;
}
.ids-data-grid[data-row-height=xxs] [aria-level="7"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=xxs] [aria-level="7"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 3px;
  margin-inline-start: 3px;
}
.ids-data-grid[data-row-height=xxs] [aria-level="8"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 126px;
}
.ids-data-grid[data-row-height=xxs] [aria-level="8"] .ids-data-grid-cell ids-button {
  margin-inline-start: 96px;
}
.ids-data-grid[data-row-height=xxs] [aria-level="8"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=xxs] [aria-level="8"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 3px;
  margin-inline-start: 3px;
}
.ids-data-grid[data-row-height=xs] .ids-data-grid-cell.is-dirty:not(.is-inline).formatter-text::before {
  inset-block-start: 1px;
  margin-inline-start: 1px;
}
.ids-data-grid[data-row-height=xs] .ids-data-grid-cell.is-dirty.is-inline.formatter-text::before {
  inset-block-start: 4px;
  margin-inline-start: 4px;
}
.ids-data-grid[data-row-height=xs] .ids-data-grid-cell.is-editable.is-inline:not(.formatter-tree) {
  position: relative;
}
.ids-data-grid[data-row-height=xs] .ids-data-grid-cell.is-editable.is-inline:not(.formatter-tree)::after {
  border: 1px solid var(--ids-input-color-border-default);
  border-radius: var(--ids-border-radius-2xs);
  box-sizing: border-box;
  display: block;
  content: "";
  margin: 2px;
  height: calc(100% - 4px);
  position: absolute;
  width: calc(100% - 4px);
}
.ids-data-grid[data-row-height=xs] .ids-data-grid-cell.is-editable.is-inline.formatter-tree .text-ellipsis {
  position: relative;
  width: calc(100% - 6px);
}
.ids-data-grid[data-row-height=xs] .ids-data-grid-cell.is-editable.is-inline.formatter-tree .text-ellipsis::after {
  border: 1px solid var(--ids-input-color-border-default);
  border-radius: var(--ids-border-radius-2xs);
  box-sizing: border-box;
  display: block;
  content: "";
  margin: 2px;
  height: calc(100% - 4px);
  position: absolute;
  width: calc(100% - 4px);
}
.ids-data-grid[data-row-height=xs] .ids-data-grid-cell.is-editable.is-inline.formatter-tree .text-ellipsis::after {
  margin-inline-end: -2px;
}
.ids-data-grid[data-row-height=xs] .ids-data-grid-tree-field-container .text-ellipsis {
  padding-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=xs] [aria-level="1"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 32px;
}
.ids-data-grid[data-row-height=xs] [aria-level="1"] .ids-data-grid-cell ids-button {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=xs] [aria-level="1"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=xs] [aria-level="1"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 4px;
  margin-inline-start: 4px;
}
.ids-data-grid[data-row-height=xs] [aria-level="2"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 55px;
}
.ids-data-grid[data-row-height=xs] [aria-level="2"] .ids-data-grid-cell ids-button {
  margin-inline-start: 23px;
}
.ids-data-grid[data-row-height=xs] [aria-level="2"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=xs] [aria-level="2"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 4px;
  margin-inline-start: 4px;
}
.ids-data-grid[data-row-height=xs] [aria-level="3"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 68px;
}
.ids-data-grid[data-row-height=xs] [aria-level="3"] .ids-data-grid-cell ids-button {
  margin-inline-start: 36px;
}
.ids-data-grid[data-row-height=xs] [aria-level="3"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=xs] [aria-level="3"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 4px;
  margin-inline-start: 4px;
}
.ids-data-grid[data-row-height=xs] [aria-level="4"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 81px;
}
.ids-data-grid[data-row-height=xs] [aria-level="4"] .ids-data-grid-cell ids-button {
  margin-inline-start: 49px;
}
.ids-data-grid[data-row-height=xs] [aria-level="4"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=xs] [aria-level="4"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 4px;
  margin-inline-start: 4px;
}
.ids-data-grid[data-row-height=xs] [aria-level="5"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 94px;
}
.ids-data-grid[data-row-height=xs] [aria-level="5"] .ids-data-grid-cell ids-button {
  margin-inline-start: 62px;
}
.ids-data-grid[data-row-height=xs] [aria-level="5"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=xs] [aria-level="5"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 4px;
  margin-inline-start: 4px;
}
.ids-data-grid[data-row-height=xs] [aria-level="6"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 107px;
}
.ids-data-grid[data-row-height=xs] [aria-level="6"] .ids-data-grid-cell ids-button {
  margin-inline-start: 75px;
}
.ids-data-grid[data-row-height=xs] [aria-level="6"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=xs] [aria-level="6"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 4px;
  margin-inline-start: 4px;
}
.ids-data-grid[data-row-height=xs] [aria-level="7"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 120px;
}
.ids-data-grid[data-row-height=xs] [aria-level="7"] .ids-data-grid-cell ids-button {
  margin-inline-start: 88px;
}
.ids-data-grid[data-row-height=xs] [aria-level="7"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=xs] [aria-level="7"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 4px;
  margin-inline-start: 4px;
}
.ids-data-grid[data-row-height=xs] [aria-level="8"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 133px;
}
.ids-data-grid[data-row-height=xs] [aria-level="8"] .ids-data-grid-cell ids-button {
  margin-inline-start: 101px;
}
.ids-data-grid[data-row-height=xs] [aria-level="8"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=xs] [aria-level="8"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 4px;
  margin-inline-start: 4px;
}
.ids-data-grid[data-row-height=sm] .ids-data-grid-cell.is-dirty:not(.is-inline).formatter-text::before {
  inset-block-start: 1px;
  margin-inline-start: 1px;
}
.ids-data-grid[data-row-height=sm] .ids-data-grid-cell.is-dirty.is-inline.formatter-text::before {
  inset-block-start: 5px;
  margin-inline-start: 5px;
}
.ids-data-grid[data-row-height=sm] .ids-data-grid-cell.is-editable.is-inline:not(.formatter-tree) {
  position: relative;
}
.ids-data-grid[data-row-height=sm] .ids-data-grid-cell.is-editable.is-inline:not(.formatter-tree)::after {
  border: 1px solid var(--ids-input-color-border-default);
  border-radius: var(--ids-border-radius-2xs);
  box-sizing: border-box;
  display: block;
  content: "";
  margin: 3px;
  height: calc(100% - 6px);
  position: absolute;
  width: calc(100% - 6px);
}
.ids-data-grid[data-row-height=sm] .ids-data-grid-cell.is-editable.is-inline.formatter-tree .text-ellipsis {
  position: relative;
  width: calc(100% - 9px);
}
.ids-data-grid[data-row-height=sm] .ids-data-grid-cell.is-editable.is-inline.formatter-tree .text-ellipsis::after {
  border: 1px solid var(--ids-input-color-border-default);
  border-radius: var(--ids-border-radius-2xs);
  box-sizing: border-box;
  display: block;
  content: "";
  margin: 3px;
  height: calc(100% - 6px);
  position: absolute;
  width: calc(100% - 6px);
}
.ids-data-grid[data-row-height=sm] .ids-data-grid-cell.is-editable.is-inline.formatter-tree .text-ellipsis::after {
  margin-inline-end: -5px;
}
.ids-data-grid[data-row-height=sm] .ids-data-grid-tree-field-container .text-ellipsis {
  padding-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=sm] [aria-level="1"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 34px;
}
.ids-data-grid[data-row-height=sm] [aria-level="1"] .ids-data-grid-cell ids-button {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=sm] [aria-level="1"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=sm] [aria-level="1"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 5px;
  margin-inline-start: 5px;
}
.ids-data-grid[data-row-height=sm] [aria-level="2"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 57px;
}
.ids-data-grid[data-row-height=sm] [aria-level="2"] .ids-data-grid-cell ids-button {
  margin-inline-start: 23px;
}
.ids-data-grid[data-row-height=sm] [aria-level="2"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=sm] [aria-level="2"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 5px;
  margin-inline-start: 5px;
}
.ids-data-grid[data-row-height=sm] [aria-level="3"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 72px;
}
.ids-data-grid[data-row-height=sm] [aria-level="3"] .ids-data-grid-cell ids-button {
  margin-inline-start: 38px;
}
.ids-data-grid[data-row-height=sm] [aria-level="3"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=sm] [aria-level="3"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 5px;
  margin-inline-start: 5px;
}
.ids-data-grid[data-row-height=sm] [aria-level="4"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 87px;
}
.ids-data-grid[data-row-height=sm] [aria-level="4"] .ids-data-grid-cell ids-button {
  margin-inline-start: 53px;
}
.ids-data-grid[data-row-height=sm] [aria-level="4"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=sm] [aria-level="4"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 5px;
  margin-inline-start: 5px;
}
.ids-data-grid[data-row-height=sm] [aria-level="5"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 102px;
}
.ids-data-grid[data-row-height=sm] [aria-level="5"] .ids-data-grid-cell ids-button {
  margin-inline-start: 68px;
}
.ids-data-grid[data-row-height=sm] [aria-level="5"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=sm] [aria-level="5"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 5px;
  margin-inline-start: 5px;
}
.ids-data-grid[data-row-height=sm] [aria-level="6"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 117px;
}
.ids-data-grid[data-row-height=sm] [aria-level="6"] .ids-data-grid-cell ids-button {
  margin-inline-start: 83px;
}
.ids-data-grid[data-row-height=sm] [aria-level="6"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=sm] [aria-level="6"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 5px;
  margin-inline-start: 5px;
}
.ids-data-grid[data-row-height=sm] [aria-level="7"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 132px;
}
.ids-data-grid[data-row-height=sm] [aria-level="7"] .ids-data-grid-cell ids-button {
  margin-inline-start: 98px;
}
.ids-data-grid[data-row-height=sm] [aria-level="7"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=sm] [aria-level="7"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 5px;
  margin-inline-start: 5px;
}
.ids-data-grid[data-row-height=sm] [aria-level="8"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 147px;
}
.ids-data-grid[data-row-height=sm] [aria-level="8"] .ids-data-grid-cell ids-button {
  margin-inline-start: 113px;
}
.ids-data-grid[data-row-height=sm] [aria-level="8"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=sm] [aria-level="8"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 5px;
  margin-inline-start: 5px;
}
.ids-data-grid[data-row-height=md] .ids-data-grid-cell.is-dirty:not(.is-inline).formatter-text::before {
  inset-block-start: 2px;
  margin-inline-start: 2px;
}
.ids-data-grid[data-row-height=md] .ids-data-grid-cell.is-dirty.is-inline.formatter-text::before {
  inset-block-start: 6px;
  margin-inline-start: 6px;
}
.ids-data-grid[data-row-height=md] .ids-data-grid-cell.is-editable.is-inline:not(.formatter-tree) {
  position: relative;
}
.ids-data-grid[data-row-height=md] .ids-data-grid-cell.is-editable.is-inline:not(.formatter-tree)::after {
  border: 1px solid var(--ids-input-color-border-default);
  border-radius: var(--ids-border-radius-2xs);
  box-sizing: border-box;
  display: block;
  content: "";
  margin: 4px;
  height: calc(100% - 8px);
  position: absolute;
  width: calc(100% - 8px);
}
.ids-data-grid[data-row-height=md] .ids-data-grid-cell.is-editable.is-inline.formatter-tree .text-ellipsis {
  position: relative;
  width: calc(100% - 12px);
}
.ids-data-grid[data-row-height=md] .ids-data-grid-cell.is-editable.is-inline.formatter-tree .text-ellipsis::after {
  border: 1px solid var(--ids-input-color-border-default);
  border-radius: var(--ids-border-radius-2xs);
  box-sizing: border-box;
  display: block;
  content: "";
  margin: 4px;
  height: calc(100% - 8px);
  position: absolute;
  width: calc(100% - 8px);
}
.ids-data-grid[data-row-height=md] .ids-data-grid-cell.is-editable.is-inline.formatter-tree .text-ellipsis::after {
  margin-inline-end: -8px;
}
.ids-data-grid[data-row-height=md] .ids-data-grid-tree-field-container .text-ellipsis {
  padding-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=md] [aria-level="1"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 40px;
}
.ids-data-grid[data-row-height=md] [aria-level="1"] .ids-data-grid-cell ids-button {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=md] [aria-level="1"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=md] [aria-level="1"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 6px;
  margin-inline-start: 6px;
}
.ids-data-grid[data-row-height=md] [aria-level="2"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 60px;
}
.ids-data-grid[data-row-height=md] [aria-level="2"] .ids-data-grid-cell ids-button {
  margin-inline-start: 20px;
}
.ids-data-grid[data-row-height=md] [aria-level="2"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=md] [aria-level="2"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 6px;
  margin-inline-start: 6px;
}
.ids-data-grid[data-row-height=md] [aria-level="3"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 77px;
}
.ids-data-grid[data-row-height=md] [aria-level="3"] .ids-data-grid-cell ids-button {
  margin-inline-start: 37px;
}
.ids-data-grid[data-row-height=md] [aria-level="3"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=md] [aria-level="3"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 6px;
  margin-inline-start: 6px;
}
.ids-data-grid[data-row-height=md] [aria-level="4"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 94px;
}
.ids-data-grid[data-row-height=md] [aria-level="4"] .ids-data-grid-cell ids-button {
  margin-inline-start: 54px;
}
.ids-data-grid[data-row-height=md] [aria-level="4"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=md] [aria-level="4"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 6px;
  margin-inline-start: 6px;
}
.ids-data-grid[data-row-height=md] [aria-level="5"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 111px;
}
.ids-data-grid[data-row-height=md] [aria-level="5"] .ids-data-grid-cell ids-button {
  margin-inline-start: 71px;
}
.ids-data-grid[data-row-height=md] [aria-level="5"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=md] [aria-level="5"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 6px;
  margin-inline-start: 6px;
}
.ids-data-grid[data-row-height=md] [aria-level="6"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 128px;
}
.ids-data-grid[data-row-height=md] [aria-level="6"] .ids-data-grid-cell ids-button {
  margin-inline-start: 88px;
}
.ids-data-grid[data-row-height=md] [aria-level="6"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=md] [aria-level="6"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 6px;
  margin-inline-start: 6px;
}
.ids-data-grid[data-row-height=md] [aria-level="7"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 145px;
}
.ids-data-grid[data-row-height=md] [aria-level="7"] .ids-data-grid-cell ids-button {
  margin-inline-start: 105px;
}
.ids-data-grid[data-row-height=md] [aria-level="7"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=md] [aria-level="7"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 6px;
  margin-inline-start: 6px;
}
.ids-data-grid[data-row-height=md] [aria-level="8"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 162px;
}
.ids-data-grid[data-row-height=md] [aria-level="8"] .ids-data-grid-cell ids-button {
  margin-inline-start: 122px;
}
.ids-data-grid[data-row-height=md] [aria-level="8"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=md] [aria-level="8"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 6px;
  margin-inline-start: 6px;
}
.ids-data-grid[data-row-height=lg] .ids-data-grid-cell.is-dirty:not(.is-inline).formatter-text::before {
  inset-block-start: 2px;
  margin-inline-start: 2px;
}
.ids-data-grid[data-row-height=lg] .ids-data-grid-cell.is-dirty.is-inline.formatter-text::before {
  inset-block-start: 6px;
  margin-inline-start: 6px;
}
.ids-data-grid[data-row-height=lg] .ids-data-grid-cell.is-editable.is-inline:not(.formatter-tree) {
  position: relative;
}
.ids-data-grid[data-row-height=lg] .ids-data-grid-cell.is-editable.is-inline:not(.formatter-tree)::after {
  border: 1px solid var(--ids-input-color-border-default);
  border-radius: var(--ids-border-radius-2xs);
  box-sizing: border-box;
  display: block;
  content: "";
  margin: 4px;
  height: calc(100% - 8px);
  position: absolute;
  width: calc(100% - 8px);
}
.ids-data-grid[data-row-height=lg] .ids-data-grid-cell.is-editable.is-inline.formatter-tree .text-ellipsis {
  position: relative;
  width: calc(100% - 16px);
}
.ids-data-grid[data-row-height=lg] .ids-data-grid-cell.is-editable.is-inline.formatter-tree .text-ellipsis::after {
  border: 1px solid var(--ids-input-color-border-default);
  border-radius: var(--ids-border-radius-2xs);
  box-sizing: border-box;
  display: block;
  content: "";
  margin: 4px;
  height: calc(100% - 8px);
  position: absolute;
  width: calc(100% - 8px);
}
.ids-data-grid[data-row-height=lg] .ids-data-grid-cell.is-editable.is-inline.formatter-tree .text-ellipsis::after {
  margin-inline-end: -12px;
}
.ids-data-grid[data-row-height=lg] .ids-data-grid-tree-field-container .text-ellipsis {
  padding-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=lg] [aria-level="1"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 40px;
}
.ids-data-grid[data-row-height=lg] [aria-level="1"] .ids-data-grid-cell ids-button {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=lg] [aria-level="1"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=lg] [aria-level="1"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 6px;
  margin-inline-start: 6px;
}
.ids-data-grid[data-row-height=lg] [aria-level="2"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 60px;
}
.ids-data-grid[data-row-height=lg] [aria-level="2"] .ids-data-grid-cell ids-button {
  margin-inline-start: 20px;
}
.ids-data-grid[data-row-height=lg] [aria-level="2"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=lg] [aria-level="2"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 6px;
  margin-inline-start: 6px;
}
.ids-data-grid[data-row-height=lg] [aria-level="3"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 77px;
}
.ids-data-grid[data-row-height=lg] [aria-level="3"] .ids-data-grid-cell ids-button {
  margin-inline-start: 37px;
}
.ids-data-grid[data-row-height=lg] [aria-level="3"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=lg] [aria-level="3"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 6px;
  margin-inline-start: 6px;
}
.ids-data-grid[data-row-height=lg] [aria-level="4"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 94px;
}
.ids-data-grid[data-row-height=lg] [aria-level="4"] .ids-data-grid-cell ids-button {
  margin-inline-start: 54px;
}
.ids-data-grid[data-row-height=lg] [aria-level="4"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=lg] [aria-level="4"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 6px;
  margin-inline-start: 6px;
}
.ids-data-grid[data-row-height=lg] [aria-level="5"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 111px;
}
.ids-data-grid[data-row-height=lg] [aria-level="5"] .ids-data-grid-cell ids-button {
  margin-inline-start: 71px;
}
.ids-data-grid[data-row-height=lg] [aria-level="5"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=lg] [aria-level="5"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 6px;
  margin-inline-start: 6px;
}
.ids-data-grid[data-row-height=lg] [aria-level="6"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 128px;
}
.ids-data-grid[data-row-height=lg] [aria-level="6"] .ids-data-grid-cell ids-button {
  margin-inline-start: 88px;
}
.ids-data-grid[data-row-height=lg] [aria-level="6"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=lg] [aria-level="6"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 6px;
  margin-inline-start: 6px;
}
.ids-data-grid[data-row-height=lg] [aria-level="7"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 145px;
}
.ids-data-grid[data-row-height=lg] [aria-level="7"] .ids-data-grid-cell ids-button {
  margin-inline-start: 105px;
}
.ids-data-grid[data-row-height=lg] [aria-level="7"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=lg] [aria-level="7"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 6px;
  margin-inline-start: 6px;
}
.ids-data-grid[data-row-height=lg] [aria-level="8"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 162px;
}
.ids-data-grid[data-row-height=lg] [aria-level="8"] .ids-data-grid-cell ids-button {
  margin-inline-start: 122px;
}
.ids-data-grid[data-row-height=lg] [aria-level="8"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=lg] [aria-level="8"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 6px;
  margin-inline-start: 6px;
}
.ids-data-grid.is-list-style {
  border-width: var(--ids-border-width-none);
}
.ids-data-grid.waiting-load {
  visibility: hidden;
  overflow: hidden;
}
.ids-data-grid.waiting-load .ids-data-grid-body {
  visibility: hidden;
}

.ids-data-grid-body {
  min-width: fit-content;
}

table.ids-data-grid {
  display: table;
  outline: 1px solid var(--ids-data-grid-cell-color-border);
  outline-offset: -1px;
}

.ids-data-grid-wrapper {
  position: relative;
}
.ids-data-grid-wrapper .ids-data-grid-toolbar {
  display: flex;
  width: 100%;
  margin: 6px var(--ids-space-none);
  align-items: center;
  justify-content: end;
}

ids-empty-message:not([hidden]),
::slotted(ids-empty-message:not([hidden])) {
  display: flex;
  width: 100%;
  height: 100%;
  position: absolute;
  justify-content: center;
  align-items: center;
  top: var(--ids-space-none);
  pointer-events: none;
  margin-top: var(--ids-space-sm);
}

ids-empty-message.has-filter-row:not([hidden]).filter-row-size-xxs {
  margin-block-start: 24px;
}
ids-empty-message.has-filter-row:not([hidden]).filter-row-size-xs {
  margin-block-start: 34px;
}
ids-empty-message.has-filter-row:not([hidden]).filter-row-size-sm {
  margin-block-start: 34px;
}
ids-empty-message.has-filter-row:not([hidden]).filter-row-size-md {
  margin-block-start: 34px;
}
ids-empty-message.has-filter-row:not([hidden]).filter-row-size-lg {
  margin-block-start: 26px;
}
ids-empty-message.has-filter-row:not([hidden]).has-pager {
  margin-block-start: 14px;
}

::slotted(ids-empty-message.has-filter-row:not([hidden])) {
  margin-block-start: 14px;
}

.has-empty-message .ids-data-grid {
  min-height: var(--ids-data-grid-height-min);
}

ids-loading-indicator {
  display: flex;
  width: 100%;
  height: 100%;
  position: absolute;
  justify-content: center;
  align-items: center;
  top: var(--ids-space-none);
}
ids-loading-indicator[stopped] {
  display: none;
}

:host(:not([disable-row-highlight])) ids-data-grid-row:hover:not([part*=row-]):not(.selected) ids-data-grid-cell,
:host(:not([disable-row-highlight])) ids-data-grid-row:hover:not([part*=row-]):not(.selected) ids-data-grid-cell.is-readonly:not(.exclude-readonly-style) {
  background-color: var(--ids-data-grid-row-color-background-hover);
}
:host(:not([disable-row-highlight])) ids-data-grid-row:hover:not([part*=row-]):not(.selected) ids-data-grid-cell.is-invalid {
  background-color: var(--ids-data-grid-cell-color-background-error-hover);
}

#datagrid-modal {
  --ids-modal-content-padding: var(--ids-space-none);
  --ids-modal-header-padding: var(--ids-space-sm) var(--ids-space-sm) var(--ids-space-xs) var(--ids-space-sm);
  --ids-popup-fit-height: 400px;
}
#datagrid-modal ids-swappable-item {
  --ids-swappable-item-color-background-selected: var(--ids-color-accent-blue-weakest);
  --ids-swappable-item-color-text-selected: var(--ids-color-foreground-default-default);
  align-items: center;
  height: var(--ids-data-grid-modal-row-height);
}
#datagrid-modal #datagrid-modal-title {
  position: relative;
  top: calc(var(--ids-space-04) * -1);
}
#datagrid-modal ids-search-field {
  --ids-input-color-background-default: var(--ids-color-accent-neutral-weakest);
  --ids-search-field-color-background-default: var(--ids-color-accent-neutral-weakest);
  --ids-input-color-border-default: var(--ids-color-accent-neutral-weak);
  --ids-input-color-border-hover: var(--ids-color-accent-neutral-weak);
  --ids-input-color-border-focus: var(--ids-color-accent-neutral-weak);
  --ids-input-color-border-shadow: none;
  --ids-search-field-border-radius: var(--ids-border-radius-none);
  --ids-search-field-border-width: var(--ids-border-width-sm) var(--ids-border-width-none);
  margin-bottom: -8px;
  margin-top: calc(var(--ids-space-08) * -1);
  min-width: 330px;
  position: sticky;
  top: var(--ids-space-none);
  z-index: 1;
}
#datagrid-modal ids-text {
  width: 100%;
}
#datagrid-modal ids-switch {
  position: relative;
  top: var(--ids-space-3xs);
}
#datagrid-modal ids-swappable {
  width: 100%;
}
#datagrid-modal .datagrid-modal-column-list {
  --ids-modal-column-list-height: calc(100% - 14px);
  overflow: auto;
  max-height: var(--ids-modal-column-list-height);
}

.selection-border {
  position: absolute;
  pointer-events: none;
  border: 1.5px solid var(--ids-button-primary-color-background-default);
  background: transparent;
  z-index: 2;
  transition: all 0.05s ease;
}`, "",{"version":3,"sources":["webpack://./src/components/ids-data-grid/ids-data-grid-filters.scss","webpack://./src/components/ids-data-grid/ids-data-grid.scss","webpack://./src/components/ids-data-grid/ids-data-grid-header.scss","webpack://./src/components/ids-data-grid/ids-data-grid-row.scss","webpack://./src/components/ids-data-grid/ids-data-grid-cell.scss","webpack://./src/themes/mixins/ids-hide-mixin.scss","webpack://./src/components/ids-popup-menu/ids-popup-menu.scss","webpack://./src/themes/mixins/ids-checkbox-mixin.scss","webpack://./src/themes/mixins/ids-radio-mixin.scss","webpack://./src/themes/mixins/ids-core-mixins.scss","webpack://./src/components/ids-data-grid/ids-data-grid-common.scss"],"names":[],"mappings":"AAAA,qCAAA;AACA;EACE,iFAAA;EACA,sGAAA;EACA,qFAAA;EACA,gCAAA;EACA,gDAAA;ACCF;ADCE;EACE,mDAAA;EAEA,gBAAA;ACAJ;ADGE;EAIE,cAAA;ACJJ;ADOE;EACE,mBAAA;EACA,aAAA;EACA,kBAAA;ACLJ;ADQE;EACE,kBAAA;EACA,oCAAA;ACNJ;ADSE;EACE,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,yCAAA;EACA,uCAAA;EACA,sCAAA;ACPJ;ADSI;EACE,aAAA;ACPN;ADUI;EACE,gBAAA;EACA,8BAAA;ACRN;ADcM;;;EAGE,yBAAA;ACZR;ADiBE;EACE,sCAAA;EACA,qCAAA;EAEA,sBAAA;EACA,sBAAA;AChBJ;ADkBI;EACE,wBAAA;EACA,uBAAA;AChBN;ADmBI;EACE,uBAAA;ACjBN;;ACxDA,qCAAA;AACA;EACE,gBAAA;EACA,0BAAA;EACA,UAAA;EAOA,iCAAA;ADqDF;AC1DE;EACE,UAAA;AD4DJ;;ACpDA;EACE,WAAA;ADuDF;ACrDE;EACE,eAAA;ADuDJ;ACpDE;EACE,oBAAA;EACA,8DAAA;ADsDJ;AClDE;EACE,uEAAA;EACA,+DAAA;ADoDJ;;AC/CA;EACE,uEAAA;EACA,oEAAA;EACA,sEAAA;EACA,gBAAA;EACA,kBAAA;ADkDF;AC/CE;EACE,uDAAA;ADiDJ;AC9CE;EACE,oEAAA;ADgDJ;AC7CE;EAEE,uBAAA;AD8CJ;AC3CE;EAEE,yBAAA;AD4CJ;ACzCE;EACE,mDAAA;EACA,yBAAA;AD2CJ;ACvCI;EACE,yCAAA;ADyCN;ACpCE;EACE,gCAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,qCAAA;EACA,0BAAA;EACA,UAAA;EACA,UAAA;ADsCJ;AClCE;EACE,8BAAA;EACA,eAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,uCAAA;EACA,0BAAA;EACA,2BAAA;ADoCJ;AClCI;EACE,kBAAA;EACA,6CAAA;EACA,kDAAA;EACA,kBAAA;EACA,oBAAA;ADoCN;AChCE;EACE,qBAAA;EACA,2BAAA;ADkCJ;AC/BE;EACE,qCAAA;ADiCJ;AC9BE;EACE,8EAAA;EACA,0CAAA;EACA,cAAA;EACA,aAAA;EACA,kBAAA;EACA,0BAAA;EACA,YAAA;ADgCJ;AC7BE;EACE,2FAAA;AD+BJ;AC7BI;EACE,UAAA;AD+BN;AC3BE;EACE,UAAA;AD6BJ;ACzBE;EACE,sEAAA;EACA,gBAAA;EACA,UAAA;AD2BJ;ACvBE;EACE,qEAAA;ADyBJ;ACvBI;EACE,uDAAA;ADyBN;ACrBE;EACE,gBAAA;EACA,2BAAA;EACA,UAAA;ADuBJ;ACnBM;EACE,qDAAA;ADqBR;ACtBM;EACE,qDAAA;ADwBR;ACzBM;EACE,qDAAA;AD2BR;AC5BM;EACE,qDAAA;AD8BR;AC/BM;EACE,qDAAA;ADiCR;AClCM;EACE,qDAAA;ADoCR;ACrCM;EACE,qDAAA;ADuCR;ACxCM;EACE,qDAAA;AD0CR;AC3CM;EACE,sDAAA;AD6CR;ACxCE;EACE,gBAAA;EACA,4BAAA;AD0CJ;ACvCI;EACE,oBAAA;ADyCN;;ACpCA;EACE,aAAA;ADuCF;;ACpCA;EACE,cAAA;EACA,+CAAA;EACA,4CAAA;EACA,4CAAA;EACA,6CAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;EACA,mBAAA;ADuCF;ACrCE;EACE,0CAAA;EACA,4CAAA;ADuCJ;;ACnCA;EACE,kBAAA;EACA,6CAAA;EACA,yCAAA;EACA,wCAAA;ADsCF;;AClCA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;EACA,gBAAA;EACA,2BAAA;EACA,yBAAA;EACA,sBAAA;EACA,WAAA;ADqCF;;AChCE;EACE,sDAAA;EACA,UAAA;EACA,kDAAA;ADmCJ;ACjCI;EACE,kBAAA;EACA,yBAAA;EACA,yBAAA;ADmCN;AChCI;EACE,kBAAA;EACA,UAAA;ADkCN;AC9BE;EACE,eAAA;ADgCJ;AC9BI;EACE,UAAA;ADgCN;;AC3BA;EACE,aAAA;EACA,gBAAA;EACA,iCAAA;EACA,iDAAA;EACA,wCAAA;AD8BF;AC5BE;EACE,wDAAA;AD8BJ;;AC1BA;EACE,yBAAA;AD6BF;;AC1BA;;EAEE,cAAA;AD6BF;;AC1BA;EACE,2CAAA;EACA,yCAAA;AD6BF;;ACxBE;;EACE,yCAAA;AD4BJ;;ACtBE;EACE,oDAAA;EACA,UAAA;ADyBJ;ACtBE;EACE,UAAA;ADwBJ;;AClBE;EACE,UAAA;ADqBJ;AClBE;EACE,oDAAA;EACA,UAAA;ADoBJ;;ACfA;EACE,aAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;ADkBF;AChBE;EAEE,kCAAA;EACA,mCAAA;EACA,WAAA;EACA,qBAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,QAAA;ADiBJ;ACdE;EACE,6EAAA;EACA,SAAA;ADgBJ;ACbE;EACE,gFAAA;EACA,YAAA;ADeJ;;ACVA;EACE,iBAAA;ADaF;;ACVA;EACE,mBAAA;ADaF;;ACPE;EACE,mEAAA;EACA,2DAAA;ADUJ;ACPE;EACE,kDAAA;ADSJ;ACJI;EACE,sDAAA;ADMN;ACFE;;EAEE,2DAAA;ADIJ;ACCI;EACE,wEAAA;ADCN;;ACKA;EACE,sBAAA;ADFF;;ACQI;EACE,+CAAA;ADLN;ACQI;EACE,yBAAA;ADNN;ACSI;EACE,yBAAA;ADPN;ACUI;EACE,qBAAA;ADRN;ACaI;EACE,+CAAA;ADXN;ACcI;EACE,aAAA;ADZN;ACeI;EACE,yBAAA;ADbN;ACkBI;EACE,+CAAA;ADhBN;ACmBI;EACE,aAAA;ADjBN;ACoBI;EACE,yBAAA;EACA,uBAAA;EACA,wBAAA;ADlBN;ACqBI;EACE,iCAAA;ADnBN;ACsBI;EACE,mDAAA;EACA,yBAAA;ADpBN;ACyBI;EACE,gDAAA;ADvBN;AC0BI;EACE,aAAA;ADxBN;AC2BI;EACE,0CAAA;EACA,wBAAA;EACA,YAAA;ADzBN;AC2BM;EACE,QAAA;ADzBR;AC4BM;EACE,UAAA;AD1BR;AC8BI;EACE,0CAAA;AD5BN;AC+BI;EACE,gBAAA;AD7BN;ACgCI;EACE,uBAAA;EACA,yBAAA;AD9BN;ACkCI;;;;EAIE,2BAAA;ADhCN;ACmCI;EACE,uDAAA;ADjCN;ACoCI;EACE,kEAAA;EACA,gEAAA;EACA,uDAAA;ADlCN;;ACyCE;EACE,2BAAA;ADtCJ;ACwCI;EACE,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,UAAA;ADtCN;AC2CM;EACE,UAAA;ADzCR;AC8CM;EACE,UAAA;AD5CR;ACiDE;EACE,yBAAA;AD/CJ;;ACuDI;EACE,cAAA;ADpDN;ACuDI;EACE,qDAAA;ADrDN;ACwDI;EACE,gBAAA;EACA,4BAAA;ADtDN;AC0DQ;EACE,sDAAA;ADxDV;ACuDQ;EACE,sDAAA;ADrDV;ACoDQ;EACE,sDAAA;ADlDV;ACiDQ;EACE,sDAAA;AD/CV;AC8CQ;EACE,sDAAA;AD5CV;AC2CQ;EACE,sDAAA;ADzCV;ACwCQ;EACE,sDAAA;ADtCV;ACqCQ;EACE,sDAAA;ADnCV;ACkCQ;EACE,uDAAA;ADhCV;;AE/fA,mCAAA;AACA;EACE,aAAA;EACA,yDAAA;EACA,WAAA;AFkgBF;AEhgBE;EAEE,oEAAA;AFigBJ;AE9fE;EACE,aAAA;AFggBJ;AE3fM;EACE,mBAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,MAAA;AF6fR;AExfE;EACE,+DAAA;AF0fJ;AEvfM;EAKE,+DAAA;EACA,0DAAA;AFqfR;AE1fQ;EACI,yHAAA;AF4fZ;AEnfE;EACE,mEAAA;AFqfJ;AElfM;EAKE,mEAAA;EACA,0DAAA;AFgfR;AErfQ;EACE,iIAAA;AFufV;AE9eE;EACE,iEAAA;AFgfJ;AE7eM;EAKE,iEAAA;EACA,0DAAA;AF2eR;AEhfQ;EACE,6HAAA;AFkfV;;AEveA;EACE,mEAAA;EACA,2BAAA;AF0eF;AEveE;EACE,uDAAA;EACA,8DAAA;EACA,sBAAA;AFyeJ;AEteE;EACE,yDAAA;EACA,qDAAA;EAEA,cAAA;AFueJ;;AE/dI;EACE,0CAAA;AFkeN;AEheM;;EAEE,qDAAA;EACA,mDAAA;AFkeR;AE/dM;EACE,uCAAA;AFieR;AE7dI;EACE,qDAAA;EACA,qEAAA;AF+dN;AE5dI;EACE,qDAAA;AF8dN;AEzdI;EACE,0CAAA;AF2dN;AEzdM;;EAEE,qDAAA;EACA,mDAAA;AF2dR;AExdM;EACE,uCAAA;AF0dR;AEtdI;EACE,qDAAA;EACA,qEAAA;AFwdN;AErdI;EACE,qDAAA;AFudN;AEldI;EACE,0CAAA;EACA,4CAAA;AFodN;AEldM;;EAEE,qDAAA;EACA,mDAAA;AFodR;AEjdM;EACE,uCAAA;AFmdR;AE/cI;EACE,qDAAA;EACA,qEAAA;AFidN;AE9cI;EACE,qDAAA;AFgdN;AE3cI;EACE,2CAAA;EACA,4CAAA;AF6cN;AE3cM;;EAEE,sDAAA;EACA,oDAAA;AF6cR;AE1cM;EACE,wCAAA;AF4cR;AEtcQ;EACE,qDAAA;EACA,mDAAA;AFwcV;AEncI;EACE,sDAAA;EACA,qEAAA;AFqcN;AElcI;EACE,sDAAA;AFocN;;AE9bA;EACE,uEAAA;AFicF;;AE7bA;EACE,+DAAA;EACA,iBAAA;EACA,4BAAA;AFgcF;;AE5bA;EACE,kBAAA;EACA,0CAAA;AF+bF;;AE1bE;EACE,4BAAA;AF6bJ;AE3bI;EACE,iDAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AF6bN;AEzbE;EACE,gBAAA;EACA,aAAA;AF2bJ;AEvbE;;EAEE,0BAAA;AFybJ;;AEhbU;EACI,yHAAA;AFmbd;AE1aU;EACI,iIAAA;AF4ad;AEnaU;EACI,6HAAA;AFqad;;AG9rBA,oCAAA;AAGA,8DAAA;AAaA;EACE,mBAAA;AHmrBF;;AGhrBA;EACE,mBAAA;AHmrBF;;AGhrBA;EACE,mBAAA;AHmrBF;;AGhrBA;EACE,wBAAA;AHmrBF;;AG9qBI;EACE,uDAAA;AHirBN;AG9qBI;EACE,uDAAA;AHgrBN;AG3qBI;EACE,iEAAA;AH6qBN;;AGxqBA;EAEE,mBAAA;EACA,8BAAA;EACA,2BAAA;EACA,oDAAA;EACA,oBAAA;EACA,mDAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AH0qBF;AGvqBE;EACE,uDAAA;AHyqBJ;AGrqBE;EACE,uCAAA;EACA,wCAAA;AHuqBJ;AGpqBE;EACE,yCAAA;EACA,uCAAA;AHsqBJ;AGlqBE;EACE,0CAAA;AHoqBJ;AGjqBE;EACE,2BAAA;EACA,qBAAA;EACA,6BAAA;EACA,qBAAA;AHmqBJ;AGhqBE;EACE,qBAAA;EACA,sBAAA;EACA,yCAAA;EACA,uCAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;AHkqBJ;AG9pBE;EACE,sBAAA;AHgqBJ;AG9pBI;EACE,sBAAA;EACA,iBAAA;EACA,oCAAA;AHgqBN;AG1pBI;EACE,oBAAA;EACA,kCAAA;AH4pBN;AGvpBI;EACE,yBAAA;EACA,wCAAA;AHypBN;AGtpBI;EACE,iBAAA;AHwpBN;AGnpBE;EACE,4EAAA;AHqpBJ;AGnpBI;EACE,aAAA;AHqpBN;AGjpBE;EACE,oDAAA;AHmpBJ;AGjpBI;EACE,aAAA;AHmpBN;AG/oBE;EACE,yBAAA;AHipBJ;AG1oBI;EACE,gCAAA;EACA,gDAAA;EACA,oBAAA;AH4oBN;AGtoBM;EACE,qEAAA;AHwoBR;AGloBQ;EACE,YAAA;EACA,WAAA;AHooBV;AGjoBQ;EACE,YAAA;EACA,WAAA;AHmoBV;AGhoBQ;EACE,mBAAA;EACA,aAAA;EACA,YAAA;EACA,oBAAA;EACA,WAAA;AHkoBV;AG/nBQ;EACE,uBAAA;AHioBV;AG7nBM;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;AH+nBR;AG7nBQ;EACE,uBAAA;AH+nBV;AG1nBI;EAGE,8BAAA;AH0nBN;AGxnBM;EACE,yCAAA;AH0nBR;AGpnBM;EACE,yBAAA;EACA,uBAAA;AHsnBR;AGjnBM;EACE,SAAA;EACA,aAAA;EACA,WAAA;AHmnBR;AGhnBM;;EAEE,8CAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,SAAA;AHknBR;AG9mBI;EACE,uBAAA;EACA,wCAAA;EACA,aAAA;AHgnBN;AG9mBM;EACE,oBAAA;AHgnBR;AG9mBQ;EACE,eAAA;AHgnBV;AG3mBI;EACE,cAAA;AH6mBN;AGvmBM;EACE,aAAA;AHymBR;AGtmBM;EACE,gCAAA;AHwmBR;AGpmBI;EACE,8BAAA;AHsmBN;AGpmBM;EACE,sCAAA;AHsmBR;AGjmBE;EACE,mCAAA;EACA,yEAAA;EACA,6DAAA;EAMA,aAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;AH8lBJ;AGvmBI;EACE,gFAAA;AHymBN;AG7lBE;EAGE,iBAAA;AH6lBJ;AG1lBE;EACE,WAAA;AH4lBJ;AGvlBI;EACE,WAAA;AHylBN;AGtlBI;EACE,4BAAA;AHwlBN;AGnlBE;EACE,gBAAA;AHqlBJ;AGnlBI;EACE,+BAAA;AHqlBN;AGhlBE;EACE,gBAAA;AHklBJ;AG9kBE;EACE,yBAAA;AHglBJ;AG9kBI;;;EAGE,yBAAA;AHglBN;AG3kBE;EACE,gBAAA;EACA,UAAA;AH6kBJ;AGzkBE;EACE,mEAAA;AH2kBJ;AGzkBI;EACE,uDAAA;AH2kBN;AGvkBE;EACE,gBAAA;EACA,2BAAA;AHykBJ;AGrkBM;EACE,qDAAA;AHukBR;AGxkBM;EACE,qDAAA;AH0kBR;AG3kBM;EACE,qDAAA;AH6kBR;AG9kBM;EACE,qDAAA;AHglBR;AGjlBM;EACE,qDAAA;AHmlBR;AGplBM;EACE,qDAAA;AHslBR;AGvlBM;EACE,qDAAA;AHylBR;AG1lBM;EACE,qDAAA;AH4lBR;AG7lBM;EACE,sDAAA;AH+lBR;AG1lBE;EACE,gBAAA;EACA,4BAAA;AH4lBJ;AGzlBE;EAvXA,qJAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;EACA,qBAAA;EACA,mCAAA;EACA,kBAAA;EACA,uCAAA;EACA,UAAA;AHm9BF;AG9lBM;EACE,aAAA;EACA,aAAA;AHgmBR;AG7lBM;EACE,kBAAA;AH+lBR;AG7lBQ;EArYN,qJAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;EACA,qBAAA;EACA,mCAAA;EACA,kBAAA;EACA,uCAAA;EACA,UAAA;AHq+BF;AGlmBI;EACE,kBAAA;EACA,sBAAA;AHomBN;AGhmBM;EACE,0CAAA;EACA,yCAAA;AHkmBR;AG7lBE;EACE,sBAAA;EACA,kBAAA;AH+lBJ;AG5lBE;EACE,kEAAA;AH8lBJ;AG3lBE;EACE,oEAAA;AH6lBJ;AG1lBE;EACE,eAAA;AH4lBJ;AGzlBE;EACE,8BAAA;AH2lBJ;AGxlBE;EACE,gDAAA;AH0lBJ;AGzkBU;EACE,uBAAA;EACA,uBAAA;AH2kBZ;AG7kBU;EACE,uCAAA;EACA,uBAAA;AH+kBZ;AGjlBU;EACE,uBAAA;EACA,uBAAA;AHmlBZ;AGrlBU;EACE,uCAAA;EACA,uBAAA;AHulBZ;;AG1kBI;EACE,wCAAA;AH6kBN;AGzkBE;EACE,iBAAA;EACA,sBAAA;EACA,wBAAA;AH2kBJ;AGxkBE;EACE,kBAAA;EACA,QAAA;AH0kBJ;AGvkBE;EACE,+CAAA;AHykBJ;AGtkBE;EACE,6EAAA;AHwkBJ;AGrkBE;EACE,iEAAA;AHukBJ;AGpkBE;;EAEE,kBAAA;EACA,2DAAA;AHskBJ;AGlkBI;EACE,0CAAA;EACA,yCAAA;AHokBN;AGjkBI;EACE,8CAAA;AHmkBN;AG9jBE;EACE,uCAAA;AHgkBJ;AG5jBE;EACE,uCAAA;AH8jBJ;AG3jBE;EACE,0EAAA;AH6jBJ;AG1jBE;EACE,mDAAA;EAEA,2DAAA;AH2jBJ;AGvjBI;EACE,gDAAA;AHyjBN;AGtjBI;EACE,uCAAA;AHwjBN;;AG7iBI;EACE,uCAAA;AHgjBN;AG5iBE;EACE,iBAAA;AH8iBJ;AG3iBE;EACE,kBAAA;EACA,QAAA;AH6iBJ;AG1iBE;EACE,8BAAA;AH4iBJ;AGziBE;EACE,6EAAA;AH2iBJ;AGxiBE;EACE,iEAAA;AH0iBJ;AGviBE;EACE,2DAAA;AHyiBJ;AGviBI;EACE,0CAAA;EACA,yCAAA;AHyiBN;AGpiBE;EACE,uCAAA;AHsiBJ;AGliBE;EACE,uCAAA;AHoiBJ;AGjiBE;EACE,0EAAA;EACA,2DAAA;AHmiBJ;AGhiBE;EACE,mDAAA;AHkiBJ;AG9hBI;EACE,+CAAA;AHgiBN;;AGrhBI;EACE,uCAAA;AHwhBN;AGphBE;EACE,+CAAA;AHshBJ;AGlhBE;EACE,sBAAA;AHohBJ;AGhhBE;EACE,sBAAA;EACA,qBAAA;AHkhBJ;AG/gBE;EACE,0EAAA;AHihBJ;AG7gBI;EACE,+CAAA;AH+gBN;;AGpgBI;EACE,uCAAA;AHugBN;AGlgBE;EACE,sBAAA;AHogBJ;AGjgBE;EACE,kDAAA;AHmgBJ;AGhgBE;EACE,0EAAA;AHkgBJ;AGhgBI;EACE,kBAAA;EACA,UAAA;AHkgBN;AG7fI;EACE,+CAAA;AH+fN;;AGpfI;EACE,+CAAA;AHufN;;AG/eE;EACE,uDAAA;EACA,oEAAA;AHkfJ;AGhfI;EACE,qEAAA;AHkfN;AG/eI;EACE,oDAAA;AHifN;AG7eE;EACE,aAAA;AH+eJ;;AG1eA;EACE,mBAAA;EACA,yCAAA;EACA,uCAAA;AH6eF;;AGveI;EACE,qDAAA;AH0eN;AGpeI;EACE,gBAAA;EACA,4BAAA;AHseN;AGleQ;EACE,sDAAA;AHoeV;AGreQ;EACE,sDAAA;AHueV;AGxeQ;EACE,sDAAA;AH0eV;AG3eQ;EACE,sDAAA;AH6eV;AG9eQ;EACE,sDAAA;AHgfV;AGjfQ;EACE,sDAAA;AHmfV;AGpfQ;EACE,sDAAA;AHsfV;AGvfQ;EACE,sDAAA;AHyfV;AG1fQ;EACE,uDAAA;AH4fV;AGvfI;EACE,qDAAA;AHyfN;AGrfM;EAEE,qJAAA;AHsfR;;AG/eA;EACE,wCAAA;AHkfF;;AIvuCA;EACE,aAAA;AJ0uCF;;AItuCE;EADF;IAEI,aAAA;EJ0uCF;AACF;;AIhuCE;EADF;IAEI,aAAA;EJouCF;AACF;;AI1tCE;EADF;IAEI,aAAA;EJ8tCF;AACF;;AIptCE;EADF;IAEI,aAAA;EJwtCF;AACF;;AI9sCE;EADF;IAEI,aAAA;EJktCF;AACF;;AIxsCE;EADF;IAEI,aAAA;EJ4sCF;AACF;;AIlsCE;EADF;IAEI,aAAA;EJssCF;AACF;;AI5rCE;EADF;IAEI,aAAA;EJgsCF;AACF;;AItrCE;EADF;IAEI,aAAA;EJ0rCF;AACF;;AIhrCE;EADF;IAEI,aAAA;EJorCF;AACF;;AI1qCE;EADF;IAEI,aAAA;EJ8qCF;AACF;;AIpqCE;EADF;IAEI,aAAA;EJwqCF;AACF;;AIxsCE;EC5GF;ID6GI,aAAA;EJ4sCF;AACF;;AKrzCE;EACE,cAAA;EACA,8BAAA;ALwzCJ;;AMj0CA;;EAAA;AAoIA;EACE;IACE,SAAA;IACA,OAAA;IACA,QAAA;IACA,QAAA;ENmsCF;EMhsCA;IACE,SAAA;IACA,OAAA;IACA,QAAA;IACA,UAAA;ENksCF;EM/rCA;IACE,YAAA;IACA,SAAA;IACA,MAAA;IACA,UAAA;ENisCF;AACF;AM9rCA;EACE;IACE,QAAA;ENgsCF;EM7rCA;IACE,WAAA;EN+rCF;AACF;AOj2CA;;EAAA;APWA;EACE,4DAAA;EAEA,kBAAA;AA01CF;;AAv1CA;EAEE,uDAAA;EACA,wDAAA;EACA,2CAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,WAAA;EAGA,oBAAA;EACA,yBAAA;EQnBA,mCAAA;EACA,kCAAA;ERuBA,+EAAA;EACA,kCAAA;AAq1CF;AAl1CE;EACE,iCAAA;EACA,aAAA;EACA,WAAA;AAo1CJ;AA/0CI;;EAEE,sBAAA;AAi1CN;AA50CI;EACE,uBAAA;AA80CN;AAz0CI;EACE,oBAAA;AA20CN;AAv0CE;EMxDA,kBAAA;EACA,kCAAA;EACA,gDAAA;EACA,YAAA;EACA,WAAA;EACA,OAAA;EACA,QAAA;ENyDE,6DAAA;EACA,kBAAA;EACA,2BAAA;EACA,0BAAA;AA00CJ;AAj1CI;EACE,iCAAA;AAm1CN;AA30CI;EMbF,+DAAA;EACA,uDAAA;EACA,iCAAA;ENcI,YAAA;AA80CN;AA30CI;EM3DF,+DAAA;EACA,uDAAA;ANy4CF;AA50CM;EMzDJ,kBAAA;EACA,cAAA;EACA,sFAAA;EACA,6DAAA;EACA,sBAAA;EACA,wBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,MAAA;EACA,UAAA;ENkDM,eAAA;AAu1CR;AAp1CM;EMlBJ,wEAAA;EACA,gEAAA;ANy2CF;AAn1CI;EMrDF,oEAAA;EACA,4DAAA;AN24CF;AAp1CM;EMnDJ,kBAAA;EACA,mCAAA;EACA,cAAA;EACA,sEAAA;EACA,4DAAA;EACA,WAAA;EACA,WAAA;EACA,SAAA;EACA,MAAA;EACA,eAAA;EACA,WAAA;EN4CM,eAAA;AA+1CR;AAz1CE;EACE,aAAA;EACA,uBAAA;EACA,WAAA;AA21CJ;AAx1CE;EO1GA,kBAAA;EACA,uDAAA;EACA,6CAAA;EACA,YAAA;EACA,OAAA;EACA,QAAA;EACA,0EAAA;EACA,WAAA;EPsGE,iCAAA;EACA,kBAAA;EACA,2BAAA;EACA,0BAAA;AAg2CJ;AA91CI;EOvGF,kBAAA;EACA,mDAAA;EACA,mDAAA;EACA,6CAAA;EACA,WAAA;EACA,SAAA;EACA,SAAA;EACA,QAAA;EACA,iEAAA;EACA,QAAA;APw8CF;AAt2CI;EOrEF,oDAAA;EACA,iCAAA;EACA,gBAAA;EACA,0CAAA;AP86CF;AAx2CI;EOzFF,4DAAA;EACA,oDAAA;APo8CF;AAz2CM;EOvFJ,kEAAA;EACA,8DAAA;EACA,iBAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;APm8CF;AA92CM;EOjEJ,qEAAA;EACA,6DAAA;EACA,0CAAA;APk7CF;AA52CE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AA82CJ;AA52CI;EACE,0CAAA;AA82CN;AA32CI;EACE,0CAAA;EACA,yCAAA;AA62CN;AA12CI;EACE,0EAAA;EACA,sEAAA;EACA,4EAAA;EACA,wEAAA;AA42CN;AAx2CM;EACE,0CAAA;AA02CR;AAr2CE;EACE,oBAAA;EACA,mBAAA;AAu2CJ;AAxxCc;EACE,sBAAA;EACA,wBAAA;AA0xChB;AAnxCc;EACE,sBAAA;EACA,wBAAA;AAqxChB;AA7wCU;ES5QR,kBAAA;AT4hDF;AS1hDE;EACE,uDAAA;EACA,2CAAA;EACA,sBAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,wBAAA;EACA,kBAAA;EACA,uBAAA;AT4hDJ;AAtxCY;ESjRV,kBAAA;EToRY,uBAAA;AAuxCd;ASziDE;EACE,uDAAA;EACA,2CAAA;EACA,sBAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,wBAAA;EACA,kBAAA;EACA,uBAAA;AT2iDJ;AAhyCc;EACE,uBAAA;AAkyChB;AA1xCM;EACE,2CAAA;AA4xCR;AApxCY;EACE,yBAAA;AAsxCd;AAnxCY;EACE,0CAAA;AAqxCd;AAlxCY;EACE,0CAAA;AAoxCd;AAhwCc;EACE,sBAAA;EACA,wBAAA;AAkwChB;AArxCY;EACE,yBAAA;AAuxCd;AApxCY;EACE,yBAAA;AAsxCd;AAnxCY;EACE,0CAAA;AAqxCd;AA7wCc;EACE,sBAAA;EACA,wBAAA;AA+wChB;AAlyCY;EACE,yBAAA;AAoyCd;AAjyCY;EACE,yBAAA;AAmyCd;AAhyCY;EACE,0CAAA;AAkyCd;AA1xCc;EACE,sBAAA;EACA,wBAAA;AA4xChB;AA/yCY;EACE,yBAAA;AAizCd;AA9yCY;EACE,yBAAA;AAgzCd;AA7yCY;EACE,0CAAA;AA+yCd;AAvyCc;EACE,sBAAA;EACA,wBAAA;AAyyChB;AA5zCY;EACE,yBAAA;AA8zCd;AA3zCY;EACE,yBAAA;AA6zCd;AA1zCY;EACE,0CAAA;AA4zCd;AApzCc;EACE,sBAAA;EACA,wBAAA;AAszChB;AAz0CY;EACE,0BAAA;AA20Cd;AAx0CY;EACE,yBAAA;AA00Cd;AAv0CY;EACE,0CAAA;AAy0Cd;AAj0Cc;EACE,sBAAA;EACA,wBAAA;AAm0ChB;AAt1CY;EACE,0BAAA;AAw1Cd;AAr1CY;EACE,yBAAA;AAu1Cd;AAp1CY;EACE,0CAAA;AAs1Cd;AA90Cc;EACE,sBAAA;EACA,wBAAA;AAg1ChB;AAn2CY;EACE,0BAAA;AAq2Cd;AAl2CY;EACE,yBAAA;AAo2Cd;AAj2CY;EACE,0CAAA;AAm2Cd;AA31Cc;EACE,sBAAA;EACA,wBAAA;AA61ChB;AA36Cc;EACE,sBAAA;EACA,wBAAA;AA66ChB;AAt6Cc;EACE,sBAAA;EACA,wBAAA;AAw6ChB;AAh6CU;ES5QR,kBAAA;AT+qDF;AS7qDE;EACE,uDAAA;EACA,2CAAA;EACA,sBAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,wBAAA;EACA,kBAAA;EACA,uBAAA;AT+qDJ;AAz6CY;ESjRV,kBAAA;EToRY,uBAAA;AA06Cd;AS5rDE;EACE,uDAAA;EACA,2CAAA;EACA,sBAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,wBAAA;EACA,kBAAA;EACA,uBAAA;AT8rDJ;AAn7Cc;EACE,uBAAA;AAq7ChB;AA76CM;EACE,2CAAA;AA+6CR;AAv6CY;EACE,yBAAA;AAy6Cd;AAt6CY;EACE,0CAAA;AAw6Cd;AAr6CY;EACE,0CAAA;AAu6Cd;AAn5Cc;EACE,sBAAA;EACA,wBAAA;AAq5ChB;AAx6CY;EACE,yBAAA;AA06Cd;AAv6CY;EACE,yBAAA;AAy6Cd;AAt6CY;EACE,0CAAA;AAw6Cd;AAh6Cc;EACE,sBAAA;EACA,wBAAA;AAk6ChB;AAr7CY;EACE,yBAAA;AAu7Cd;AAp7CY;EACE,yBAAA;AAs7Cd;AAn7CY;EACE,0CAAA;AAq7Cd;AA76Cc;EACE,sBAAA;EACA,wBAAA;AA+6ChB;AAl8CY;EACE,yBAAA;AAo8Cd;AAj8CY;EACE,yBAAA;AAm8Cd;AAh8CY;EACE,0CAAA;AAk8Cd;AA17Cc;EACE,sBAAA;EACA,wBAAA;AA47ChB;AA/8CY;EACE,yBAAA;AAi9Cd;AA98CY;EACE,yBAAA;AAg9Cd;AA78CY;EACE,0CAAA;AA+8Cd;AAv8Cc;EACE,sBAAA;EACA,wBAAA;AAy8ChB;AA59CY;EACE,0BAAA;AA89Cd;AA39CY;EACE,yBAAA;AA69Cd;AA19CY;EACE,0CAAA;AA49Cd;AAp9Cc;EACE,sBAAA;EACA,wBAAA;AAs9ChB;AAz+CY;EACE,0BAAA;AA2+Cd;AAx+CY;EACE,yBAAA;AA0+Cd;AAv+CY;EACE,0CAAA;AAy+Cd;AAj+Cc;EACE,sBAAA;EACA,wBAAA;AAm+ChB;AAt/CY;EACE,0BAAA;AAw/Cd;AAr/CY;EACE,0BAAA;AAu/Cd;AAp/CY;EACE,0CAAA;AAs/Cd;AA9+Cc;EACE,sBAAA;EACA,wBAAA;AAg/ChB;AA9jDc;EACE,sBAAA;EACA,wBAAA;AAgkDhB;AAzjDc;EACE,sBAAA;EACA,wBAAA;AA2jDhB;AAnjDU;ES5QR,kBAAA;ATk0DF;ASh0DE;EACE,uDAAA;EACA,2CAAA;EACA,sBAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,wBAAA;EACA,kBAAA;EACA,uBAAA;ATk0DJ;AA5jDY;ESjRV,kBAAA;EToRY,uBAAA;AA6jDd;AS/0DE;EACE,uDAAA;EACA,2CAAA;EACA,sBAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,wBAAA;EACA,kBAAA;EACA,uBAAA;ATi1DJ;AAtkDc;EACE,uBAAA;AAwkDhB;AAhkDM;EACE,2CAAA;AAkkDR;AA1jDY;EACE,yBAAA;AA4jDd;AAzjDY;EACE,0CAAA;AA2jDd;AAxjDY;EACE,0CAAA;AA0jDd;AAtiDc;EACE,sBAAA;EACA,wBAAA;AAwiDhB;AA3jDY;EACE,yBAAA;AA6jDd;AA1jDY;EACE,yBAAA;AA4jDd;AAzjDY;EACE,0CAAA;AA2jDd;AAnjDc;EACE,sBAAA;EACA,wBAAA;AAqjDhB;AAxkDY;EACE,yBAAA;AA0kDd;AAvkDY;EACE,yBAAA;AAykDd;AAtkDY;EACE,0CAAA;AAwkDd;AAhkDc;EACE,sBAAA;EACA,wBAAA;AAkkDhB;AArlDY;EACE,yBAAA;AAulDd;AAplDY;EACE,yBAAA;AAslDd;AAnlDY;EACE,0CAAA;AAqlDd;AA7kDc;EACE,sBAAA;EACA,wBAAA;AA+kDhB;AAlmDY;EACE,0BAAA;AAomDd;AAjmDY;EACE,yBAAA;AAmmDd;AAhmDY;EACE,0CAAA;AAkmDd;AA1lDc;EACE,sBAAA;EACA,wBAAA;AA4lDhB;AA/mDY;EACE,0BAAA;AAinDd;AA9mDY;EACE,yBAAA;AAgnDd;AA7mDY;EACE,0CAAA;AA+mDd;AAvmDc;EACE,sBAAA;EACA,wBAAA;AAymDhB;AA5nDY;EACE,0BAAA;AA8nDd;AA3nDY;EACE,yBAAA;AA6nDd;AA1nDY;EACE,0CAAA;AA4nDd;AApnDc;EACE,sBAAA;EACA,wBAAA;AAsnDhB;AAzoDY;EACE,0BAAA;AA2oDd;AAxoDY;EACE,0BAAA;AA0oDd;AAvoDY;EACE,0CAAA;AAyoDd;AAjoDc;EACE,sBAAA;EACA,wBAAA;AAmoDhB;AAjtDc;EACE,sBAAA;EACA,wBAAA;AAmtDhB;AA5sDc;EACE,sBAAA;EACA,wBAAA;AA8sDhB;AAtsDU;ES5QR,kBAAA;ATq9DF;ASn9DE;EACE,uDAAA;EACA,2CAAA;EACA,sBAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,wBAAA;EACA,kBAAA;EACA,uBAAA;ATq9DJ;AA/sDY;ESjRV,kBAAA;EToRY,wBAAA;AAgtDd;ASl+DE;EACE,uDAAA;EACA,2CAAA;EACA,sBAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,wBAAA;EACA,kBAAA;EACA,uBAAA;ATo+DJ;AAztDc;EACE,uBAAA;AA2tDhB;AAntDM;EACE,2CAAA;AAqtDR;AA7sDY;EACE,yBAAA;AA+sDd;AA5sDY;EACE,0CAAA;AA8sDd;AA3sDY;EACE,0CAAA;AA6sDd;AAzrDc;EACE,sBAAA;EACA,wBAAA;AA2rDhB;AA9sDY;EACE,yBAAA;AAgtDd;AA7sDY;EACE,yBAAA;AA+sDd;AA5sDY;EACE,0CAAA;AA8sDd;AAtsDc;EACE,sBAAA;EACA,wBAAA;AAwsDhB;AA3tDY;EACE,yBAAA;AA6tDd;AA1tDY;EACE,yBAAA;AA4tDd;AAztDY;EACE,0CAAA;AA2tDd;AAntDc;EACE,sBAAA;EACA,wBAAA;AAqtDhB;AAxuDY;EACE,yBAAA;AA0uDd;AAvuDY;EACE,yBAAA;AAyuDd;AAtuDY;EACE,0CAAA;AAwuDd;AAhuDc;EACE,sBAAA;EACA,wBAAA;AAkuDhB;AArvDY;EACE,0BAAA;AAuvDd;AApvDY;EACE,yBAAA;AAsvDd;AAnvDY;EACE,0CAAA;AAqvDd;AA7uDc;EACE,sBAAA;EACA,wBAAA;AA+uDhB;AAlwDY;EACE,0BAAA;AAowDd;AAjwDY;EACE,yBAAA;AAmwDd;AAhwDY;EACE,0CAAA;AAkwDd;AA1vDc;EACE,sBAAA;EACA,wBAAA;AA4vDhB;AA/wDY;EACE,0BAAA;AAixDd;AA9wDY;EACE,0BAAA;AAgxDd;AA7wDY;EACE,0CAAA;AA+wDd;AAvwDc;EACE,sBAAA;EACA,wBAAA;AAywDhB;AA5xDY;EACE,0BAAA;AA8xDd;AA3xDY;EACE,0BAAA;AA6xDd;AA1xDY;EACE,0CAAA;AA4xDd;AApxDc;EACE,sBAAA;EACA,wBAAA;AAsxDhB;AAp2Dc;EACE,sBAAA;EACA,wBAAA;AAs2DhB;AA/1Dc;EACE,sBAAA;EACA,wBAAA;AAi2DhB;AAz1DU;ES5QR,kBAAA;ATwmEF;AStmEE;EACE,uDAAA;EACA,2CAAA;EACA,sBAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,wBAAA;EACA,kBAAA;EACA,uBAAA;ATwmEJ;AAl2DY;ESjRV,kBAAA;EToRY,wBAAA;AAm2Dd;ASrnEE;EACE,uDAAA;EACA,2CAAA;EACA,sBAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,wBAAA;EACA,kBAAA;EACA,uBAAA;ATunEJ;AA52Dc;EACE,wBAAA;AA82DhB;AAt2DM;EACE,2CAAA;AAw2DR;AAh2DY;EACE,yBAAA;AAk2Dd;AA/1DY;EACE,0CAAA;AAi2Dd;AA91DY;EACE,0CAAA;AAg2Dd;AA50Dc;EACE,sBAAA;EACA,wBAAA;AA80DhB;AAj2DY;EACE,yBAAA;AAm2Dd;AAh2DY;EACE,yBAAA;AAk2Dd;AA/1DY;EACE,0CAAA;AAi2Dd;AAz1Dc;EACE,sBAAA;EACA,wBAAA;AA21DhB;AA92DY;EACE,yBAAA;AAg3Dd;AA72DY;EACE,yBAAA;AA+2Dd;AA52DY;EACE,0CAAA;AA82Dd;AAt2Dc;EACE,sBAAA;EACA,wBAAA;AAw2DhB;AA33DY;EACE,yBAAA;AA63Dd;AA13DY;EACE,yBAAA;AA43Dd;AAz3DY;EACE,0CAAA;AA23Dd;AAn3Dc;EACE,sBAAA;EACA,wBAAA;AAq3DhB;AAx4DY;EACE,0BAAA;AA04Dd;AAv4DY;EACE,yBAAA;AAy4Dd;AAt4DY;EACE,0CAAA;AAw4Dd;AAh4Dc;EACE,sBAAA;EACA,wBAAA;AAk4DhB;AAr5DY;EACE,0BAAA;AAu5Dd;AAp5DY;EACE,yBAAA;AAs5Dd;AAn5DY;EACE,0CAAA;AAq5Dd;AA74Dc;EACE,sBAAA;EACA,wBAAA;AA+4DhB;AAl6DY;EACE,0BAAA;AAo6Dd;AAj6DY;EACE,0BAAA;AAm6Dd;AAh6DY;EACE,0CAAA;AAk6Dd;AA15Dc;EACE,sBAAA;EACA,wBAAA;AA45DhB;AA/6DY;EACE,0BAAA;AAi7Dd;AA96DY;EACE,0BAAA;AAg7Dd;AA76DY;EACE,0CAAA;AA+6Dd;AAv6Dc;EACE,sBAAA;EACA,wBAAA;AAy6DhB;AA/5DE;EACE,0CAAA;AAi6DJ;AA75DE;EACE,kBAAA;EACA,gBAAA;AA+5DJ;AA75DI;EACE,kBAAA;AA+5DN;;AAz5DA;EACE,sBAAA;AA45DF;;AAx5DA;EACE,cAAA;EACA,yDAAA;EACA,oBAAA;AA25DF;;AAv5DA;EACE,kBAAA;AA05DF;AAx5DE;EACE,aAAA;EACA,WAAA;EACA,iCAAA;EACA,mBAAA;EACA,oBAAA;AA05DJ;;AAt5DA;;EAEE,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,0BAAA;EACA,oBAAA;EACA,+BAAA;AAy5DF;;AAp5DE;EACE,wBAAA;AAu5DJ;AAp5DE;EACE,wBAAA;AAs5DJ;AAn5DE;EACE,wBAAA;AAq5DJ;AAl5DE;EACE,wBAAA;AAo5DJ;AAj5DE;EACE,wBAAA;AAm5DJ;AAh5DE;EACE,wBAAA;AAk5DJ;;AA94DA;EACE,wBAAA;AAi5DF;;AA94DA;EACE,2CAAA;AAi5DF;;AA74DA;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,0BAAA;AAg5DF;AA94DE;EACE,aAAA;AAg5DJ;;AA34DE;;EAEE,iEAAA;AA84DJ;AA34DE;EACE,wEAAA;AA64DJ;;AAz4DA;EACE,kDAAA;EACA,2GAAA;EACA,6BAAA;AA44DF;AA14DE;EACE,oFAAA;EACA,qFAAA;EAEA,mBAAA;EACA,6CAAA;AA24DJ;AAx4DE;EACE,kBAAA;EACA,mCAAA;AA04DJ;AAv4DE;EACE,6EAAA;EACA,oFAAA;EACA,sEAAA;EACA,oEAAA;EACA,oEAAA;EACA,qCAAA;EACA,+DAAA;EACA,wFAAA;EAEA,mBAAA;EACA,0CAAA;EACA,gBAAA;EACA,gBAAA;EACA,0BAAA;EACA,UAAA;AAw4DJ;AAr4DE;EACE,WAAA;AAu4DJ;AAp4DE;EACE,kBAAA;EACA,yBAAA;AAs4DJ;AAn4DE;EACE,WAAA;AAq4DJ;AAl4DE;EACE,iDAAA;EAEA,cAAA;EACA,+CAAA;AAm4DJ;;AA93DA;EACE,kBAAA;EACA,oBAAA;EACA,sEAAA;EACA,uBAAA;EACA,UAAA;EACA,0BAAA;AAi4DF","sourcesContent":["/* Ids Data Grid Component - Filter */\n.ids-data-grid {\n  --ids-button-formatter-color-text-default: var(--ids-data-grid-filter-icon-color);\n  --ids-button-formatter-color-background-hover: var(--ids-data-grid-filter-icon-color-background-hover);\n  --ids-button-formatter-color-text-hover: var(--ids-data-grid-filter-icon-color-hover);\n  --ids-menu-item-width-min: 190px;\n  --ids-trigger-field-button-inset-inline-start: 0;\n\n  .ids-data-grid-header-cell-filter-wrapper ids-dropdown {\n    --ids-trigger-field-button-inset-inline-start: -1px;\n\n    padding-top: 3px;\n  }\n\n  &[data-row-height='md'] ids-dropdown,\n  &[data-row-height='sm'] ids-dropdown,\n  &[data-row-height='xs'] ids-dropdown,\n  &[data-row-height='xxs'] ids-dropdown {\n    padding-top: 0;\n  }\n\n  ::slotted([slot^='filter-']) {\n    align-items: center;\n    display: flex;\n    position: relative;\n  }\n\n  .ids-data-grid-header-cell-content.vertical-align-center {\n    position: relative;\n    top: calc(50% - var(--ids-space-sm));\n  }\n\n  .ids-data-grid-header-cell-filter-wrapper {\n    align-items: center;\n    display: flex;\n    position: relative;\n    padding-inline-start: var(--ids-space-xs);\n    padding-inline-end: var(--ids-space-xs);\n    padding-block-end: var(--ids-space-xs);\n\n    &.hidden {\n      display: none;\n    }\n\n    ids-dropdown[compact] ids-list-box-option {\n      font-size: unset;\n      min-height: var(--ids-size-20);\n    }\n  }\n\n  .ids-data-grid-header-cell.is-uppercase {\n    .ids-data-grid-header-cell-filter-wrapper {\n      ids-list-box-option,\n      ids-dropdown::part(triggerfield-input),\n      ids-input::part(input) {\n        text-transform: uppercase;\n      }\n    }\n  }\n\n  [data-filter-conditions-button] {\n    --ids-button-icon-compact-height: 20px;\n    --ids-button-icon-compact-width: 36px;\n\n    margin-inline-end: 2px;\n    margin-inline-start: 0;\n\n    ids-icon {\n      margin-inline-start: 3px;\n      margin-inline-end: -3px;\n    }\n\n    ids-icon-button {\n      padding-inline-start: 0;\n    }\n  }\n}\n","@use 'sass:map';\n@use '../../themes/mixins/ids-core-mixins' as mixins;\n@use './ids-data-grid-common' as *;\n@use './ids-data-grid-filters' as *;\n@use './ids-data-grid-header' as *;\n@use './ids-data-grid-row' as *;\n@use './ids-data-grid-cell' as *;\n@use '../../components/ids-popup-menu/ids-popup-menu' as *;\n@use '../../themes/mixins/ids-checkbox-mixin' as *;\n@use '../../themes/mixins/ids-radio-mixin' as *;\n\n:host {\n  --ids-data-grid-column-widths: repeat(1, minmax(110px, 1fr));\n\n  position: relative;\n}\n\n.ids-data-grid {\n  // Outside border and Background and sizing\n  background-color: var(--ids-data-grid-color-background);\n  border: 1px solid var(--ids-data-grid-cell-color-border);\n  border-radius: var(--ids-border-radius-2xs);\n  border-collapse: collapse;\n  box-sizing: border-box;\n  overflow: auto;\n  width: 100%;\n\n  // Needed so sticky header works in safari\n  display: inline-grid;\n  align-content: flex-start;\n\n  // Font Info\n  @include mixins.antialiased();\n\n  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);\n  font-size: var(--ids-font-size-sm);\n\n  // Selection Checkbox\n  .ids-data-grid-checkbox-container {\n    cursor: var(--ids-cursor-pointer);\n    display: flex;\n    width: 100%;\n  }\n\n  // Checkbox alignments\n  .ids-data-grid-cell.align-left {\n    .ids-data-grid-tree-container,\n    .ids-data-grid-checkbox-container {\n      justify-content: start;\n    }\n  }\n\n  .ids-data-grid-cell.align-center {\n    .ids-data-grid-checkbox-container {\n      justify-content: center;\n    }\n  }\n\n  .ids-data-grid-cell.align-right {\n    .ids-data-grid-checkbox-container {\n      justify-content: end;\n    }\n  }\n\n  .ids-data-grid-checkbox {\n    @include checkbox-unchecked();\n\n    &.editable {\n      cursor: var(--ids-cursor-pointer);\n    }\n\n    border-color: var(--ids-data-grid-cell-checkbox-color-border);\n    position: relative;\n    left: var(--ids-space-none);\n    top: var(--ids-space-none);\n\n    &.disabled {\n      @include checkbox-disabled-unchecked();\n\n      opacity: 0.4;\n    }\n\n    &.checked {\n      @include checkbox-checked();\n\n      &::after {\n        @include checkbox-checked-after();\n\n        animation: none;\n      }\n\n      &.disabled {\n        @include checkbox-disabled-checked();\n      }\n    }\n\n    &.indeterminate {\n      @include checkbox-indeterminate();\n\n      &::after {\n        @include checkbox-indeterminate-after();\n\n        animation: none;\n      }\n    }\n  }\n\n  // Selection Radio\n  .ids-data-grid-radio-container {\n    display: flex;\n    justify-content: center;\n    width: 100%;\n  }\n\n  .ids-data-grid-radio {\n    @include radio-unchecked();\n\n    cursor: var(--ids-cursor-pointer);\n    position: relative;\n    left: var(--ids-space-none);\n    top: var(--ids-space-none);\n\n    &::after {\n      @include radio-unchecked-after();\n    }\n\n    &.disabled {\n      @include radio-disabled-unchecked();\n    }\n\n    &.checked {\n      @include radio-checked();\n\n      &::after {\n        @include radio-checked-after();\n      }\n\n      &.disabled {\n        @include radio-disabled-checked();\n      }\n    }\n  }\n\n  // Tree Grid\n  .ids-data-grid-cell .ids-data-grid-tree-container {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n\n    ids-button + .ids-data-grid-tree-field-container .text-ellipsis {\n      margin-inline-start: var(--ids-space-none);\n    }\n\n    ids-button {\n      padding-inline-start: var(--ids-space-2xs);\n      padding-inline-end: var(--ids-space-none);\n    }\n\n    ids-button.expand-button {\n      --ids-button-tertiary-color-background-hover: var(--ids-color-transparent);\n      --ids-button-tertiary-color-border-hover: var(--ids-color-transparent);\n      --ids-button-tertiary-color-background-pressed: var(--ids-color-transparent);\n      --ids-button-tertiary-color-border-pressed: var(--ids-color-transparent);\n    }\n\n    .text-ellipsis {\n      ids-hyperlink {\n        margin-inline-start: var(--ids-space-none);\n      }\n    }\n  }\n\n  .ids-data-grid-cell .ids-data-grid-tree-field-container {\n    display: inline-grid;\n    align-items: center;\n  }\n\n  // =======================================================\n  // Maps used for altering alignments of editable grid cells in different scenarios.\n  // These rules are based on row-height, which is defined at the `.ids-data-grid` element level.\n  // =======================================================\n  $row-height-inline-tree-grid-button-widths: (\n    'xxs': 30,\n    'xs': 32,\n    'sm': 34,\n    'md': 40,\n    'lg': 40\n  );\n\n  $row-height-padding-offsets: (\n    'xxs': 12,\n    'xs': 10,\n    'sm': 8,\n    'md': 3,\n    'lg': 3\n  );\n\n  $row-height-dirty-indicator-offsets: (\n    'xxs': 1,\n    'xs': 1,\n    'sm': 1,\n    'md': 2,\n    'lg': 2\n  );\n\n  $row-height-inline-dirty-indicator-offsets: (\n    'xxs': 3,\n    'xs': 4,\n    'sm': 5,\n    'md': 6,\n    'lg': 6\n  );\n\n  $row-height-indents: (\n    'xxs': 12,\n    'xs': 13,\n    'sm': 15,\n    'md': 17,\n    'lg': 17\n  );\n\n  $row-height-outline-padding: (\n    'xxs': 1,\n    'xs': 2,\n    'sm': 3,\n    'md': 4,\n    'lg': 4\n  );\n\n  $row-height-outline-offsets: (\n    'xxs': 1,\n    'xs': 2,\n    'sm': 5,\n    'md': 8,\n    'lg': 12\n  );\n\n  @each $rowHeight, $offset in $row-height-padding-offsets {\n    // These values are different for each Row Height\n    $button-width: map.get($row-height-inline-tree-grid-button-widths, $rowHeight);\n    $indent: map.get($row-height-indents, $rowHeight);\n    $dirty-indicator-offset: map.get($row-height-dirty-indicator-offsets, $rowHeight);\n    $inline-dirty-indicator-offset: map.get($row-height-inline-dirty-indicator-offsets, $rowHeight);\n    $outline-offset: map.get($row-height-outline-offsets, $rowHeight);\n    $outline-padding: map.get($row-height-outline-padding, $rowHeight);\n\n    &[data-row-height='#{$rowHeight}'] {\n      // ================================================\n      // Top-level grid alignments that depend solely on row height\n      .ids-data-grid-cell {\n        &.is-dirty {\n          &:not(.is-inline) {\n            &.formatter-text {\n              &::before {\n                inset-block-start: #{$dirty-indicator-offset}px;\n                margin-inline-start: #{$dirty-indicator-offset}px;\n              }\n            }\n          }\n\n          &.is-inline {\n            &.formatter-text {\n              &::before {\n                inset-block-start: #{$inline-dirty-indicator-offset}px;\n                margin-inline-start: #{$inline-dirty-indicator-offset}px;\n              }\n            }\n          }\n        }\n\n        // Defines the position of the \"inline-edit\" style's outline\n        &.is-editable.is-inline {\n          &:not(.formatter-tree) {\n            @include ids-data-grid-inline-editable-outline($outline-padding);\n          }\n\n          &.formatter-tree {\n            .text-ellipsis {\n              @include ids-data-grid-inline-editable-outline($outline-padding);\n\n              width: calc(100% - #{$outline-offset + 4}px);\n\n              &::after {\n                margin-inline-end: -#{$outline-offset}px;\n              }\n            }\n          }\n        }\n      }\n\n      // Remove start padding from tree-grid-contained `.text-ellipsis` elements\n      .ids-data-grid-tree-field-container .text-ellipsis {\n        padding-inline-start: var(--ids-space-none);\n      }\n\n      // ================================================\n      // Expandable grid/tree grid nested alignment rules\n      @for $i from 1 through 8 {\n        [aria-level='#{$i}'] .ids-data-grid-cell {\n          @if $i == 1 {\n            .ids-data-grid-tree-field-container {\n              margin-inline-start: #{$button-width}px;\n            }\n\n            ids-button {\n              margin-inline-start: var(--ids-space-none);\n            }\n\n            ids-button + .ids-data-grid-tree-field-container {\n              margin-inline-start: var(--ids-space-none);\n            }\n          } @else {\n            .ids-data-grid-tree-field-container {\n              margin-inline-start: #{$button-width + ($indent * ($i - 1)) + ($offset)}px;\n            }\n\n            ids-button {\n              margin-inline-start: #{($indent * ($i - 1)) + $offset}px;\n            }\n\n            ids-button + .ids-data-grid-tree-field-container {\n              margin-inline-start: var(--ids-space-none);\n            }\n          }\n\n          // ================================================\n          // Dirty-tracker rules dependent on `aria-level` nesting\n          &.is-dirty {\n            &.is-inline {\n              .ids-data-grid-tree-field-container::before {\n                inset-block-start: #{$inline-dirty-indicator-offset}px;\n                margin-inline-start: #{$inline-dirty-indicator-offset}px;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  // List Style Feature\n  &.is-list-style {\n    border-width: var(--ids-border-width-none);\n  }\n\n  // Used for row start\n  &.waiting-load {\n    visibility: hidden;\n    overflow: hidden;\n\n    .ids-data-grid-body {\n      visibility: hidden;\n    }\n  }\n}\n\n// Used for Frozen Columns\n.ids-data-grid-body {\n  min-width: fit-content;\n}\n\n// Standalone Css Borders\ntable.ids-data-grid {\n  display: table;\n  outline: 1px solid var(--ids-data-grid-cell-color-border);\n  outline-offset: -1px;\n}\n\n// Empty Message\n.ids-data-grid-wrapper {\n  position: relative;\n\n  .ids-data-grid-toolbar {\n    display: flex;\n    width: 100%;\n    margin: 6px var(--ids-space-none);\n    align-items: center;\n    justify-content: end;\n  }\n}\n\nids-empty-message:not([hidden]),\n::slotted(ids-empty-message:not([hidden])) {\n  display: flex;\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  justify-content: center;\n  align-items: center;\n  top: var(--ids-space-none);\n  pointer-events: none;\n  margin-top: var(--ids-space-sm);\n}\n\n// Adjust for filter row\nids-empty-message.has-filter-row:not([hidden]) {\n  &.filter-row-size-xxs {\n    margin-block-start: 24px;\n  }\n\n  &.filter-row-size-xs {\n    margin-block-start: 34px;\n  }\n\n  &.filter-row-size-sm {\n    margin-block-start: 34px;\n  }\n\n  &.filter-row-size-md {\n    margin-block-start: 34px;\n  }\n\n  &.filter-row-size-lg {\n    margin-block-start: 26px;\n  }\n\n  &.has-pager {\n    margin-block-start: 14px;\n  }\n}\n\n::slotted(ids-empty-message.has-filter-row:not([hidden])) {\n  margin-block-start: 14px;\n}\n\n.has-empty-message .ids-data-grid {\n  min-height: var(--ids-data-grid-height-min);\n}\n\n// Loading Indicator\nids-loading-indicator {\n  display: flex;\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  justify-content: center;\n  align-items: center;\n  top: var(--ids-space-none);\n\n  &[stopped] {\n    display: none;\n  }\n}\n\n:host(:not([disable-row-highlight])) ids-data-grid-row:hover:not([part*='row-']):not(.selected) {\n  ids-data-grid-cell,\n  ids-data-grid-cell.is-readonly:not(.exclude-readonly-style) {\n    background-color: var(--ids-data-grid-row-color-background-hover);\n  }\n\n  ids-data-grid-cell.is-invalid {\n    background-color: var(--ids-data-grid-cell-color-background-error-hover);\n  }\n}\n\n#datagrid-modal {\n  --ids-modal-content-padding: var(--ids-space-none);\n  --ids-modal-header-padding: var(--ids-space-sm) var(--ids-space-sm) var(--ids-space-xs) var(--ids-space-sm);\n  --ids-popup-fit-height: 400px;\n\n  ids-swappable-item {\n    --ids-swappable-item-color-background-selected: var(--ids-color-accent-blue-weakest);\n    --ids-swappable-item-color-text-selected: var(--ids-color-foreground-default-default);\n\n    align-items: center;\n    height: var(--ids-data-grid-modal-row-height);\n  }\n\n  #datagrid-modal-title {\n    position: relative;\n    top: calc(var(--ids-space-04) * -1);\n  }\n\n  ids-search-field {\n    --ids-input-color-background-default: var(--ids-color-accent-neutral-weakest);\n    --ids-search-field-color-background-default: var(--ids-color-accent-neutral-weakest);\n    --ids-input-color-border-default: var(--ids-color-accent-neutral-weak);\n    --ids-input-color-border-hover: var(--ids-color-accent-neutral-weak);\n    --ids-input-color-border-focus: var(--ids-color-accent-neutral-weak);\n    --ids-input-color-border-shadow: none;\n    --ids-search-field-border-radius: var(--ids-border-radius-none);\n    --ids-search-field-border-width: var(--ids-border-width-sm) var(--ids-border-width-none);\n\n    margin-bottom: -8px;\n    margin-top: calc(var(--ids-space-08) * -1);\n    min-width: 330px;\n    position: sticky;\n    top: var(--ids-space-none);\n    z-index: 1;\n  }\n\n  ids-text {\n    width: 100%;\n  }\n\n  ids-switch {\n    position: relative;\n    top: var(--ids-space-3xs);\n  }\n\n  ids-swappable {\n    width: 100%;\n  }\n\n  .datagrid-modal-column-list {\n    --ids-modal-column-list-height: calc(100% - 14px);\n\n    overflow: auto;\n    max-height: var(--ids-modal-column-list-height);\n  }\n\n}\n\n.selection-border {\n  position: absolute;\n  pointer-events: none;\n  border: 1.5px solid var(--ids-button-primary-color-background-default);\n  background: transparent;\n  z-index: 2;\n  transition: all 0.05s ease;\n}\n","/* Ids Data Grid Component - Header */\n.ids-data-grid-header {\n  position: sticky;\n  top: var(--ids-space-none);\n  z-index: 1; // Higher than body columns; z-index higher than 2 will break ids-loading-indicator's overlay\n\n  &.is-frozen {\n    z-index: 2;\n  }\n\n  // Filter button height\n  --ids-button-formatter-size: 28px;\n}\n\n// Header Checkbox\n.ids-data-grid-header-text .ids-data-grid-checkbox-container {\n  width: 20px;\n\n  &[disabled='true'] {\n    cursor: default;\n  }\n\n  .ids-data-grid-checkbox[disabled='true'] {\n    pointer-events: none;\n    opacity: var(--ids-data-grid-header-checkbox-opacity-disabled);\n  }\n\n\n  .ids-data-grid-checkbox:not(.checked):not(.indeterminate) {\n    background-color: var(--ids-data-grid-header-checkbox-color-background);\n    border-color: var(--ids-data-grid-header-checkbox-color-border);\n  }\n}\n\n// Header Cell Area\n.ids-data-grid-header-cell {\n  border-inline-start: 1px solid var(--ids-data-grid-header-color-border);\n  border-block-end: 1px solid var(--ids-data-grid-header-color-border);\n  background-color: var(--ids-data-grid-header-color-background-default);\n  min-height: 28px;\n  position: relative;\n\n  // Hide first border\n  &:first-child {\n    border-inline-start-width: var(--ids-border-width-none);\n  }\n\n  &:hover.is-actionable {\n    background-color: var(--ids-data-grid-header-color-background-hover);\n  }\n\n  &.align-center .ids-data-grid-header-cell-content,\n  &.align-center .ids-data-grid-header-cell-filter-wrapper {\n    justify-content: center;\n  }\n\n  &.align-right .ids-data-grid-header-cell-content,\n  &.align-right .ids-data-grid-header-cell-filter-wrapper {\n    justify-content: flex-end;\n  }\n\n  &.align-right .is-sortable .ids-data-grid-header-text {\n    padding-inline-end: var(--ids-data-grid-padding-lg);\n    padding-inline-start: 5px;\n  }\n\n  &.align-right .ids-data-grid-header-cell-filter-wrapper {\n    ids-menu-button {\n      margin-inline-start: var(--ids-space-3xs);\n    }\n  }\n\n  // Resizing Cells\n  .resizer {\n    cursor: var(--ids-cursor-resize);\n    display: inline;\n    height: 100%;\n    position: absolute;\n    margin-inline-start: calc(100% - 4px);\n    top: var(--ids-space-none);\n    width: 6px;\n    z-index: 2;\n  }\n\n  // Reorderable Cells\n  .reorderer {\n    cursor: var(--ids-cursor-move);\n    display: inline;\n    height: 34px;\n    opacity: 0;\n    position: absolute;\n    inset-inline-start: var(--ids-space-xs);\n    top: var(--ids-space-none);\n    width: var(--ids-space-2xs);\n\n    ids-icon {\n      position: absolute;\n      color: var(--ids-data-grid-header-color-icon);\n      inset-inline-start: calc(-1 * var(--ids-space-xs));\n      text-align: center;\n      top: calc(50% - 9px);\n    }\n  }\n\n  &.align-right .reorderer {\n    inset-inline-end: 5px;\n    inset-inline-start: initial;\n  }\n\n  &:last-child .resizer {\n    margin-inline-start: calc(100% - 6px); // Prevents unneeded scrollbar\n  }\n\n  &.dragging {\n    background-color: var(--ids-data-grid-header-drag-background-color) !important; // this important is needed for drag styles to work\n    border-inline-start: var(--ids-space-none);\n    display: block;\n    left: -1000px;\n    position: absolute;\n    top: var(--ids-space-none);\n    width: 110px;\n  }\n\n  &.active-drag-column {\n    background-color: var(--ids-data-grid-header-color-background-default-placeholder-dragging);\n\n    .sort-indicator {\n      opacity: 0;\n    }\n  }\n\n  &:hover .reorderer {\n    opacity: 1;\n  }\n\n  // Reorderable Cells\n  &.frozen {\n    background-color: var(--ids-data-grid-header-color-background-default);\n    position: sticky;\n    z-index: 3;\n  }\n\n  // Change borders for frozen column scrolling\n  &.frozen-last {\n    border-inline-end: 1px solid var(--ids-data-grid-header-color-border);\n\n    + .ids-data-grid-header-cell {\n      border-inline-start-width: var(--ids-border-width-none);\n    }\n  }\n\n  &.frozen-left {\n    position: sticky;\n    left: var(--ids-space-none);\n    z-index: 2;\n\n    // Dynamically added widths\n    @for $i from 2 through 10 {\n      &:nth-of-type(#{$i}) {\n        left: var(--ids-data-grid-frozen-column-left-width-#{$i});\n      }\n    }\n  }\n\n  &.frozen-right {\n    position: sticky;\n    right: var(--ids-space-none);\n\n    // Wierd centering bug (frozen right)\n    .ids-data-grid-header-cell-content {\n      display: inline-flex;\n    }\n  }\n}\n\n.ids-data-grid-header-cell-content {\n  display: flex;\n}\n\n.ids-data-grid-header-text {\n  display: block;\n  padding: var(--ids-data-grid-header-lg-padding);\n  font-weight: var(--ids-font-weight-semibold);\n  font-size: var(--ids-data-grid-font-size-sm);\n  color: var(--ids-data-grid-header-color-text);\n  overflow: hidden;\n  text-align: left;\n  text-overflow: ellipsis;\n  user-select: none;\n  white-space: nowrap;\n\n  small {\n    font-weight: var(--ids-font-weight-normal);\n    font-size: var(--ids-data-grid-font-size-sm);\n  }\n}\n\n.ids-data-grid-header-icon {\n  align-self: center;\n  color: var(--ids-data-grid-header-color-text);\n  margin-inline-start: var(--ids-space-2xs);\n  margin-block-start: var(--ids-space-2xs);\n}\n\n// Header sort styles\n.sort-indicator {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  position: relative;\n  overflow: hidden;\n  height: var(--ids-space-lg);\n  margin-inline-start: auto;\n  margin-inline-end: 5px;\n  width: 18px;\n}\n\n// Sort Hover states\n.is-sortable {\n  .sort-indicator ids-icon {\n    color: var(--ids-data-grid-header-color-icon-unsorted);\n    opacity: 0;\n    transition: opacity 0.3s var(--ids-motion-ease) 0s;\n\n    &:first-child {\n      position: relative;\n      top: var(--ids-space-2xs);\n      transform: rotate(180deg);\n    }\n\n    &:last-child {\n      position: relative;\n      top: -10px;\n    }\n  }\n\n  &:hover {\n    cursor: pointer;\n\n    .sort-indicator ids-icon {\n      opacity: 1;\n    }\n  }\n}\n\n.header-expander {\n  display: none;\n  max-height: 18px;\n  cursor: var(--ids-cursor-pointer);\n  color: var(--ids-data-grid-header-expander-color);\n  margin-inline-start: var(--ids-space-12);\n\n  &:hover {\n    color: var(--ids-data-grid-header-expander-color-active);\n  }\n}\n\n[data-row-height='xxs'] .header-expander {\n  top: var(--ids-space-3xs);\n}\n\n:host([show-header-expander]) .header-expander,\n.column-header-expander .header-expander {\n  display: unset;\n}\n\n.has-selectioncheckbox .ids-data-grid-header-text {\n  padding-inline-start: var(--ids-space-none);\n  padding-inline-end: var(--ids-space-none);\n}\n\n.is-sortable,\n.has-headericon {\n  .ids-data-grid-header-text {\n    padding-inline-end: var(--ids-space-none);\n  }\n}\n\n// Ascending sort\n[aria-sort='ascending'] .is-sortable .sort-indicator ids-icon {\n  &:first-child {\n    color: var(--ids-data-grid-header-color-icon-sorted);\n    opacity: 1;\n  }\n\n  &:last-child {\n    opacity: 1;\n  }\n}\n\n// Descending sort\n[aria-sort='descending'] .is-sortable .sort-indicator ids-icon {\n  &:first-child {\n    opacity: 1;\n  }\n\n  &:last-child {\n    color: var(--ids-data-grid-header-color-icon-sorted);\n    opacity: 1;\n  }\n}\n\n// Drag arrows for sorting\n.ids-data-grid-sort-arrows {\n  display: none;\n  height: 34px;\n  position: absolute;\n  z-index: 1;\n\n  &::before,\n  &::after {\n    border-left: 5px solid transparent;\n    border-right: 5px solid transparent;\n    content: '';\n    display: inline-block;\n    height: 0;\n    left: -5px;\n    position: absolute;\n    width: 0;\n  }\n\n  &::before {\n    border-top: 5px solid var(--ids-data-grid-header-drag-arrow-color-background);\n    top: -6px;\n  }\n\n  &::after {\n    border-bottom: 5px solid var(--ids-data-grid-header-drag-arrow-color-background);\n    bottom: -9px;\n  }\n}\n\n// Standalone Css\ntr.ids-data-grid-header {\n  position: initial;\n}\n\nth.ids-data-grid-header-cell {\n  display: table-cell;\n}\n\n// List Style Feature\n.ids-data-grid.is-list-style {\n  // Change Header Color\n  .ids-data-grid-header-cell {\n    background-color: var(--ids-data-grid-list-header-color-background);\n    border-color: var(--ids-data-grid-list-header-color-border);\n  }\n\n  .ids-data-grid-header-text {\n    color: var(--ids-data-grid-list-header-color-text);\n  }\n\n  // Change Sort Icon Colors\n  .is-sortable {\n    ids-icon {\n      color: var(--ids-data-grid-header-color-icon-unsorted);\n    }\n  }\n\n  [aria-sort='descending'] .is-sortable ids-icon:last-child,\n  [aria-sort='ascending'] .is-sortable ids-icon:first-child  {\n    color: var(--ids-data-grid-list-header-color-icon-unsorted)\n  }\n\n  // Change Header Checkbox\n  .ids-data-grid-header-text .ids-data-grid-checkbox-container {\n    .ids-data-grid-checkbox:not(.checked):not(.indeterminate) {\n      border-color: var(--ids-data-grid-list-header-checkbox-color-background);\n    }\n  }\n}\n\n// Used for Frozen Columns\n.ids-data-grid-body {\n  min-width: fit-content;\n}\n\n// Adjust for Row Heights (large is default)\n.ids-data-grid {\n  &[data-row-height='md'] {\n    .ids-data-grid-header-text {\n      padding: var(--ids-data-grid-header-md-padding);\n    }\n\n    .reorderer ids-icon {\n      inset-inline-start: -11px;\n    }\n\n    .sort-indicator {\n      margin-inline-start: -8px;\n    }\n\n    .ids-data-grid-header-cell.align-right .reorderer {\n      inset-inline-end: 3px;\n    }\n  }\n\n  &[data-row-height='sm'] {\n    .ids-data-grid-header-text {\n      padding: var(--ids-data-grid-header-sm-padding);\n    }\n\n    .reorderer {\n      display: none;\n    }\n\n    .sort-indicator {\n      margin-inline-start: -4px;\n    }\n  }\n\n  &[data-row-height='xs'] {\n    .ids-data-grid-header-text {\n      padding: var(--ids-data-grid-header-xs-padding);\n    }\n\n    .reorderer {\n      display: none;\n    }\n\n    .sort-indicator {\n      margin-inline-start: -2px;\n      margin-inline-end: -2px;\n      margin-block-start: -3px;\n    }\n\n    .ids-data-grid-checkbox-container {\n      padding-top: var(--ids-space-3xs);\n    }\n\n    .ids-data-grid-header-cell.align-right .is-sortable .ids-data-grid-header-text {\n      padding-inline-end: var(--ids-data-grid-padding-xs);\n      padding-inline-start: 5px;\n    }\n  }\n\n  &[data-row-height='xxs'] {\n    .ids-data-grid-header-text {\n      padding: var(--ids-data-grid-header-xxs-padding);\n    }\n\n    .reorderer {\n      display: none;\n    }\n\n    .sort-indicator {\n      margin-inline-start: var(--ids-space-none);\n      margin-block-start: -1px;\n      height: 22px;\n\n      > ids-icon:first-child {\n        top: 3px;\n      }\n\n      ids-icon:last-child {\n        top: -11px;\n      }\n    }\n\n    .align-right .sort-indicator {\n      margin-inline-start: var(--ids-space-none);\n    }\n\n    .ids-data-grid-header-text .ids-data-grid-checkbox-container {\n      padding-top: 3px;\n    }\n\n    .ids-data-grid-header-cell.align-right .is-sortable .ids-data-grid-header-text {\n      padding-inline-end: 3px;\n      padding-inline-start: 3px;\n    }\n\n    // Filter Adjustments\n    ids-input,\n    ids-menu-button,\n    ids-trigger-field,\n    ids-dropdown {\n      --ids-input-height-10: 24px;\n    }\n\n    ids-dropdown {\n      --ids-input-font-size-sm: var(--ids-input-font-size-xs);\n    }\n\n    .ids-data-grid-header-cell-filter-wrapper {\n      padding-inline-start: calc(var(--ids-data-grid-padding-xxs) + 2px);\n      padding-inline-end: calc(var(--ids-data-grid-padding-xxs) + 2px);\n      padding-block-end: var(--ids-data-grid-padding-xxs - 1px);\n    }\n  }\n}\n\n// Column selection header\n.ids-data-grid .has-col-selection {\n  .ids-data-grid-header-cell:not([column-id='selectionCheckbox']) .ids-data-grid-header-cell-content {\n    justify-content: flex-start;\n\n    .ids-data-grid-header-text .ids-checkbox .label-text {\n      position: absolute;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      width: 80%;\n    }\n\n    &.is-sortable,\n    &.is-reorderable {\n      .ids-data-grid-header-text .ids-checkbox .label-text {\n        width: 70%;\n      }\n    }\n\n    &.is-sortable.is-reorderable {\n      .ids-data-grid-header-text .ids-checkbox .label-text {\n        width: 60%;\n      }\n    }\n  }\n\n  .sort-indicator {\n    margin-inline-start: auto;\n  }\n}\n\n// Handle RTL\n:host([dir='rtl']) {\n  // Negate right alignment\n  .ids-data-grid-header-cell {\n    &.align-right .ids-data-grid-header-cell-content {\n      direction: ltr;\n    }\n\n    &:last-child {\n      border-inline-end-width: var(--ids-border-width-none);\n    }\n\n    &.frozen-left {\n      position: sticky;\n      right: var(--ids-space-none);\n\n      // Dynamically added widths\n      @for $i from 2 through 10 {\n        &:nth-of-type(#{$i}) {\n          right: var(--ids-data-grid-frozen-column-left-width-#{$i});\n        }\n      }\n    }\n  }\n}\n","/* Ids Data Grid Component - Rows */\n.ids-data-grid-row {\n  display: grid;\n  grid-template-columns: var(--ids-data-grid-column-widths); // Filled in dynamically\n  width: 100%;\n\n  &.selected:not(.mixed) .ids-data-grid-cell,\n  &.activated .ids-data-grid-cell {\n    background-color: var(--ids-data-grid-row-color-background-selected);\n  }\n\n  &[hidden] {\n    display: none;\n  }\n\n  &[part*='row-'] {\n    &:not(.selected) {\n      .ids-data-grid-cell:first-child::before {\n        border-style: solid;\n        border-width: 5px;\n        content: \"\";\n        position: absolute;\n        z-index: 1;\n        margin: 2px;\n        top: 0;\n      }\n    }\n  }\n\n  &[part='row-new'] {\n    background-color: var(--ids-data-grid-row-color-background-new);\n\n    &:not(.selected) {\n      .ids-data-grid-cell {\n        &:first-child::before {\n            border-color: var(--ids-data-grid-row-color-border-new) transparent transparent var(--ids-data-grid-row-color-border-new);\n        }\n\n        background-color: var(--ids-data-grid-row-color-background-new);\n        color: var(--ids-data-grid-cell-color-text-states-default);\n      }\n    }\n  }\n\n  &[part='row-removed'] {\n    background-color: var(--ids-data-grid-row-color-background-removed);\n\n    &:not(.selected) {\n      .ids-data-grid-cell {\n        &:first-child::before {\n          border-color: var(--ids-data-grid-row-color-border-removed) transparent transparent var(--ids-data-grid-row-color-border-removed);\n        }\n\n        background-color: var(--ids-data-grid-row-color-background-removed);\n        color: var(--ids-data-grid-cell-color-text-states-default);\n      }\n    }\n  }\n\n  &[part='row-error'] {\n    background-color: var(--ids-data-grid-row-color-background-error);\n\n    &:not(.selected) {\n      .ids-data-grid-cell {\n        &:first-child::before {\n          border-color: var(--ids-data-grid-row-color-border-error) transparent transparent var(--ids-data-grid-row-color-border-error);\n        }\n\n        background-color: var(--ids-data-grid-row-color-background-error);\n        color: var(--ids-data-grid-cell-color-text-states-default);\n      }\n    }\n  }\n}\n\n// Grouped Rows\n.ids-data-grid-row.is-group-row {\n  background-color: var(--ids-data-grid-row-grouped-color-background);\n  grid-template-columns: 100%;\n\n\n  .ids-data-grid-cell {\n    color: var(--ids-data-grid-row-grouped-color-text, red);\n    font-weight: var(--ids-data-grid-row-grouped-font-weight, 600);\n    border-inline-start: 0;\n  }\n\n  ids-button {\n    --ids-button-tertiary-color-background-hover: transparent;\n    --ids-button-tertiary-color-border-hover: transparent;\n\n    padding: 0 2px;\n  }\n}\n\n// Row Height Feature with Formatters spacing\n.ids-data-grid {\n  // Large by default\n  &[data-row-height='md'] {\n    .ids-data-grid-cell {\n      height: var(--ids-data-grid-row-height-md);\n\n      .text-ellipsis,\n      ids-badge {\n        padding-inline-start: var(--ids-data-grid-padding-md);\n        padding-inline-end: var(--ids-data-grid-padding-md);\n      }\n\n      ids-hyperlink {\n        margin: var(--ids-data-grid-padding-md);\n      }\n    }\n\n    .ids-data-grid-cell:not(.align-center) .ids-data-grid-header-cell-content:not(.vertical-align-center) .ids-data-grid-header-text {\n      padding-inline-start: var(--ids-data-grid-padding-md);\n      transition: padding var(--ids-motion-duration) var(--ids-motion-ease);\n    }\n\n    .ids-data-grid-cell:not(.align-center) .ids-data-grid-header-cell:hover .ids-data-grid-header-cell-content:not(.vertical-align-center).is-reorderable .ids-data-grid-header-text {\n      padding-inline-start: var(--ids-data-grid-padding-md);\n    }\n  }\n\n  &[data-row-height='sm'] {\n    .ids-data-grid-cell {\n      height: var(--ids-data-grid-row-height-sm);\n\n      .text-ellipsis,\n      ids-badge {\n        padding-inline-start: var(--ids-data-grid-padding-sm);\n        padding-inline-end: var(--ids-data-grid-padding-sm);\n      }\n\n      ids-hyperlink {\n        margin: var(--ids-data-grid-padding-sm);\n      }\n    }\n\n    .ids-data-grid-cell:not(.align-center) .ids-data-grid-header-cell-content:not(.vertical-align-center) .ids-data-grid-header-text {\n      padding-inline-start: var(--ids-data-grid-padding-sm);\n      transition: padding var(--ids-motion-duration) var(--ids-motion-ease);\n    }\n\n    .ids-data-grid-cell:not(.align-center) .ids-data-grid-header-cell:hover .ids-data-grid-header-cell-content:not(.vertical-align-center).is-reorderable .ids-data-grid-header-text {\n      padding-inline-start: var(--ids-data-grid-padding-sm);\n    }\n  }\n\n  &[data-row-height='xs'] {\n    .ids-data-grid-cell {\n      height: var(--ids-data-grid-row-height-xs);\n      font-size: var(--ids-data-grid-font-size-sm);\n\n      .text-ellipsis,\n      ids-badge {\n        padding-inline-start: var(--ids-data-grid-padding-xs);\n        padding-inline-end: var(--ids-data-grid-padding-xs);\n      }\n\n      ids-hyperlink {\n        margin: var(--ids-data-grid-padding-xs);\n      }\n    }\n\n    .ids-data-grid-cell:not(.align-center) .ids-data-grid-header-cell-content:not(.vertical-align-center) .ids-data-grid-header-text {\n      padding-inline-start: var(--ids-data-grid-padding-xs);\n      transition: padding var(--ids-motion-duration) var(--ids-motion-ease);\n    }\n\n    .ids-data-grid-cell:not(.align-center) .ids-data-grid-header-cell:hover .ids-data-grid-header-cell-content:not(.vertical-align-center).is-reorderable .ids-data-grid-header-text {\n      padding-inline-start: var(--ids-data-grid-padding-xs);\n    }\n  }\n\n  &[data-row-height='xxs'] {\n    .ids-data-grid-cell {\n      height: var(--ids-data-grid-row-height-xxs);\n      font-size: var(--ids-data-grid-font-size-sm);\n\n      .text-ellipsis,\n      ids-badge {\n        padding-inline-start: var(--ids-data-grid-padding-xxs);\n        padding-inline-end: var(--ids-data-grid-padding-xxs);\n      }\n\n      ids-hyperlink {\n        margin: var(--ids-data-grid-padding-xxs);\n      }\n\n      // On 'xxs' row height, inline-editable cells have a slightly wider\n      // padding appearance to accommodate the inline display\n      &.is-inline {\n        .text-ellipsis {\n          padding-inline-start: var(--ids-data-grid-padding-xs);\n          padding-inline-end: var(--ids-data-grid-padding-xs);\n        }\n      }\n    }\n\n    .ids-data-grid-cell:not(.align-center) .ids-data-grid-header-cell-content:not(.vertical-align-center) .ids-data-grid-header-text {\n      padding-inline-start: var(--ids-data-grid-padding-xxs);\n      transition: padding var(--ids-motion-duration) var(--ids-motion-ease);\n    }\n\n    .ids-data-grid-cell:not(.align-center) .ids-data-grid-header-cell:hover .ids-data-grid-header-cell-content:not(.vertical-align-center).is-reorderable .ids-data-grid-header-text {\n      padding-inline-start: var(--ids-data-grid-padding-xxs);\n    }\n  }\n}\n\n// Row Alternate Row Setting Feature\n.ids-data-grid.alt-row-shading ids-data-grid-row:nth-child(even) {\n  background-color: var(--ids-data-grid-row-alternating-color-background);\n}\n\n// Expandable Row\n.ids-data-grid-expandable-row {\n  border-bottom: 1px solid var(--ids-data-grid-cell-color-border);\n  grid-column: 1 / -1;\n  padding: var(--ids-space-xs);\n}\n\n// Standalone Css\ntr.ids-data-grid-row {\n  display: table-row;\n  height: var(--ids-data-grid-row-height-lg);\n}\n\n// Row Navigation Styles\n.ids-data-grid.row-navigation .ids-data-grid-body .ids-data-grid-row {\n  &:focus-within {\n    transform-style: preserve-3d;\n\n    &::after {\n      box-shadow: var(--ids-data-grid-row-shadow-focus);\n      content: ' ';\n      display: block;\n      height: 100%;\n      position: absolute;\n      width: 100%;\n    }\n  }\n\n  .ids-data-grid-cell:focus {\n    box-shadow: none;\n    outline: none;\n  }\n\n  // Fixes an issue where hyperlinks in row-navigation mode cannot be directly clicked\n  ids-hyperlink,\n  .ids-hyperlink {\n    transform: translateZ(1px);\n  }\n}\n\n:host([dir='rtl']) {\n  .ids-data-grid-row {\n    &[part='row-new'] {\n      &:not(.selected) {\n        .ids-data-grid-cell {\n          &:first-child::before {\n              border-color: var(--ids-data-grid-row-color-border-new) var(--ids-data-grid-row-color-border-new) transparent transparent;\n          }\n        }\n      }\n    }\n\n    &[part='row-removed'] {\n      &:not(.selected) {\n        .ids-data-grid-cell {\n          &:first-child::before {\n              border-color: var(--ids-data-grid-row-color-border-removed) var(--ids-data-grid-row-color-border-removed) transparent transparent;\n          }\n        }\n      }\n    }\n\n    &[part='row-error'] {\n      &:not(.selected) {\n        .ids-data-grid-cell {\n          &:first-child::before {\n              border-color: var(--ids-data-grid-row-color-border-error) var(--ids-data-grid-row-color-border-error) transparent transparent;\n          }\n        }\n      }\n    }\n  }\n}\n","/* Ids Data Grid Component - Cells */\n@use 'sass:list';\n\n/* Generates a pseudo-element representing the dirty tracker */\n@mixin ids-data-grid-cell-dirty-tracker-icon {\n  border-color: var(--ids-input-dirty-indicator-color-background-dirty) transparent transparent var(--ids-input-dirty-indicator-color-background-dirty);\n  border-style: solid;\n  border-width: 5px;\n  content: '';\n  display: inline-block;\n  margin-inline: var(--ids-space-3xs);\n  position: absolute;\n  inset-block-start: var(--ids-space-3xs);\n  z-index: 1;\n}\n\nids-data-grid-cell[column-onscreen] {\n  visibility: visible;\n}\n\nids-data-grid-cell[column-offscreen] {\n  visibility: visible;\n}\n\nids-data-grid-cell[column-offscreen-left] {\n  visibility: visible;\n}\n\nids-data-grid-cell[column-offscreen-right] {\n  display: none !important;\n}\n\n.ids-data-grid-row:not(.selected):not([part*='row-']) {\n  .ids-data-grid-cell:not(.is-readonly) {\n    &.frozen-left {\n      background-color: var(--ids-data-grid-color-background);\n    }\n\n    &.frozen-right {\n      background-color: var(--ids-data-grid-color-background);\n    }\n  }\n\n  &:hover {\n    .ids-data-grid-cell.frozen {\n      background-color: var(--ids-data-grid-row-color-background-hover);\n    }\n  }\n}\n\n.ids-data-grid-cell {\n  // Border and Background and Sizing\n  align-items: center;\n  border-inline-start: 1px solid;\n  border-block-end: 1px solid;\n  border-color: var(--ids-data-grid-cell-color-border);\n  display: inline-flex;\n  color: var(--ids-data-grid-cell-color-text-default);\n  height: 50px;\n  overflow: hidden;\n  position: relative;\n  white-space: nowrap;\n\n  // Hide first/last border\n  &:first-child {\n    border-inline-start-width: var(--ids-border-width-none);\n  }\n\n  // Reset badge margin to center it vertically\n  ids-badge::part(badge) {\n    margin-block-end: var(--ids-space-none);\n    margin-inline-end: var(--ids-space-none);\n  }\n\n  ids-badge {\n    padding-inline-start: var(--ids-space-sm);\n    padding-inline-end: var(--ids-space-sm);\n  }\n\n  // So the color is the same as the editor\n  ids-icon[icon='dropdown'] {\n    color: var(--ids-trigger-field-icon-color)\n  }\n\n  ids-hyperlink {\n    margin: var(--ids-space-sm);\n    width: -moz-available;\n    width: -webkit-fill-available;\n    width: fill-available;\n  }\n\n  .text-ellipsis {\n    display: inline-block;\n    vertical-align: middle;\n    padding-inline-start: var(--ids-space-sm);\n    padding-inline-end: var(--ids-space-sm);\n    height: auto;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  // Text Alignment\n  ids-icon {\n    vertical-align: middle;\n\n    + span {\n      vertical-align: middle;\n      line-height: 25px;\n      padding-inline: var(--ids-space-2xs);\n    }\n  }\n\n  // Text Alignment\n  &.align-center {\n    & > *:first-child {\n      display: inline-flex;\n      margin: var(--ids-space-none) auto;\n    }\n  }\n\n  &.align-right {\n    & > *:first-child {\n      margin-inline-start: auto;\n      margin-inline-end: var(--ids-space-none);\n    }\n\n    ids-input {\n      text-align: right;\n    }\n  }\n\n  // Readonly and disabled Cells\n  &.is-readonly:not(.exclude-readonly-style):not(.selected) {\n    background-color: var(--ids-data-grid-cell-color-background-frozen-readonly);\n\n    .editor-cell-icon {\n      display: none;\n    }\n  }\n\n  &.is-disabled {\n    color: var(--ids-data-grid-cell-color-text-disabled);\n\n    .editor-cell-icon {\n      display: none;\n    }\n  }\n\n  &.is-uppercase {\n    text-transform: uppercase;\n  }\n\n  // Focus State\n  &:focus,\n  &.is-editing:not(.is-inline):focus-within,\n  &.is-focused {\n    &:not(.selected):not([tabindex='-1']) {\n      box-shadow: var(--ids-shadow-20);\n      outline: 1px solid var(--ids-color-border-focus);\n      outline-offset: -1px;\n    }\n  }\n\n  &.is-editable {\n    &.is-readonly:not(.exclude-readonly-style) {\n      .text-ellipsis::after {\n        background-color: var(--ids-data-grid-cell-color-background-readonly);\n      }\n    }\n\n    &.is-inline {\n      &.formatter-tree {\n        .ids-data-grid-tree-container {\n          height: 100%;\n          width: 100%;\n        }\n\n        .ids-data-grid-tree-field-container {\n          height: 100%;\n          width: 100%;\n        }\n\n        .text-ellipsis {\n          align-items: center;\n          display: flex;\n          height: 100%;\n          justify-content: end;\n          width: 100%;\n        }\n\n        .text-ellipsis::after {\n          margin-inline-end: -8px;\n        }\n      }\n\n      ids-icon.editor-cell-icon {\n        display: inline-flex;\n        visibility: visible;\n        margin-inline-end: 15px;\n\n        &[icon='dropdown'] {\n          margin-inline-end: 12px;\n        }\n      }\n    }\n\n    &.is-lookup,\n    &.is-datepicker,\n    &.is-timepicker {\n      justify-content: space-between;\n\n      .text-ellipsis {\n        padding-inline-end: var(--ids-space-none);\n      }\n    }\n\n    &.is-datepicker,\n    &.is-timepicker {\n      ids-trigger-field {\n        margin-inline-start: -1px;\n        margin-block-start: 1px;\n      }\n    }\n\n    &.is-lookup {\n      ids-lookup {\n        border: 0;\n        outline: none;\n        width: 100%;\n      }\n\n      ids-lookup::part(container),\n      ids-lookup::part(field-container) {\n        background-color: var(--ids-color-transparent);\n        border: 0;\n        border-radius: 0;\n        box-shadow: none;\n        outline: none;\n        height: 100%;\n        width: 100%;\n        display: flex;\n        margin: 0;\n      }\n    }\n\n    .editor-cell-icon {\n      margin-inline-end: 10px;\n      margin-block-start: var(--ids-space-3xs);\n      display: none;\n\n      &.show-cell-icon-always {\n        display: inline-flex;\n\n        &:hover {\n          cursor: pointer;\n        }\n      }\n    }\n\n    ids-trigger-button::part(button) {\n      color: inherit;\n    }\n\n    // is-borderless:hover\n    &:not(.is-inline):not(.is-invalid):focus,\n    &:not(.is-inline):not(.is-invalid):hover {\n      .editor-cell-icon {\n        display: flex;\n      }\n\n      ids-alert {\n        margin-inline: calc(100% - 48px);\n      }\n    }\n\n    &.is-editable.is-invalid {\n      justify-content: space-between;\n\n      ids-alert {\n        margin-inline-end: var(--ids-space-xs);\n      }\n    }\n  }\n\n  &.is-editing ids-checkbox {\n    --ids-checkbox-margin-inline-end: 0;\n    --ids-checkbox-shadow-focus: 0 0 0 2px transparent, 0 0 0 3px transparent;\n    --ids-checkbox-color-border-focus: var(--ids-checkbox-border);\n\n    &[checked] {\n      --ids-checkbox-color-border-focus: var(--ids-checkbox-color-background-selected);\n    }\n\n    display: flex;\n    justify-content: center;\n    width: 100%;\n    position: relative;\n    left: 6px;\n    top: 3px;\n  }\n\n  // Editing with popups\n  &.is-editing.is-lookup,\n  &.is-editing.is-datepicker,\n  &.is-editing.is-timepicker {\n    overflow: visible;\n  }\n\n  &.is-editing.is-inline ids-input {\n    z-index: 99;\n  }\n\n  // Dropdown Editable Cell\n  &.is-editable.is-dropdown {\n    .dropdown-cell-value {\n      width: 100%;\n    }\n\n    &.is-editing:not(.is-inline) {\n      border-inline-start-width: 0;\n    }\n  }\n\n  // Dropdown Editing Inline\n  &.is-editing.is-dropdown.is-inline {\n    box-shadow: none;\n\n    ids-dropdown {\n      padding: 0 var(--ids-space-2xs);\n    }\n  }\n\n  // Text Editable Cell\n  &.formatter-text {\n    white-space: pre;\n  }\n\n  // Editing Uppercase\n  &.is-editing.is-uppercase {\n    text-transform: uppercase;\n\n    ids-list-box-option,\n    ids-dropdown::part(triggerfield-input),\n    ids-input::part(input) {\n      text-transform: uppercase;\n    }\n  }\n\n  // Frozen Cells\n  &.frozen {\n    position: sticky;\n    z-index: 1; // z-index higher than 2 will break ids-loading-indicator's overlay\n  }\n\n  // Change borders for scrolling\n  &.frozen-last {\n    border-inline-end: 1px solid var(--ids-data-grid-cell-color-border);\n\n    + .ids-data-grid-cell {\n      border-inline-start-width: var(--ids-border-width-none);\n    }\n  }\n\n  &.frozen-left {\n    position: sticky;\n    left: var(--ids-space-none);\n\n    // Dynamically added widths\n    @for $i from 2 through 10 {\n      &:nth-of-type(#{$i}) {\n        left: var(--ids-data-grid-frozen-column-left-width-#{$i});\n      }\n    }\n  }\n\n  &.frozen-right {\n    position: sticky;\n    right: var(--ids-space-none);\n  }\n\n  &.is-dirty::before {\n    @include ids-data-grid-cell-dirty-tracker-icon;\n  }\n\n  &.is-dirty.is-inline {\n    &.formatter-tree {\n      &::before {\n        display: none;\n        content: none;\n      }\n\n      .ids-data-grid-tree-field-container {\n        position: relative;\n\n        &::before {\n          @include ids-data-grid-cell-dirty-tracker-icon;\n        }\n      }\n    }\n\n    &.is-dropdown::before {\n      margin-inline: 6px;\n      inset-block-start: 6px;\n    }\n\n    ids-input {\n      &::part(dirty-tracker-icon) {\n        --ids-icon-height-default: 12px !important;\n        --ids-icon-width-default: 12px !important;\n      }\n    }\n  }\n\n  &.is-dirty.is-dropdown.is-editing:not(.is-inline)::before {\n    inset-block-start: 3px;\n    margin-inline: 3px;\n  }\n\n  &.is-invalid {\n    background-color: var(--ids-data-grid-cell-color-background-error);\n  }\n\n  &.selected {\n    background-color: var(--ids-data-grid-row-color-background-selected);\n  }\n\n  ids-alert {\n    margin-top: 3px;\n  }\n\n  ids-tag {\n    --ids-tag-margin-inline-end: 0;\n  }\n\n  ids-progress-bar {\n    margin: var(--ids-progress-bar-grid-cell-margin);\n  }\n\n  &.is-editing {\n    $icon-styles: (\n      'timepicker': 'clock',\n      'datepicker': 'calendar'\n    );\n\n    $field-heights: (\n      'xs': (-5px, 1px),\n      'sm': (var(--ids-space-3xs), 1px)\n    );\n\n    @each $class, $icon in $icon-styles {\n      &.is-#{$class} {\n        @each $height, $values in $field-heights {\n          .ids-trigger-field-slot-trigger-end[icon='#{$icon}'][field-height='#{$height}'] {\n            margin-inline-end: list.nth($values, 1);\n            margin-block-start: list.nth($values, 2);\n          }\n        }\n      }\n    }\n  }\n}\n\n// =============================================\n// Row height: 'xxs'\n// =============================================\n[data-row-height='xxs'] {\n  .formatter-progress {\n    ids-progress-bar {\n      margin: var(--ids-data-grid-padding-xxs);\n    }\n  }\n\n  .ids-data-grid-cell.is-dirty::before {\n    border-width: 4px;\n    inset-block-start: 1px;\n    inset-inline-start: -1px;\n  }\n\n  .ids-data-grid-cell.is-dirty.is-inline::before {\n    margin-inline: 3px;\n    top: 3px;\n  }\n\n  ids-button {\n    --ids-button-icon-padding: var(--ids-space-3xs);\n  }\n\n  ids-badge {\n    --ids-badge-font-line-height: calc(var(--ids-data-grid-row-height-xxs) - 8px);\n  }\n\n  ids-tag {\n    --ids-tag-height: calc(var(--ids-data-grid-row-height-xxs) - 6px);\n  }\n\n  ids-input,\n  ids-trigger-field {\n    --ids-space-3xs: 0;\n    --ids-input-font-size-sm: var(--ids-data-grid-font-size-sm);\n  }\n\n  ids-input {\n    &::part(dirty-tracker-icon) {\n      --ids-icon-height-default: 10px !important;\n      --ids-icon-width-default: 10px !important;\n    }\n\n    &::part(input) {\n      height: calc(var(--ids-input-height-10) - 4px);\n    }\n  }\n\n  // Adjust non inline editor\n  .ids-data-grid-cell.is-editable .editor-cell-icon {\n    margin-inline-end: var(--ids-space-3xs);\n  }\n\n  // Adjust dropdown editor\n  .ids-data-grid-cell.is-editable.is-inline ids-icon.editor-cell-icon {\n    margin-inline-end: var(--ids-space-2xs);\n  }\n\n  .ids-data-grid-cell.is-editable.is-inline {\n    --ids-button-tertiary-color-background-hover: var(--ids-color-transparent);\n  }\n\n  .ids-data-grid-cell.is-editing.is-dropdown.is-inline ids-dropdown {\n    padding: var(--ids-space-none) var(--ids-space-4xs);\n\n    --ids-input-font-size-sm: var(--ids-data-grid-font-size-sm);\n  }\n\n  .ids-data-grid-cell {\n    .ids-data-grid-checkbox-container:not(.is-selection-checkbox) {\n      padding-inline: var(--ids-data-grid-padding-xxs);\n    }\n\n    &.is-editable.is-editable.is-invalid ids-alert {\n      margin-inline-end: var(--ids-space-4xs);\n    }\n  }\n}\n\n// =============================================\n// Row height: 'xs'\n// =============================================\n\n[data-row-height='xs'] {\n  .formatter-progress {\n    ids-progress-bar {\n      margin: var(--ids-data-grid-padding-xs);\n    }\n  }\n\n  .ids-data-grid-cell.is-dirty::before {\n    border-width: 4px;\n  }\n\n  .ids-data-grid-cell.is-dirty.is-inline::before {\n    margin-inline: 3px;\n    top: 3px;\n  }\n\n  ids-button {\n    --ids-button-icon-padding: 3px;\n  }\n\n  ids-badge {\n    --ids-badge-font-line-height: calc(var(--ids-data-grid-row-height-xs) - 12px);\n  }\n\n  ids-tag {\n    --ids-tag-height: calc(var(--ids-data-grid-row-height-xxs) - 4px);\n  }\n\n  ids-input {\n    --ids-input-font-size-sm: var(--ids-data-grid-font-size-sm);\n\n    &::part(dirty-tracker-icon) {\n      --ids-icon-height-default: 12px !important;\n      --ids-icon-width-default: 12px !important;\n    }\n  }\n\n  // Adjust non inline editor\n  .ids-data-grid-cell.is-editable .editor-cell-icon {\n    margin-inline-end: var(--ids-space-3xs);\n  }\n\n  // Adjust dropdown editor\n  .ids-data-grid-cell.is-editable.is-inline ids-icon.editor-cell-icon {\n    margin-inline-end: var(--ids-space-2xs);\n  }\n\n  .ids-data-grid-cell.is-editable.is-inline {\n    --ids-button-tertiary-color-background-hover: var(--ids-color-transparent);\n    --ids-input-font-size-sm: var(--ids-data-grid-font-size-sm);\n  }\n\n  .ids-data-grid-cell.is-editing.is-dropdown.is-inline ids-dropdown {\n    padding: var(--ids-space-none) var(--ids-space-3xs);\n  }\n\n  .ids-data-grid-cell {\n    .ids-data-grid-checkbox-container:not(.is-selection-checkbox) {\n      padding-inline: var(--ids-data-grid-padding-xs);\n    }\n  }\n}\n\n// =============================================\n// Row height: 'sm'\n// =============================================\n\n[data-row-height='sm'] {\n  .formatter-progress {\n    ids-progress-bar {\n      margin: var(--ids-data-grid-padding-sm);\n    }\n  }\n\n  ids-button {\n    --ids-button-icon-padding: var(--ids-space-2xs);\n  }\n\n  // Adjust non inline editor\n  .ids-data-grid-cell.is-editable .editor-cell-icon {\n    margin-inline-end: 6px;\n  }\n\n  // Adjust dropdown editor\n  .ids-data-grid-cell.is-editable.is-inline ids-icon.editor-cell-icon {\n    margin-inline-end: 5px;\n    margin-block-start: 0;\n  }\n\n  .ids-data-grid-cell.is-editable.is-inline {\n    --ids-button-tertiary-color-background-hover: var(--ids-color-transparent);\n  }\n\n  .ids-data-grid-cell {\n    .ids-data-grid-checkbox-container:not(.is-selection-checkbox) {\n      padding-inline: var(--ids-data-grid-padding-sm);\n    }\n  }\n}\n\n// =============================================\n// Row height: 'md'\n// =============================================\n\n[data-row-height='md'] {\n  .formatter-progress {\n    ids-progress-bar {\n      margin: var(--ids-data-grid-padding-md);\n    }\n  }\n\n  // Adjust dropdown editor\n  .ids-data-grid-cell.is-editable .editor-cell-icon {\n    margin-inline-end: 7px;\n  }\n\n  .ids-data-grid-cell.is-editable.is-inline ids-icon.editor-cell-icon {\n    margin-inline-end: var(--ids-data-grid-padding-sm);\n  }\n\n  .ids-data-grid-cell.is-editable.is-inline {\n    --ids-button-tertiary-color-background-hover: var(--ids-color-transparent);\n\n    ::slotted(ids-trigger-button) {\n      position: relative;\n      top: 100px;\n    }\n  }\n\n  .ids-data-grid-cell {\n    .ids-data-grid-checkbox-container:not(.is-selection-checkbox) {\n      padding-inline: var(--ids-data-grid-padding-md);\n    }\n  }\n}\n\n// =============================================\n// Row height: 'lg'\n// =============================================\n\n[data-row-height='lg'] {\n  .ids-data-grid-cell {\n    .ids-data-grid-checkbox-container:not(.is-selection-checkbox) {\n      padding-inline: var(--ids-data-grid-padding-lg);\n    }\n  }\n}\n\n// List Style Feature\n.ids-data-grid.is-list-style {\n  // Change Cell Borders/BG\n  .ids-data-grid-cell {\n    border-inline-start-width: var(--ids-border-width-none);\n    border-bottom: 1px solid var(--ids-data-grid-list-cell-color-border);\n\n    &.is-readonly:not(.exclude-readonly-style) {\n      background-color: var(--ids-data-grid-cell-color-background-readonly)\n    }\n\n    &.is-disabled {\n      color: var(--ids-data-grid-cell-color-text-disabled);\n    }\n  }\n\n  .ids-data-grid-body .ids-data-grid-row:first-child .ids-data-grid-cell {\n    border-top: 0;\n  }\n}\n\n// Standalone Css\ntd.ids-data-grid-cell {\n  display: table-cell;\n  padding-inline-start: var(--ids-space-sm);\n  padding-inline-end: var(--ids-space-sm);\n}\n\n// Handle RTL\n:host([dir='rtl']) {\n  .ids-data-grid.is-list-style {\n    .ids-data-grid-cell {\n      border-inline-end-width: var(--ids-border-width-none);\n    }\n  }\n\n  // Negate Borders\n  .ids-data-grid-cell {\n    &.frozen-left {\n      position: sticky;\n      right: var(--ids-space-none);\n\n      // Dynamically added widths\n      @for $i from 2 through 10 {\n        &:nth-of-type(#{$i}) {\n          right: var(--ids-data-grid-frozen-column-left-width-#{$i});\n        }\n      }\n    }\n\n    &:last-child {\n      border-inline-end-width: var(--ids-border-width-none);\n    }\n\n    &.is-dirty {\n      .ids-data-grid-tree-field-container::before,\n      &::before {\n        border-color: var(--ids-input-dirty-indicator-color-background-dirty)  var(--ids-input-dirty-indicator-color-background-dirty) transparent  transparent;\n      }\n    }\n  }\n}\n\n// Fix slotted trigger button margins when nested within cells\n.ids-trigger-field-slot-trigger-end {\n  margin-inline-end: var(--ids-space-none);\n}\n","@use '../../themes/mixins/ids-core-mixins' as *;\n\n// Includes Hidden Classes and Mixins for hiding elements at breakpoints\n.hide {\n  display: none;\n}\n\n.hide-xxl-down {\n  @media all and (max-width: $breakpoint-xxl) {\n    display: none;\n  }\n}\n\n@mixin hide-xxl-down {\n  @media all and (max-width: $breakpoint-xxl) {\n    display: none;\n  }\n}\n\n.hide-xxl-up {\n  @media all and (min-width: $breakpoint-xxl) {\n    display: none;\n  }\n}\n\n@mixin hide-xxl-up {\n  @media all and (min-width: $breakpoint-xxl) {\n    display: none;\n  }\n}\n\n.hide-xl-down {\n  @media all and (max-width: $breakpoint-xl) {\n    display: none;\n  }\n}\n\n@mixin hide-xl-down {\n  @media all and (max-width: $breakpoint-xl) {\n    display: none;\n  }\n}\n\n.hide-xl-up {\n  @media all and (min-width: $breakpoint-xl) {\n    display: none;\n  }\n}\n\n@mixin hide-xl-up {\n  @media all and (min-width: $breakpoint-xl) {\n    display: none;\n  }\n}\n\n.hide-lg-down {\n  @media all and (max-width: $breakpoint-lg) {\n    display: none;\n  }\n}\n\n@mixin hide-lg-down {\n  @media all and (max-width: $breakpoint-lg) {\n    display: none;\n  }\n}\n\n.hide-lg-up {\n  @media all and (min-width: $breakpoint-lg) {\n    display: none;\n  }\n}\n\n@mixin hide-lg-up {\n  @media all and (min-width: $breakpoint-lg) {\n    display: none;\n  }\n}\n\n.hide-md-down {\n  @media all and (max-width: $breakpoint-md) {\n    display: none;\n  }\n}\n\n@mixin hide-md-down {\n  @media all and (max-width: $breakpoint-md) {\n    display: none;\n  }\n}\n\n.hide-md-up {\n  @media all and (min-width: $breakpoint-md) {\n    display: none;\n  }\n}\n\n@mixin hide-md-up {\n  @media all and (min-width: $breakpoint-md) {\n    display: none;\n  }\n}\n\n.hide-sm-down {\n  @media all and (max-width: $breakpoint-sm) {\n    display: none;\n  }\n}\n\n@mixin hide-sm-down {\n  @media all and (max-width: $breakpoint-sm) {\n    display: none;\n  }\n}\n\n.hide-sm-up {\n  @media all and (min-width: $breakpoint-sm) {\n    display: none;\n  }\n}\n\n@mixin hide-sm-up {\n  @media all and (min-width: $breakpoint-sm) {\n    display: none;\n  }\n}\n\n.hide-xs-down {\n  @media all and (max-width: $breakpoint-xs) {\n    display: none;\n  }\n}\n\n@mixin hide-xs-down {\n  @media all and (max-width: $breakpoint-xs) {\n    display: none;\n  }\n}\n\n.hide-xs-up {\n  @media all and (min-width: $breakpoint-xs) {\n    display: none;\n  }\n}\n\n@mixin hide-xs-up {\n  @media all and (min-width: $breakpoint-xs) {\n    display: none;\n  }\n}\n\n@mixin breakpoint-xs-down {\n  @media all and (max-width: $breakpoint-xs) {\n    @content;\n  }\n}\n","@use '../../themes/mixins/ids-hide-mixin.scss' as hide;\n\n:host(.hide-sm-down) {\n  @include hide.hide-sm-down();\n}\n\n.ids-popup-menu {\n  &:not([hidden]) {\n    display: block;\n    z-index: var(--ids-z-index-60);\n  }\n}\n","/**\n * Checkbox Mixins.\n */\n@use 'sass:list';\n@use '../../themes/mixins/ids-core-mixins' as mixins;\n\n// Unchecked\n@mixin checkbox-unchecked() {\n  position: absolute;\n  border: var(--ids-checkbox-border);\n  border-radius: var(--ids-checkbox-border-radius);\n  height: 14px;\n  width: 14px;\n  left: 0;\n  top: 3px;\n}\n\n@mixin checkbox-unchecked-error {\n  border-color: var(--ids-checkbox-color-border-error);\n}\n\n// Checked\n@mixin checkbox-checked() {\n  background-color: var(--ids-checkbox-color-background-selected);\n  border-color: var(--ids-checkbox-color-border-selected);\n}\n\n@mixin checkbox-checked-after {\n  position: absolute;\n  display: block;\n  border: var(--ids-font-size-2xs) solid var(--ids-checkbox-color-border-selected-after);\n  border-width: var(--ids-checkbox-border-width-selected-after);\n  animation: check 0.15s;\n  transform: rotate(45deg);\n  content: '';\n  height: 10px;\n  left: 4px;\n  top: 0;\n  width: 4px;\n}\n\n// Indeterminate\n@mixin checkbox-indeterminate() {\n  background-color: var(--ids-checkbox-color-background-indeterminate);\n  border-color: var(--ids-checkbox-color-border-indeterminate);\n}\n\n@mixin checkbox-indeterminate-after {\n  position: absolute;\n  animation: checkindeterminate 0.15s;\n  display: block;\n  border: 1px solid var(--ids-checkbox-color-border-indeterminate-after);\n  border-width: var(--ids-checkbox-border-width-indeterminate);\n  content: '';\n  height: 6px;\n  left: 2px;\n  top: 0;\n  transform: none;\n  width: 10px;\n}\n\n// Disabled\n@mixin checkbox-disabled-unchecked {\n  background-color: var(--ids-checkbox-color-background-disabled);\n  border-color: var(--ids-checkbox-color-border-disabled);\n  cursor: var(--ids-cursor-default);\n}\n\n@mixin checkbox-disabled-unchecked-error {\n  border-color: var(--ids-checkbox-color-border-focus-error);\n}\n\n@mixin checkbox-disabled-checked() {\n  background-color: var(--ids-checkbox-color-background-selected-disabled);\n  border-color: var(--ids-checkbox-color-border-selected-disabled);\n}\n\n@mixin checkbox-disabled-text {\n  cursor: var(--ids-cursor-default);\n  color: var(--ids-checkbox-color-text-disabled);\n}\n\n// Focus\n@mixin checkbox-focus {\n  border-color: var(--ids-checkbox-color-border-focus);\n  box-shadow: var(--ids-checkbox-shadow-focus);\n}\n\n@mixin checkbox-focus-error {\n  border-color: var(--ids-checkbox-color-border-focus-error);\n  box-shadow: var(--ids-checkbox-shadow-focus-error);\n}\n\n// Colored\n$color-names: 'green' 'purple' 'blue' 'orange' 'red';\n$color-vars: --ids-color-green-70 --ids-color-purple-70 --ids-color-blue-70 --ids-color-orange-70 --ids-color-red-70;\n\n@mixin checkbox-colored() {\n  @each $name in $color-names {\n    $i: list.index($color-names, $name);\n    $color: var(#{list.nth($color-vars, $i)});\n\n    &[color='#{$name}'] input[type='checkbox'] {\n      ~ .checkmark {\n        @include checkbox-colored-box($color);\n      }\n\n      &:disabled ~ .checkmark {\n        @include checkbox-disabled-unchecked();\n      }\n\n      &:disabled:checked ~ .checkmark {\n        @include checkbox-disabled-checked();\n      }\n\n      &:focus ~ .checkmark {\n        @include checkbox-colored-box-focus($color);\n      }\n    }\n  }\n}\n\n@mixin checkbox-colored-box($color) {\n  background-color: $color;\n  border-color: $color;\n}\n\n@mixin checkbox-colored-box-focus($color) {\n  border-color: $color;\n}\n\n// Animations\n@keyframes check {\n  0% {\n    height: 0;\n    left: 0;\n    top: 8px;\n    width: 0;\n  }\n\n  50% {\n    height: 0;\n    left: 0;\n    top: 8px;\n    width: 4px;\n  }\n\n  100% {\n    height: 10px;\n    left: 4px;\n    top: 0;\n    width: 4px;\n  }\n}\n\n@keyframes checkindeterminate {\n  0% {\n    width: 0;\n  }\n\n  100% {\n    width: 10px;\n  }\n}\n","/**\n * Radio Mixins.\n */\n@use 'sass:list';\n@use '../../themes/mixins/ids-core-mixins' as mixins;\n\n// Unchecked\n@mixin radio-unchecked {\n  position: absolute;\n  border: 1px solid var(--ids-radio-color-border-default);\n  border-radius: var(--ids-radio-border-radius);\n  height: 14px;\n  left: 0;\n  top: 3px;\n  transition: border-color var(--ids-motion-duration) var(--ids-motion-ease);\n  width: 14px;\n}\n\n@mixin radio-unchecked-after {\n  position: absolute;\n  background-color: var(--ids-radio-color-background);\n  border: 1px solid var(--ids-radio-color-background);\n  border-radius: var(--ids-radio-border-radius);\n  content: '';\n  height: 0;\n  left: 6px;\n  top: 6px;\n  transition: all var(--ids-motion-duration) var(--ids-motion-ease);\n  width: 0;\n}\n\n@mixin radio-unchecked-error-circle {\n  border-color: var(--ids-color-error-default);\n}\n\n@mixin radio-unchecked-error-label-text {\n  color: var(--ids-color-error-default);\n}\n\n// Checked\n@mixin radio-checked {\n  background-color: var(--ids-radio-color-background-selected);\n  border-color: var(--ids-radio-color-border-selected);\n}\n\n@mixin radio-checked-after {\n  background-color: var(--ids-radio-inner-color-background-selected);\n  border-color: var(--ids-radio-inner-color-background-selected);\n  border-width: 2px;\n  height: 4px;\n  left: 3px;\n  top: 3px;\n  width: 4px;\n}\n\n// Disabled\n@mixin radio-disabled-unchecked {\n  border-color: var(--ids-radio-color-border-disabled);\n  cursor: var(--ids-cursor-default);\n  box-shadow: none;\n  opacity: var(--ids-radio-disabled-opacity);\n}\n\n@mixin radio-disabled-unchecked-error-circle {\n  border-color: var(--ids-radio-color-border-disabled);\n}\n\n@mixin radio-disabled-unchecked-error-label-text {\n  color: var(--ids-radio-color-border-disabled);\n}\n\n@mixin radio-disabled-checked() {\n  background-color: var(--ids-radio-color-background-selected-disabled);\n  border-color: var(--ids-radio-color-border-selected-disabled);\n  opacity: var(--ids-radio-disabled-opacity);\n}\n\n@mixin radio-disabled-text {\n  cursor: var(--ids-cursor-default);\n  color: var(--ids-radio-color-text-disabled);\n  opacity: var(--ids-radio-disabled-opacity);\n}\n\n// Focus\n@mixin radio-focus {\n  box-shadow: var(--ids-radio-shadow);\n}\n\n@mixin radio-focus-not-hide-focus {\n  box-shadow: var(--ids-radio-shadow-focus);\n}\n","// Breakpoints - this cant be tokens\n$breakpoint-xxl: 1440px;\n$breakpoint-xl: 1280px;\n$breakpoint-lg: 1024px;\n$breakpoint-md: 840px;\n$breakpoint-sm: 600px;\n$breakpoint-xs: 320px;\n\n// Sets Text Antialiasing\n@mixin antialiased {\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n// vendor prefixed transitions for regular attributes (non-vendor prefixed)\n@mixin transition($transitions-list...) {\n  @each $prefix in $prefixes {\n    #{$prefix}transition: $transitions-list;\n  }\n}\n\n// make the text invisible visually but readable by screen readers\n@mixin audible() {\n  clip: rect(0, 0, 0, 0);\n  height: 0;\n  line-height: 0;\n  min-height: 0;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n","// ================================================\n// Generates a pseudo-element in the form of an \"outline\"\n// in a cell that represents the \"inline, editable\" state.\n@mixin ids-data-grid-inline-editable-outline($margin) {\n  position: relative;\n\n  &::after {\n    border: 1px solid var(--ids-input-color-border-default);\n    border-radius: var(--ids-border-radius-2xs);\n    box-sizing: border-box;\n    display: block;\n    content: '';\n    margin: #{$margin}px;\n    height: calc(100% - #{$margin * 2}px);\n    position: absolute;\n    width: calc(100% - #{$margin * 2}px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
